"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  IdlRepository: () => IdlRepository,
  addIdlToMap: () => addIdlToMap,
  checkForIdlPatches: () => checkForIdlPatches,
  checkIdlIsAnchor: () => checkIdlIsAnchor,
  checkIdlIsAnchorV1: () => checkIdlIsAnchorV1,
  checkIdlIsShank: () => checkIdlIsShank,
  checkIdlIsString: () => checkIdlIsString,
  getLocalIdl: () => getLocalIdl,
  getMultipleProgramIdls: () => getMultipleProgramIdls,
  getProgramIdl: () => getProgramIdl
});
module.exports = __toCommonJS(src_exports);

// src/idls-patcher/patches/jupiter-v4.ts
var JupiterV4IdlPatch = {
  type: 1 /* OVERWRITE */,
  programHash: "JUP4Fb2cqiRUcaTHdrPC8h2gNsA2ETXiPDD33WcGuJB",
  patch: {
    types: [
      {
        name: "AmountWithSlippage",
        type: {
          kind: "struct",
          fields: [
            { name: "amount", type: "u64" },
            { name: "slippageBps", type: "u16" }
          ]
        }
      },
      {
        name: "SplitLegDeeper",
        type: {
          kind: "struct",
          fields: [
            { name: "percent", type: "u8" },
            { name: "swapLeg", type: { defined: "SwapLegSwap" } }
          ]
        }
      },
      {
        name: "SplitLeg",
        type: {
          kind: "struct",
          fields: [
            { name: "percent", type: "u8" },
            { name: "swapLeg", type: { defined: "SwapLegDeeper" } }
          ]
        }
      },
      {
        name: "SwapInstrution",
        type: {
          kind: "enum",
          variants: [{ name: "Swap", fields: [{ defined: "Swap" }] }]
        }
      },
      {
        name: "Side",
        type: {
          kind: "enum",
          variants: [{ name: "Bid" }, { name: "Ask" }]
        }
      },
      {
        name: "SwapLegSwap",
        type: {
          kind: "enum",
          variants: [
            { name: "PlaceholderOne" },
            { name: "PlaceholderTwo" },
            {
              name: "Swap",
              fields: [{ name: "swap", type: { defined: "Swap" } }]
            }
          ]
        }
      },
      {
        name: "SwapLegDeeper",
        type: {
          kind: "enum",
          variants: [
            {
              name: "Chain",
              fields: [
                {
                  name: "swap_legs",
                  type: { vec: { defined: "SwapLegSwap" } }
                }
              ]
            },
            {
              name: "Split",
              fields: [
                {
                  name: "split_legs",
                  type: { vec: { defined: "SplitLegDeeper" } }
                }
              ]
            },
            {
              name: "Swap",
              fields: [{ name: "swap", type: { defined: "Swap" } }]
            }
          ]
        }
      },
      {
        name: "SwapLeg",
        type: {
          kind: "enum",
          variants: [
            {
              name: "Chain",
              fields: [
                {
                  name: "swap_legs",
                  type: { vec: { defined: "SwapLegDeeper" } }
                }
              ]
            },
            {
              name: "Split",
              fields: [
                {
                  name: "split_legs",
                  type: { vec: { defined: "SplitLeg" } }
                }
              ]
            },
            {
              name: "Swap",
              fields: [{ name: "swap", type: { defined: "Swap" } }]
            }
          ]
        }
      },
      {
        name: "Swap",
        type: {
          kind: "enum",
          variants: [
            { name: "Saber" },
            { name: "SaberAddDecimalsDeposit" },
            { name: "SaberAddDecimalsWithdraw" },
            { name: "TokenSwap" },
            { name: "Sencha" },
            { name: "Step" },
            { name: "Cropper" },
            { name: "Raydium" },
            { name: "Crema", fields: [{ name: "a_to_b", type: "bool" }] },
            { name: "Lifinity" },
            { name: "Mercurial" },
            { name: "Cykura" },
            {
              name: "Serum",
              fields: [{ name: "side", type: { defined: "Side" } }]
            },
            { name: "MarinadeDeposit" },
            { name: "MarinadeUnstake" },
            {
              name: "Aldrin",
              fields: [{ name: "side", type: { defined: "Side" } }]
            },
            {
              name: "AldrinV2",
              fields: [{ name: "side", type: { defined: "Side" } }]
            },
            {
              name: "Whirlpool",
              fields: [{ name: "a_to_b", type: "bool" }]
            },
            {
              name: "Invariant",
              fields: [{ name: "x_to_y", type: "bool" }]
            },
            { name: "Meteora" },
            { name: "GooseFX" },
            {
              name: "DeltaFi",
              fields: [{ name: "stable", type: "bool" }]
            },
            { name: "Balansol" },
            {
              name: "MarcoPolo",
              fields: [{ name: "x_to_y", type: "bool" }]
            },
            {
              name: "Dradex",
              fields: [{ name: "side", type: { defined: "Side" } }]
            },
            { name: "LifinityV2" },
            { name: "RaydiumClmm" },
            {
              name: "Openbook",
              fields: [{ name: "side", type: { defined: "Side" } }]
            },
            {
              name: "Phoenix",
              fields: [{ name: "side", type: { defined: "Side" } }]
            }
          ]
        }
      },
      {
        name: "SwapAction",
        type: {
          kind: "enum",
          variants: [
            {
              name: "SetupSplit",
              fields: [{ name: "percents", type: "bytes" }]
            },
            { name: "NextSplitLeg" },
            { name: "MergeSplit" },
            {
              name: "Swap",
              fields: [{ name: "swap", type: { defined: "Swap" } }]
            }
          ]
        }
      }
    ]
  },
  slots: [178870133, 179194518]
};

// src/idls-patcher/patches/magiceden-v2.ts
var MagicEdenV2IdlPatch = {
  type: 0 /* APPEND */,
  programHash: "M2mx93ekt1fmXSVkTrUL9xVFHkmME8HTUi5Cyc5aF7K",
  patch: {
    instructions: [
      {
        name: "executeSale",
        accounts: [
          {
            name: "buyer",
            isMut: true,
            isSigner: false
          },
          {
            name: "seller",
            isMut: true,
            isSigner: false
          },
          {
            name: "notary",
            isMut: false,
            isSigner: false
          },
          {
            name: "tokenAccount",
            isMut: true,
            isSigner: false
          },
          {
            name: "tokenMint",
            isMut: false,
            isSigner: false
          },
          {
            name: "metadata",
            isMut: false,
            isSigner: false
          },
          {
            name: "escrowPaymentAccount",
            isMut: true,
            isSigner: false
          },
          {
            name: "buyerReceiptTokenAccount",
            isMut: true,
            isSigner: false
          },
          {
            name: "authority",
            isMut: false,
            isSigner: false
          },
          {
            name: "auctionHouse",
            isMut: false,
            isSigner: false
          },
          {
            name: "auctionHouseTreasury",
            isMut: true,
            isSigner: false
          },
          {
            name: "buyerTradeState",
            isMut: true,
            isSigner: false
          },
          {
            name: "buyerReferral",
            isMut: true,
            isSigner: false
          },
          {
            name: "sellerTradeState",
            isMut: true,
            isSigner: false
          },
          {
            name: "sellerReferral",
            isMut: true,
            isSigner: false
          },
          {
            name: "tokenProgram",
            isMut: false,
            isSigner: false
          },
          {
            name: "systemProgram",
            isMut: false,
            isSigner: false
          },
          {
            name: "ataProgram",
            isMut: false,
            isSigner: false
          },
          {
            name: "programAsSigner",
            isMut: false,
            isSigner: false
          },
          {
            name: "rent",
            isMut: false,
            isSigner: false
          }
        ],
        args: [
          {
            name: "escrowPaymentBump",
            type: "u8"
          },
          {
            name: "programAsSignerBump",
            type: "u8"
          },
          {
            name: "buyerPrice",
            type: "u64"
          },
          {
            name: "tokenSize",
            type: "u64"
          },
          {
            name: "buyerStateExpiry",
            type: "i64"
          },
          {
            name: "sellerStateExpiry",
            type: "i64"
          }
        ]
      }
    ]
  }
};

// src/idls-patcher/patcher.ts
var checkForIdlPatches = (idlMetaResponse) => {
  let patchedIdlMetaResponse = Object.assign({}, idlMetaResponse);
  if (patchedIdlMetaResponse.idlInformation) {
    if (patchedIdlMetaResponse.idlInformation.idl) {
      switch (idlMetaResponse.programHash) {
        case "M2mx93ekt1fmXSVkTrUL9xVFHkmME8HTUi5Cyc5aF7K":
          patchedIdlMetaResponse.idlInformation.idl = patchIdlByAppending(
            MagicEdenV2IdlPatch,
            patchedIdlMetaResponse?.idlInformation?.idl
          );
          break;
        case "JUP4Fb2cqiRUcaTHdrPC8h2gNsA2ETXiPDD33WcGuJB":
          patchedIdlMetaResponse.idlInformation.idl = patchIdlByOverwriting(
            JupiterV4IdlPatch,
            patchedIdlMetaResponse?.idlInformation.slotDeployed,
            patchedIdlMetaResponse?.idlInformation?.idl
          );
          break;
        default:
          break;
      }
    }
  }
  return patchedIdlMetaResponse;
};
var patchIdlByAppending = (patch, idl) => {
  if (idl) {
    if (!checkIdlIsString(idl)) {
      if (patch.type === 0 /* APPEND */) {
        const idlToReturn = Object.assign({}, idl);
        const keysToAppend = Object.keys(patch.patch);
        keysToAppend.forEach((key) => {
          if (key in idlToReturn) {
            if (Array.isArray(idlToReturn[key])) {
              idlToReturn[key] = idlToReturn[key].concat(
                patch.patch[key]
              );
            }
          }
        });
        return idlToReturn;
      }
    }
  }
  return idl;
};
var patchIdlByOverwriting = (patch, idlSlotDeployed, idl) => {
  if (idl) {
    if (!checkIdlIsString(idl)) {
      if (patch.slots) {
        if (idlSlotDeployed) {
          if (!patch.slots.includes(idlSlotDeployed)) {
            return idl;
          }
        }
      }
      if (patch.type === 1 /* OVERWRITE */) {
        const idlToReturn = Object.assign({}, idl);
        const keysToOverwrite = Object.keys(patch.patch);
        keysToOverwrite.forEach((key) => {
          idlToReturn[key] = patch.patch[key];
        });
        return idlToReturn;
      }
    }
  }
  return idl;
};

// src/instances/ProgramIDL.ts
var import_axios = __toESM(require("axios"));
var API_URL = "https://api.solana.fm/v0/";
var createProgramIdlInstance = (options = {
  baseUrl: API_URL
}) => {
  const programIdlInstance = import_axios.default.create({
    baseURL: options?.baseUrl ?? API_URL,
    headers: {
      ApiKey: options.apiKey
    }
  });
  return programIdlInstance;
};

// src/idls/kinobi/memo.ts
var MemoKinobiTree = '{"kind":"rootNode","programs":[{"kind":"programNode","accounts":[],"instructions":[{"kind":"instructionNode","name":"createMemo","accounts":[{"kind":"instructionAccountNode","name":"signers","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"createMemoInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"memo","child":{"kind":"stringTypeNode","encoding":"utf8","size":{"kind":"remainder"}},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"createMemoInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"CreateMemo","docs":[],"internal":false,"argDefaults":{}}],"definedTypes":[],"errors":[],"name":"memo","prefix":"","publicKey":"MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr","version":"0.0.0","origin":"shank","internal":false}]}';

// src/idls/kinobi/phoenix.ts
var PhoenixKinobiTree = `{"kind":"rootNode","programs":[{"kind":"programNode","accounts":[{"kind":"accountNode","name":"seat","data":{"kind":"accountDataNode","name":"seatAccountData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"arrayTypeNode","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"size":{"kind":"fixed","value":8}},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"list","values":[{"kind":"number","value":136},{"kind":"number","value":183},{"kind":"number","value":66},{"kind":"number","value":31},{"kind":"number","value":71},{"kind":"number","value":173},{"kind":"number","value":202},{"kind":"number","value":27}]}}},{"kind":"structFieldTypeNode","name":"market","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"trader","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"approvalStatus","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"padding","child":{"kind":"arrayTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"size":{"kind":"fixed","value":6}},"docs":[],"defaultsTo":null}]}},"idlName":"Seat","docs":[],"internal":false,"size":128,"seeds":[],"discriminator":{"kind":"field","name":"discriminator"}},{"kind":"accountNode","name":"marketHeader","data":{"kind":"accountDataNode","name":"marketHeaderAccountData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"arrayTypeNode","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"size":{"kind":"fixed","value":8}},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"list","values":[{"kind":"number","value":119},{"kind":"number","value":223},{"kind":"number","value":113},{"kind":"number","value":115},{"kind":"number","value":183},{"kind":"number","value":32},{"kind":"number","value":88},{"kind":"number","value":113}]}}},{"kind":"structFieldTypeNode","name":"status","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"marketSizeParams","child":{"kind":"linkTypeNode","name":"marketSizeParams","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseParams","child":{"kind":"linkTypeNode","name":"tokenParams","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotSize","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"quoteParams","child":{"kind":"linkTypeNode","name":"tokenParams","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"quoteLotSize","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"tickSizeInQuoteAtomsPerBaseUnit","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"authority","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"feeRecipient","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"marketSequenceNumber","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"successor","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"rawBaseUnitsPerBaseUnit","child":{"kind":"numberTypeNode","format":"u32","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"padding1","child":{"kind":"numberTypeNode","format":"u32","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"padding2","child":{"kind":"arrayTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"size":{"kind":"fixed","value":32}},"docs":[],"defaultsTo":null}]}},"idlName":"MarketHeader","docs":[],"internal":false,"size":576,"seeds":[],"discriminator":{"kind":"field","name":"discriminator"}}],"instructions":[{"kind":"instructionNode","name":"swap","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader base token account"]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader quote token account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"swapInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":0}}},{"kind":"structFieldTypeNode","name":"orderPacket","child":{"kind":"linkTypeNode","name":"orderPacket","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"swapInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"Swap","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"swapWithFreeFunds","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"seat","isWritable":false,"isSigner":false,"isOptional":false,"docs":[]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"swapWithFreeFundsInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":1}}},{"kind":"structFieldTypeNode","name":"orderPacket","child":{"kind":"linkTypeNode","name":"orderPacket","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"swapWithFreeFundsInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"SwapWithFreeFunds","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"placeLimitOrder","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"seat","isWritable":false,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader base token account"]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader quote token account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"placeLimitOrderInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":2}}},{"kind":"structFieldTypeNode","name":"orderPacket","child":{"kind":"linkTypeNode","name":"orderPacket","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"placeLimitOrderInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"PlaceLimitOrder","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"placeLimitOrderWithFreeFunds","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"seat","isWritable":false,"isSigner":false,"isOptional":false,"docs":[]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"placeLimitOrderWithFreeFundsInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":3}}},{"kind":"structFieldTypeNode","name":"orderPacket","child":{"kind":"linkTypeNode","name":"orderPacket","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"placeLimitOrderWithFreeFundsInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"PlaceLimitOrderWithFreeFunds","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"reduceOrder","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader base token account"]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader quote token account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"reduceOrderInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":4}}},{"kind":"structFieldTypeNode","name":"params","child":{"kind":"linkTypeNode","name":"reduceOrderParams","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"reduceOrderInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"ReduceOrder","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"reduceOrderWithFreeFunds","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":true,"isSigner":true,"isOptional":false,"docs":[]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"reduceOrderWithFreeFundsInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":5}}},{"kind":"structFieldTypeNode","name":"params","child":{"kind":"linkTypeNode","name":"reduceOrderParams","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"reduceOrderWithFreeFundsInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"ReduceOrderWithFreeFunds","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"cancelAllOrders","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader base token account"]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader quote token account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"cancelAllOrdersInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":6}}}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"cancelAllOrdersInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"CancelAllOrders","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"cancelAllOrdersWithFreeFunds","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"cancelAllOrdersWithFreeFundsInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":7}}}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"cancelAllOrdersWithFreeFundsInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"CancelAllOrdersWithFreeFunds","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"cancelUpTo","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader base token account"]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader quote token account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"cancelUpToInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":8}}},{"kind":"structFieldTypeNode","name":"params","child":{"kind":"linkTypeNode","name":"cancelUpToParams","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"cancelUpToInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"CancelUpTo","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"cancelUpToWithFreeFunds","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"cancelUpToWithFreeFundsInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":9}}},{"kind":"structFieldTypeNode","name":"params","child":{"kind":"linkTypeNode","name":"cancelUpToParams","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"cancelUpToWithFreeFundsInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"CancelUpToWithFreeFunds","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"cancelMultipleOrdersById","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader base token account"]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader quote token account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"cancelMultipleOrdersByIdInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":10}}},{"kind":"structFieldTypeNode","name":"params","child":{"kind":"linkTypeNode","name":"cancelMultipleOrdersByIdParams","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"cancelMultipleOrdersByIdInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"CancelMultipleOrdersById","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"cancelMultipleOrdersByIdWithFreeFunds","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"cancelMultipleOrdersByIdWithFreeFundsInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":11}}},{"kind":"structFieldTypeNode","name":"params","child":{"kind":"linkTypeNode","name":"cancelMultipleOrdersByIdParams","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"cancelMultipleOrdersByIdWithFreeFundsInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"CancelMultipleOrdersByIdWithFreeFunds","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"withdrawFunds","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader base token account"]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader quote token account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"withdrawFundsInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":12}}},{"kind":"structFieldTypeNode","name":"quoteLotsToWithdraw","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotsToWithdraw","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"withdrawFundsInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"WithdrawFunds","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"depositFunds","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"seat","isWritable":false,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader base token account"]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader quote token account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"depositFundsInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":13}}},{"kind":"structFieldTypeNode","name":"quoteLotsToDeposit","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotsToDeposit","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"depositFundsInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"DepositFunds","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"requestSeat","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"payer","isWritable":true,"isSigner":true,"isOptional":false,"docs":[],"defaultsTo":{"kind":"payer","account":{},"ignoreIfOptional":true}},{"kind":"instructionAccountNode","name":"seat","isWritable":true,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"systemProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["System program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splSystem","publicKey":"11111111111111111111111111111111"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"requestSeatInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":14}}}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"requestSeatInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"RequestSeat","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"log","accounts":[{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":true,"isOptional":false,"docs":["Log authority"]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"logInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":15}}}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"logInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"Log","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"placeMultiplePostOnlyOrders","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"seat","isWritable":false,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader base token account"]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader quote token account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"placeMultiplePostOnlyOrdersInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":16}}},{"kind":"structFieldTypeNode","name":"multipleOrderPacket","child":{"kind":"linkTypeNode","name":"multipleOrderPacket","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"placeMultiplePostOnlyOrdersInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"PlaceMultiplePostOnlyOrders","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"placeMultiplePostOnlyOrdersWithFreeFunds","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":true,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"seat","isWritable":false,"isSigner":false,"isOptional":false,"docs":[]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"placeMultiplePostOnlyOrdersWithFreeFundsInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":17}}},{"kind":"structFieldTypeNode","name":"multipleOrderPacket","child":{"kind":"linkTypeNode","name":"multipleOrderPacket","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"placeMultiplePostOnlyOrdersWithFreeFundsInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"PlaceMultiplePostOnlyOrdersWithFreeFunds","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"initializeMarket","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"marketCreator","isWritable":true,"isSigner":true,"isOptional":false,"docs":["The market_creator account must sign for the creation of new vaults"]},{"kind":"instructionAccountNode","name":"baseMint","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Base mint account"]},{"kind":"instructionAccountNode","name":"quoteMint","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Quote mint account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"systemProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["System program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splSystem","publicKey":"11111111111111111111111111111111"},"ignoreIfOptional":true}},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"initializeMarketInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":100}}},{"kind":"structFieldTypeNode","name":"marketSizeParams","child":{"kind":"linkTypeNode","name":"marketSizeParams","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"numQuoteLotsPerQuoteUnit","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"tickSizeInQuoteLotsPerBaseUnit","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"numBaseLotsPerBaseUnit","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"takerFeeBps","child":{"kind":"numberTypeNode","format":"u16","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"feeCollector","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"rawBaseUnitsPerBaseUnit","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u32","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"initializeMarketInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"InitializeMarket","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"claimAuthority","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"successor","isWritable":false,"isSigner":true,"isOptional":false,"docs":["The successor account must sign to claim authority"]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"claimAuthorityInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":101}}}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"claimAuthorityInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"ClaimAuthority","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"nameSuccessor","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"marketAuthority","isWritable":false,"isSigner":true,"isOptional":false,"docs":["The market_authority account must sign to name successor"]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"nameSuccessorInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":102}}},{"kind":"structFieldTypeNode","name":"successor","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"nameSuccessorInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"NameSuccessor","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"changeMarketStatus","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"marketAuthority","isWritable":false,"isSigner":true,"isOptional":false,"docs":["The market_authority account must sign to change market status"]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"changeMarketStatusInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":103}}},{"kind":"structFieldTypeNode","name":"marketStatus","child":{"kind":"linkTypeNode","name":"marketStatus","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"changeMarketStatusInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"ChangeMarketStatus","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"changeSeatStatus","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"marketAuthority","isWritable":false,"isSigner":true,"isOptional":false,"docs":["The market_authority account must sign to change seat status"]},{"kind":"instructionAccountNode","name":"seat","isWritable":true,"isSigner":false,"isOptional":false,"docs":[]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"changeSeatStatusInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":104}}},{"kind":"structFieldTypeNode","name":"approvalStatus","child":{"kind":"linkTypeNode","name":"seatApprovalStatus","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"changeSeatStatusInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"ChangeSeatStatus","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"requestSeatAuthorized","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"marketAuthority","isWritable":false,"isSigner":true,"isOptional":false,"docs":["The market_authority account must sign to request a seat on behalf of a trader"]},{"kind":"instructionAccountNode","name":"payer","isWritable":true,"isSigner":true,"isOptional":false,"docs":[],"defaultsTo":{"kind":"payer","account":{},"ignoreIfOptional":true}},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"seat","isWritable":true,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"systemProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["System program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splSystem","publicKey":"11111111111111111111111111111111"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"requestSeatAuthorizedInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":105}}}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"requestSeatAuthorizedInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"RequestSeatAuthorized","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"evictSeat","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"marketAuthority","isWritable":false,"isSigner":true,"isOptional":false,"docs":["The market_authority account must sign to evict a seat"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"seat","isWritable":false,"isSigner":false,"isOptional":false,"docs":["The trader's PDA seat account, seeds are [b'seat', market_address, trader_address]"]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"evictSeatInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":106}}}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"evictSeatInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"EvictSeat","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"forceCancelOrders","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"marketAuthority","isWritable":false,"isSigner":true,"isOptional":false,"docs":["The market_authority account must sign to claim authority"]},{"kind":"instructionAccountNode","name":"trader","isWritable":false,"isSigner":false,"isOptional":false,"docs":[]},{"kind":"instructionAccountNode","name":"seat","isWritable":false,"isSigner":false,"isOptional":false,"docs":["The trader's PDA seat account, seeds are [b'seat', market_address, trader_address]"]},{"kind":"instructionAccountNode","name":"baseAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader base token account"]},{"kind":"instructionAccountNode","name":"quoteAccount","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Trader quote token account"]},{"kind":"instructionAccountNode","name":"baseVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Base vault PDA, seeds are [b'vault', market_address, base_mint_address]"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"forceCancelOrdersInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":107}}},{"kind":"structFieldTypeNode","name":"params","child":{"kind":"linkTypeNode","name":"cancelUpToParams","importFrom":"generated"},"docs":[],"defaultsTo":null}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"forceCancelOrdersInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"ForceCancelOrders","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"collectFees","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"sweeper","isWritable":false,"isSigner":true,"isOptional":false,"docs":["Signer of collect fees instruction"]},{"kind":"instructionAccountNode","name":"feeRecipient","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Fee collector quote token account"]},{"kind":"instructionAccountNode","name":"quoteVault","isWritable":true,"isSigner":false,"isOptional":false,"docs":["Quote vault PDA, seeds are [b'vault', market_address, quote_mint_address]"]},{"kind":"instructionAccountNode","name":"tokenProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Token program"],"defaultsTo":{"kind":"program","account":{},"program":{"name":"splToken","publicKey":"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"},"ignoreIfOptional":true}}],"dataArgs":{"kind":"instructionDataArgsNode","name":"collectFeesInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":108}}}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"collectFeesInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"CollectFees","docs":[],"internal":false,"argDefaults":{}},{"kind":"instructionNode","name":"changeFeeRecipient","accounts":[{"kind":"instructionAccountNode","name":"phoenixProgram","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix program"]},{"kind":"instructionAccountNode","name":"logAuthority","isWritable":false,"isSigner":false,"isOptional":false,"docs":["Phoenix log authority"]},{"kind":"instructionAccountNode","name":"market","isWritable":true,"isSigner":false,"isOptional":false,"docs":["This account holds the market state"]},{"kind":"instructionAccountNode","name":"marketAuthority","isWritable":false,"isSigner":true,"isOptional":false,"docs":["The market_authority account must sign to change the free recipient"]},{"kind":"instructionAccountNode","name":"newFeeRecipient","isWritable":false,"isSigner":false,"isOptional":false,"docs":["New fee recipient"]}],"dataArgs":{"kind":"instructionDataArgsNode","name":"changeFeeRecipientInstructionData","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminator","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":{"strategy":"omitted","value":{"kind":"number","value":109}}}]}},"extraArgs":{"kind":"instructionExtraArgsNode","name":"changeFeeRecipientInstructionExtra","struct":{"kind":"structTypeNode","fields":[]}},"subInstructions":[],"idlName":"ChangeFeeRecipient","docs":[],"internal":false,"argDefaults":{}}],"definedTypes":[{"kind":"definedTypeNode","name":"marketSizeParams","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"bidsSize","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"asksSize","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"numSeats","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"MarketSizeParams","docs":[],"internal":false},{"kind":"definedTypeNode","name":"tokenParams","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"decimals","child":{"kind":"numberTypeNode","format":"u32","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"vaultBump","child":{"kind":"numberTypeNode","format":"u32","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"mintKey","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"vaultKey","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null}]},"idlName":"TokenParams","docs":[],"internal":false},{"kind":"definedTypeNode","name":"seat","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminant","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"market","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"trader","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"approvalStatus","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"padding","child":{"kind":"arrayTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"size":{"kind":"fixed","value":6}},"docs":[],"defaultsTo":null}]},"idlName":"Seat","docs":[],"internal":false},{"kind":"definedTypeNode","name":"auditLogHeader","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"instruction","child":{"kind":"numberTypeNode","format":"u8","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"sequenceNumber","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"timestamp","child":{"kind":"numberTypeNode","format":"i64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"slot","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"market","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"signer","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"totalEvents","child":{"kind":"numberTypeNode","format":"u16","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"AuditLogHeader","docs":[],"internal":false},{"kind":"definedTypeNode","name":"fillEvent","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"index","child":{"kind":"numberTypeNode","format":"u16","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"makerId","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"orderSequenceNumber","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"priceInTicks","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotsFilled","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotsRemaining","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"FillEvent","docs":[],"internal":false},{"kind":"definedTypeNode","name":"reduceEvent","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"index","child":{"kind":"numberTypeNode","format":"u16","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"orderSequenceNumber","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"priceInTicks","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotsRemoved","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotsRemaining","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"ReduceEvent","docs":[],"internal":false},{"kind":"definedTypeNode","name":"placeEvent","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"index","child":{"kind":"numberTypeNode","format":"u16","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"orderSequenceNumber","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"clientOrderId","child":{"kind":"numberTypeNode","format":"u128","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"priceInTicks","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotsPlaced","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"PlaceEvent","docs":[],"internal":false},{"kind":"definedTypeNode","name":"evictEvent","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"index","child":{"kind":"numberTypeNode","format":"u16","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"makerId","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"orderSequenceNumber","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"priceInTicks","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotsEvicted","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"EvictEvent","docs":[],"internal":false},{"kind":"definedTypeNode","name":"fillSummaryEvent","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"index","child":{"kind":"numberTypeNode","format":"u16","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"clientOrderId","child":{"kind":"numberTypeNode","format":"u128","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"totalBaseLotsFilled","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"totalQuoteLotsFilled","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"totalFeeInQuoteLots","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"FillSummaryEvent","docs":[],"internal":false},{"kind":"definedTypeNode","name":"feeEvent","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"index","child":{"kind":"numberTypeNode","format":"u16","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"feesCollectedInQuoteLots","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"FeeEvent","docs":[],"internal":false},{"kind":"definedTypeNode","name":"timeInForceEvent","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"index","child":{"kind":"numberTypeNode","format":"u16","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"orderSequenceNumber","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"lastValidSlot","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"lastValidUnixTimestampInSeconds","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"TimeInForceEvent","docs":[],"internal":false},{"kind":"definedTypeNode","name":"expiredOrderEvent","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"index","child":{"kind":"numberTypeNode","format":"u16","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"makerId","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"orderSequenceNumber","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"priceInTicks","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotsRemoved","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"ExpiredOrderEvent","docs":[],"internal":false},{"kind":"definedTypeNode","name":"cancelUpToParams","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"side","child":{"kind":"linkTypeNode","name":"side","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"tickLimit","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"numOrdersToSearch","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u32","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"numOrdersToCancel","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u32","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null}]},"idlName":"CancelUpToParams","docs":[],"internal":false},{"kind":"definedTypeNode","name":"cancelMultipleOrdersByIdParams","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"orders","child":{"kind":"arrayTypeNode","child":{"kind":"linkTypeNode","name":"cancelOrderParams","importFrom":"generated"},"size":{"kind":"prefixed","prefix":{"kind":"numberTypeNode","format":"u32","endian":"le"}}},"docs":[],"defaultsTo":null}]},"idlName":"CancelMultipleOrdersByIdParams","docs":[],"internal":false},{"kind":"definedTypeNode","name":"multipleOrderPacket","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"bids","child":{"kind":"arrayTypeNode","child":{"kind":"linkTypeNode","name":"condensedOrder","importFrom":"generated"},"size":{"kind":"prefixed","prefix":{"kind":"numberTypeNode","format":"u32","endian":"le"}}},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"asks","child":{"kind":"arrayTypeNode","child":{"kind":"linkTypeNode","name":"condensedOrder","importFrom":"generated"},"size":{"kind":"prefixed","prefix":{"kind":"numberTypeNode","format":"u32","endian":"le"}}},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"clientOrderId","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u128","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"rejectPostOnly","child":{"kind":"boolTypeNode","size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"docs":[],"defaultsTo":null}]},"idlName":"MultipleOrderPacket","docs":[],"internal":false},{"kind":"definedTypeNode","name":"condensedOrder","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"priceInTicks","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"sizeInBaseLots","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"lastValidSlot","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"lastValidUnixTimestampInSeconds","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null}]},"idlName":"CondensedOrder","docs":[],"internal":false},{"kind":"definedTypeNode","name":"cancelOrderParams","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"side","child":{"kind":"linkTypeNode","name":"side","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"priceInTicks","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"orderSequenceNumber","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"CancelOrderParams","docs":[],"internal":false},{"kind":"definedTypeNode","name":"reduceOrderParams","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"baseParams","child":{"kind":"linkTypeNode","name":"cancelOrderParams","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"size","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null}]},"idlName":"ReduceOrderParams","docs":[],"internal":false},{"kind":"definedTypeNode","name":"marketHeader","data":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"discriminant","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"status","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"marketSizeParams","child":{"kind":"linkTypeNode","name":"marketSizeParams","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseParams","child":{"kind":"linkTypeNode","name":"tokenParams","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"baseLotSize","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"quoteParams","child":{"kind":"linkTypeNode","name":"tokenParams","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"quoteLotSize","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"tickSizeInQuoteAtomsPerBaseUnit","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"authority","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"feeRecipient","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"marketSequenceNumber","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"successor","child":{"kind":"publicKeyTypeNode"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"rawBaseUnitsPerBaseUnit","child":{"kind":"numberTypeNode","format":"u32","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"padding1","child":{"kind":"numberTypeNode","format":"u32","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"padding2","child":{"kind":"arrayTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"size":{"kind":"fixed","value":32}},"docs":[],"defaultsTo":null}]},"idlName":"MarketHeader","docs":[],"internal":false},{"kind":"definedTypeNode","name":"phoenixMarketEvent","data":{"kind":"enumTypeNode","variants":[{"kind":"enumEmptyVariantTypeNode","name":"uninitialized"},{"kind":"enumTupleVariantTypeNode","name":"header","tuple":{"kind":"tupleTypeNode","children":[{"kind":"linkTypeNode","name":"auditLogHeader","importFrom":"generated"}]}},{"kind":"enumTupleVariantTypeNode","name":"fill","tuple":{"kind":"tupleTypeNode","children":[{"kind":"linkTypeNode","name":"fillEvent","importFrom":"generated"}]}},{"kind":"enumTupleVariantTypeNode","name":"place","tuple":{"kind":"tupleTypeNode","children":[{"kind":"linkTypeNode","name":"placeEvent","importFrom":"generated"}]}},{"kind":"enumTupleVariantTypeNode","name":"reduce","tuple":{"kind":"tupleTypeNode","children":[{"kind":"linkTypeNode","name":"reduceEvent","importFrom":"generated"}]}},{"kind":"enumTupleVariantTypeNode","name":"evict","tuple":{"kind":"tupleTypeNode","children":[{"kind":"linkTypeNode","name":"evictEvent","importFrom":"generated"}]}},{"kind":"enumTupleVariantTypeNode","name":"fillSummary","tuple":{"kind":"tupleTypeNode","children":[{"kind":"linkTypeNode","name":"fillSummaryEvent","importFrom":"generated"}]}},{"kind":"enumTupleVariantTypeNode","name":"fee","tuple":{"kind":"tupleTypeNode","children":[{"kind":"linkTypeNode","name":"feeEvent","importFrom":"generated"}]}},{"kind":"enumTupleVariantTypeNode","name":"timeInForce","tuple":{"kind":"tupleTypeNode","children":[{"kind":"linkTypeNode","name":"timeInForceEvent","importFrom":"generated"}]}},{"kind":"enumTupleVariantTypeNode","name":"expiredOrder","tuple":{"kind":"tupleTypeNode","children":[{"kind":"linkTypeNode","name":"expiredOrderEvent","importFrom":"generated"}]}}],"size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"idlName":"PhoenixMarketEvent","docs":[],"internal":false},{"kind":"definedTypeNode","name":"marketStatus","data":{"kind":"enumTypeNode","variants":[{"kind":"enumEmptyVariantTypeNode","name":"uninitialized"},{"kind":"enumEmptyVariantTypeNode","name":"active"},{"kind":"enumEmptyVariantTypeNode","name":"postOnly"},{"kind":"enumEmptyVariantTypeNode","name":"paused"},{"kind":"enumEmptyVariantTypeNode","name":"closed"},{"kind":"enumEmptyVariantTypeNode","name":"tombstoned"}],"size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"idlName":"MarketStatus","docs":[],"internal":false},{"kind":"definedTypeNode","name":"seatApprovalStatus","data":{"kind":"enumTypeNode","variants":[{"kind":"enumEmptyVariantTypeNode","name":"notApproved"},{"kind":"enumEmptyVariantTypeNode","name":"approved"},{"kind":"enumEmptyVariantTypeNode","name":"retired"}],"size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"idlName":"SeatApprovalStatus","docs":[],"internal":false},{"kind":"definedTypeNode","name":"orderPacket","data":{"kind":"enumTypeNode","variants":[{"kind":"enumStructVariantTypeNode","name":"postOnly","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"side","child":{"kind":"linkTypeNode","name":"side","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"priceInTicks","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"numBaseLots","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"clientOrderId","child":{"kind":"numberTypeNode","format":"u128","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"rejectPostOnly","child":{"kind":"boolTypeNode","size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"useOnlyDepositedFunds","child":{"kind":"boolTypeNode","size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"lastValidSlot","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"lastValidUnixTimestampInSeconds","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null}]}},{"kind":"enumStructVariantTypeNode","name":"limit","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"side","child":{"kind":"linkTypeNode","name":"side","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"priceInTicks","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"numBaseLots","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"selfTradeBehavior","child":{"kind":"linkTypeNode","name":"selfTradeBehavior","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"matchLimit","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"clientOrderId","child":{"kind":"numberTypeNode","format":"u128","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"useOnlyDepositedFunds","child":{"kind":"boolTypeNode","size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"lastValidSlot","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"lastValidUnixTimestampInSeconds","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null}]}},{"kind":"enumStructVariantTypeNode","name":"immediateOrCancel","struct":{"kind":"structTypeNode","fields":[{"kind":"structFieldTypeNode","name":"side","child":{"kind":"linkTypeNode","name":"side","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"priceInTicks","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"numBaseLots","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"numQuoteLots","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"minBaseLotsToFill","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"minQuoteLotsToFill","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"selfTradeBehavior","child":{"kind":"linkTypeNode","name":"selfTradeBehavior","importFrom":"generated"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"matchLimit","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"clientOrderId","child":{"kind":"numberTypeNode","format":"u128","endian":"le"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"useOnlyDepositedFunds","child":{"kind":"boolTypeNode","size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"lastValidSlot","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null},{"kind":"structFieldTypeNode","name":"lastValidUnixTimestampInSeconds","child":{"kind":"optionTypeNode","child":{"kind":"numberTypeNode","format":"u64","endian":"le"},"prefix":{"kind":"numberTypeNode","format":"u8","endian":"le"},"fixed":false,"idlOption":"option"},"docs":[],"defaultsTo":null}]}}],"size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"idlName":"OrderPacket","docs":[],"internal":false},{"kind":"definedTypeNode","name":"side","data":{"kind":"enumTypeNode","variants":[{"kind":"enumEmptyVariantTypeNode","name":"bid"},{"kind":"enumEmptyVariantTypeNode","name":"ask"}],"size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"idlName":"Side","docs":[],"internal":false},{"kind":"definedTypeNode","name":"selfTradeBehavior","data":{"kind":"enumTypeNode","variants":[{"kind":"enumEmptyVariantTypeNode","name":"abort"},{"kind":"enumEmptyVariantTypeNode","name":"cancelProvide"},{"kind":"enumEmptyVariantTypeNode","name":"decrementTake"}],"size":{"kind":"numberTypeNode","format":"u8","endian":"le"}},"idlName":"SelfTradeBehavior","docs":[],"internal":false}],"errors":[],"name":"phoenixV1","prefix":"","publicKey":"PhoeNiXZ8ByJGLkxNfZRnkUfjvmuYqLR89jjFHGqdXY","version":"0.2.3","origin":"shank","internal":false}]}`;

// src/idls/shank/native/compute-budget-idls/compute-budget.ts
var ComputeBudgetIDL = {
  version: "0.0.1",
  name: "ComputeBudget",
  instructions: [
    {
      name: "RequestUnitsDeprecated",
      accounts: [],
      args: [
        {
          name: "units",
          type: "u32"
        },
        {
          name: "additionalFee",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "RequestHeapFrame",
      accounts: [],
      args: [
        {
          name: "heapRegionSize",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "SetComputeUnitLimit",
      accounts: [],
      args: [
        {
          name: "computeUnitLimit",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "SetComputeUnitPrice",
      accounts: [],
      args: [
        {
          name: "computeUnitPrice",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "SetLoadedAccountsDataSizeLimit",
      accounts: [],
      args: [
        {
          name: "accountDataSizeLimit",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 4
      }
    }
  ],
  types: [],
  metadata: {
    origin: "shank",
    address: "ComputeBudget111111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/native/compute-budget-idls/compute-budget-134784000.ts
var ComputeBudget_134784000_IDL = {
  version: "0.0.1",
  name: "ComputeBudget",
  instructions: [
    {
      name: "RequestUnitsDeprecated",
      accounts: [],
      args: [
        {
          name: "units",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "RequestHeapFrame",
      accounts: [],
      args: [
        {
          name: "heapRegionSize",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "SetComputeUnitLimit",
      accounts: [],
      args: [
        {
          name: "computeUnitLimit",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "SetComputeUnitPrice",
      accounts: [],
      args: [
        {
          name: "computeUnitPrice",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "SetLoadedAccountsDataSizeLimit",
      accounts: [],
      args: [
        {
          name: "accountDataSizeLimit",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 4
      }
    }
  ],
  types: [],
  metadata: {
    origin: "shank",
    address: "ComputeBudget111111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/native/config.ts
var ConfigIDL = {
  version: "0.0.1",
  name: "config",
  accounts: [
    {
      name: "StakeConfig",
      type: {
        kind: "struct",
        fields: [
          {
            name: "Keys",
            type: {
              defined: "ConfigKeys"
            }
          },
          {
            name: "warmup_cooldown_rate",
            type: "f64"
          },
          {
            name: "slash_penalty",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "ValidatorInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "Keys",
            type: {
              defined: "ConfigKeys"
            }
          },
          {
            name: "info",
            type: "string"
          }
        ]
      }
    }
  ],
  instructions: [
    {
      name: "Create",
      accounts: [
        {
          name: "ConfigAccount",
          isMut: true,
          isSigner: true
        }
      ],
      args: [
        {
          name: "Keys",
          type: {
            defined: "ConfigKeys"
          }
        },
        {
          name: "space",
          type: "u64"
        }
      ]
    },
    {
      name: "Store",
      accounts: [
        {
          name: "ConfigAccount",
          isMut: true,
          isSigner: true
        },
        {
          name: "Signer1",
          isMut: true,
          isSigner: true
        },
        {
          name: "Signer2",
          isMut: true,
          isSigner: true
        }
      ],
      args: [
        {
          name: "Keys",
          type: {
            defined: "ConfigKeys"
          }
        },
        {
          name: "info",
          type: "string"
        }
      ]
    }
  ],
  types: [
    {
      name: "ConfigKeys",
      type: {
        kind: "struct",
        fields: [
          {
            name: "KeysTuple",
            type: {
              vec: {
                tuple: ["publicKey", "bool"]
              },
              size: "u8"
            }
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "Config1111111111111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/native/stake.ts
var StakeIDL = {
  version: "0.0.1",
  name: "stake",
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Initialized",
      type: {
        kind: "struct",
        fields: [
          {
            name: "meta",
            type: {
              defined: "Meta"
            }
          }
        ]
      }
    },
    {
      name: "StakeAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "meta",
            type: {
              defined: "Meta"
            }
          },
          {
            name: "stake",
            type: {
              defined: "Stake"
            }
          }
        ]
      }
    },
    {
      name: "RewardsPool",
      type: {
        kind: "struct",
        fields: []
      }
    }
  ],
  instructions: [
    {
      name: "Initialize",
      accounts: [
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "rentSysvar",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "authorized",
          type: {
            defined: "Authorized"
          }
        },
        {
          name: "lockup",
          type: {
            defined: "Lockup"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 0
      }
    },
    {
      name: "Authorize",
      accounts: [
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "lockupAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "authorizePubkey",
          type: "publicKey"
        },
        {
          name: "stakeAuthorize",
          type: {
            defined: "StakeAuthorize"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 1
      }
    },
    {
      name: "DelegateStake",
      accounts: [
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "voteAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeHistorySysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "configAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 2
      }
    },
    {
      name: "Split",
      accounts: [
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "splitAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "stakeAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "stakeAmount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u32",
        value: 3
      }
    },
    {
      name: "Withdraw",
      accounts: [
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "recipientAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeHistorySysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "unstakedLamports",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u32",
        value: 4
      }
    },
    {
      name: "Deactivate",
      accounts: [
        {
          name: "delegatedStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 5
      }
    },
    {
      name: "SetLockup",
      accounts: [
        {
          name: "initializedStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "lockupOrWithdrawAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "lockup",
          type: {
            defined: "Lockup"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 6
      }
    },
    {
      name: "Merge",
      accounts: [
        {
          name: "destinationStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "sourceStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeHistorySysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 7
      }
    },
    {
      name: "AuthorizeWithSeed",
      accounts: [
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "stakeOrWithdrawAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "lockupAuthority",
          isMut: false,
          isSigner: true,
          isOptional: true
        }
      ],
      args: [
        {
          name: "authorizeWithSeedArgs",
          type: {
            defined: "AuthorizeWithSeedArgs"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 8
      }
    },
    {
      name: "InitializeChecked",
      accounts: [
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "rentSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 9
      }
    },
    {
      name: "AuthorizeChecked",
      accounts: [
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "newStakeAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "lockupAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "stakeAuthorize",
          type: {
            defined: "StakeAuthorize"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 10
      }
    },
    {
      name: "AuthorizeCheckedWithSeed",
      accounts: [
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "newStakeAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "lockupAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "authorizeWithSeedArgs",
          type: {
            defined: "AuthorizeWithSeedArgs"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 11
      }
    },
    {
      name: "SetLockupChecked",
      accounts: [
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "lockupOrWithdrawAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "newLockupAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "lockupCheckedArgs",
          type: {
            defined: "LockupCheckedArgs"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 12
      }
    },
    {
      name: "GetMinimumDelegation",
      accounts: [],
      args: [],
      discriminant: {
        type: "u32",
        value: 13
      }
    },
    {
      name: "DeactivateDelinquent",
      accounts: [
        {
          name: "delegatedStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "delinquentVoteAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "referenceVoteAccount",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 14
      }
    },
    {
      name: "Redelegate",
      accounts: [
        {
          name: "delegatedStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "uninitializedStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "voteAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "configAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 15
      }
    }
  ],
  types: [
    {
      name: "LockupCheckedArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "unix_timestamp",
            type: {
              option: "i64"
            }
          },
          {
            name: "epoch",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "AuthorizeWithSeedArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "stake_authorize",
            type: {
              defined: "StakeAuthorize"
            }
          },
          {
            name: "authority_seed",
            type: "string"
          },
          {
            name: "authority_owner",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "StakeAuthorize",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Staker"
          },
          {
            name: "Withdrawer"
          }
        ],
        size: "u32"
      }
    },
    {
      name: "Delegation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "voter_pubkey",
            type: "publicKey"
          },
          {
            name: "stake",
            type: "u64"
          },
          {
            name: "activation_epoch",
            type: "u64"
          },
          {
            name: "deactivation_epoch",
            type: "u64"
          },
          {
            name: "warmup_cooldown_rate",
            type: "f64"
          }
        ]
      }
    },
    {
      name: "Stake",
      type: {
        kind: "struct",
        fields: [
          {
            name: "delegation",
            type: {
              defined: "Delegation"
            }
          },
          {
            name: "credits_observed",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Meta",
      type: {
        kind: "struct",
        fields: [
          {
            name: "rent_exempt_reserve",
            type: "u64"
          },
          {
            name: "authorized",
            type: {
              defined: "Authorized"
            }
          },
          {
            name: "lockup",
            type: {
              defined: "Lockup"
            }
          }
        ]
      }
    },
    {
      name: "Authorized",
      type: {
        kind: "struct",
        fields: [
          {
            name: "staker",
            type: "publicKey"
          },
          {
            name: "withdrawer",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Lockup",
      type: {
        kind: "struct",
        fields: [
          {
            name: "unix_timestamp",
            type: "i64"
          },
          {
            name: "epoch",
            type: "u64"
          },
          {
            name: "custodian",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "Stake11111111111111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/native/system.ts
var SystemIDL = {
  version: "0.0.1",
  name: "system",
  accounts: [],
  instructions: [
    {
      name: "CreateAccount",
      accounts: [
        {
          name: "fundingAccount",
          isMut: true,
          isSigner: true
        },
        {
          name: "newAccount",
          isMut: true,
          isSigner: true
        }
      ],
      args: [
        {
          name: "lamports",
          type: "u64"
        },
        {
          name: "space",
          type: "u64"
        },
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 0
      }
    },
    {
      name: "Assign",
      accounts: [
        {
          name: "assignAccount",
          isMut: true,
          isSigner: true
        }
      ],
      args: [
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 1
      }
    },
    {
      name: "Transfer",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: true
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "lamports",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u32",
        value: 2
      }
    },
    {
      name: "CreateAccountWithSeed",
      accounts: [
        {
          name: "fundingAccount",
          isMut: true,
          isSigner: true
        },
        {
          name: "createdAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "baseAccount",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "base",
          type: "publicKey"
        },
        {
          name: "seed",
          type: "string"
        },
        {
          name: "lamports",
          type: "u64"
        },
        {
          name: "space",
          type: "u64"
        },
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 3
      }
    },
    {
      name: "AdvanceNonceAccount",
      accounts: [
        {
          name: "nonceAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "recentBlockhashesSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "nonceAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 4
      }
    },
    {
      name: "WithdrawNonceAccount",
      accounts: [
        {
          name: "nonceAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "recipientAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "recentBlockhashesSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "rentSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "nonceAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "withdrawAmount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u32",
        value: 5
      }
    },
    {
      name: "InitializeNonceAccount",
      accounts: [
        {
          name: "nonceAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "recentBlockhashesSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "rentSysvar",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "nonceAccount",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 6
      }
    },
    {
      name: "AuthorizeNonceAccount",
      accounts: [
        {
          name: "nonceAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "nonceAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "nonceAccount",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 7
      }
    },
    {
      name: "Allocate",
      accounts: [
        {
          name: "newAccount",
          isMut: true,
          isSigner: true
        }
      ],
      args: [
        {
          name: "space",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u32",
        value: 8
      }
    },
    {
      name: "AllocateWithSeed",
      accounts: [
        {
          name: "allocatedAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "baseAccount",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "base",
          type: "publicKey"
        },
        {
          name: "seed",
          type: "string"
        },
        {
          name: "space",
          type: "u64"
        },
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 9
      }
    },
    {
      name: "AssignWithSeed",
      accounts: [
        {
          name: "assignedAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "baseAccount",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "base",
          type: "publicKey"
        },
        {
          name: "seed",
          type: "string"
        },
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 10
      }
    },
    {
      name: "TransferWithSeed",
      accounts: [
        {
          name: "fundingAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "baseAccount",
          isMut: false,
          isSigner: true
        },
        {
          name: "recipientAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "lamports",
          type: "u64"
        },
        {
          name: "fromSeed",
          type: "string"
        },
        {
          name: "fromOwner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 11
      }
    },
    {
      name: "UpgradeNonceAccount",
      accounts: [
        {
          name: "nonceAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 12
      }
    }
  ],
  types: [],
  errors: [
    {
      code: 0,
      name: "AccountAlreadyInUse",
      msg: "an account with the same address already exists"
    },
    {
      code: 1,
      name: "ResultWithNegativeLamports",
      msg: "account does not have enough SOL to perform the operation"
    },
    {
      code: 2,
      name: "InvalidProgramId",
      msg: "cannot assign account to this program id"
    },
    {
      code: 3,
      name: "InvalidAccountDataLength",
      msg: "cannot allocate account data of this length"
    },
    {
      code: 4,
      name: "MaxSeedLengthExceeded",
      msg: "length of requested seed is too long"
    },
    {
      code: 5,
      name: "AddressWithSeedMismatch",
      msg: "provided address does not match addressed derived from seed"
    },
    {
      code: 6,
      name: "NonceNoRecentBlockhashes",
      msg: "advancing stored nonce requires a populated RecentBlockhashes sysvar"
    },
    {
      code: 7,
      name: "NonceBlockhashNotExpired",
      msg: "stored nonce is still in recent_blockhashes"
    },
    {
      code: 8,
      name: "NonceUnexpectedBlockhashValue",
      msg: "specified nonce does not match stored nonce"
    }
  ],
  metadata: {
    origin: "shank",
    address: "11111111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/native/upgradeable-loader.ts
var BPFLoaderUpgradeableIDL = {
  version: "0.0.0",
  name: "bpf_upgradeable_loader",
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Buffer",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authority_address",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "data",
            type: "bytes"
          }
        ]
      }
    },
    {
      name: "Program",
      type: {
        kind: "struct",
        fields: [
          {
            name: "program_data_address",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ProgramData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "slot",
            type: "u64"
          },
          {
            name: "upgrade_authority_address",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "data",
            type: "bytes"
          }
        ]
      }
    }
  ],
  instructions: [
    {
      name: "InitializeBuffer",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "bufferAuthority",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 0
      }
    },
    {
      name: "Write",
      accounts: [
        {
          name: "bufferAccountToWrite",
          isMut: true,
          isSigner: false
        },
        {
          name: "bufferAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "offset",
          type: "u32"
        },
        {
          name: "data",
          type: "bytes"
        }
      ],
      discriminant: {
        type: "u32",
        value: 1
      }
    },
    {
      name: "DeployWithMaxDataLen",
      accounts: [
        {
          name: "payer",
          isMut: false,
          isSigner: true
        },
        {
          name: "programData",
          isMut: true,
          isSigner: false
        },
        {
          name: "program",
          isMut: true,
          isSigner: false
        },
        {
          name: "bufferAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "rentSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "maxDataLen",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u32",
        value: 2
      }
    },
    {
      name: "Upgrade",
      accounts: [
        {
          name: "programData",
          isMut: true,
          isSigner: false
        },
        {
          name: "program",
          isMut: true,
          isSigner: false
        },
        {
          name: "bufferAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "spillAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "rentSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 3
      }
    },
    {
      name: "SetAuthority",
      accounts: [
        {
          name: "programData",
          isMut: true,
          isSigner: false
        },
        {
          name: "currentAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "newAuthority",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 4
      }
    },
    {
      name: "Close",
      accounts: [
        {
          name: "closeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "DestinationAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "associatedProgram",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 5
      }
    },
    {
      name: "ExtendProgram",
      accounts: [
        {
          name: "programData",
          isMut: true,
          isSigner: false
        },
        {
          name: "associatedProgram",
          isMut: true,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "additionalBytes",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u32",
        value: 6
      }
    },
    {
      name: "SetAuthorityNew",
      accounts: [
        {
          name: "programData",
          isMut: true,
          isSigner: false
        },
        {
          name: "currentAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "newAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 7
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "BPFLoaderUpgradeab1e11111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/native/vote.ts
var VoteIDL = {
  version: "0.0.1",
  name: "vote",
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "VoteState",
      type: {
        kind: "struct",
        fields: [
          {
            name: "node_pubkey",
            type: "publicKey"
          },
          {
            name: "authorized_withdrawer",
            type: "publicKey"
          },
          {
            name: "commission",
            type: "u8"
          },
          {
            name: "votes",
            type: {
              vec: {
                defined: "Lockout"
              },
              size: "u64"
            }
          },
          {
            name: "root_slot",
            type: {
              option: "u64"
            }
          },
          {
            name: "authorized_voters",
            type: {
              bTreeMap: ["u64", "publicKey"],
              size: "u64"
            }
          },
          {
            name: "prior_voters",
            type: {
              defined: "PriorVoters"
            }
          },
          {
            name: "epoch_credits",
            type: {
              vec: {
                tuple: [
                  {
                    defined: "Epoch"
                  },
                  {
                    defined: "Credits"
                  },
                  {
                    defined: "PrevCredits"
                  }
                ]
              },
              size: "u64"
            }
          },
          {
            name: "last_timestamp",
            type: {
              defined: "BlockTimestamp"
            }
          }
        ]
      }
    },
    {
      name: "VoteStateWithLatency",
      type: {
        kind: "struct",
        fields: [
          {
            name: "node_pubkey",
            type: "publicKey"
          },
          {
            name: "authorized_withdrawer",
            type: "publicKey"
          },
          {
            name: "commission",
            type: "u8"
          },
          {
            name: "votes",
            type: {
              vec: {
                defined: "LandedVote"
              },
              size: "u64"
            }
          },
          {
            name: "root_slot",
            type: {
              option: "u64"
            }
          },
          {
            name: "authorized_voters",
            type: {
              bTreeMap: ["u64", "publicKey"],
              size: "u64"
            }
          },
          {
            name: "prior_voters",
            type: {
              defined: "PriorVoters"
            }
          },
          {
            name: "epoch_credits",
            type: {
              vec: {
                tuple: [
                  {
                    defined: "Epoch"
                  },
                  {
                    defined: "Credits"
                  },
                  {
                    defined: "PrevCredits"
                  }
                ]
              },
              size: "u64"
            }
          },
          {
            name: "last_timestamp",
            type: {
              defined: "BlockTimestamp"
            }
          }
        ]
      }
    }
  ],
  instructions: [
    {
      name: "Initialize",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "rentSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "nodePubkey",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "voteInit",
          type: {
            defined: "VoteInit"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 0
      }
    },
    {
      name: "Authorize",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "newAuthorizedPubkey",
          type: "publicKey"
        },
        {
          name: "voteAuthorizeType",
          type: {
            defined: "VoteAuthorize"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 1
      }
    },
    {
      name: "Vote",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "slotHashesSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "vote",
          type: {
            defined: "Vote"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 2
      }
    },
    {
      name: "Withdraw",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "recipientAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "withdrawAmount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u32",
        value: 3
      }
    },
    {
      name: "UpdateValidatorIdentity",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "newValidatorIdentity",
          isMut: false,
          isSigner: true
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 4
      }
    },
    {
      name: "UpdateCommission",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "commissionAmount",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u32",
        value: 5
      }
    },
    {
      name: "VoteSwitch",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "slotHashesSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "voteAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "vote",
          type: {
            defined: "Vote"
          }
        },
        {
          name: "hash",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 6
      }
    },
    {
      name: "AuthorizeChecked",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "newAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "voteAuthorize",
          type: {
            defined: "VoteAuthorize"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 7
      }
    },
    {
      name: "UpdateVoteState",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "voteAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "voteStateUpdate",
          type: {
            defined: "VoteStateUpdate"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 8
      }
    },
    {
      name: "UpdateVoteStateSwitch",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "voteAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "voteStateUpdate",
          type: {
            defined: "VoteStateUpdate"
          }
        },
        {
          name: "hash",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 9
      }
    },
    {
      name: "AuthorizeWithSeed",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "authorityBaseKey",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "voteAuthorizeWithSeed",
          type: {
            defined: "VoteAuthorizeWithSeed"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 10
      }
    },
    {
      name: "AuthorizeCheckedWithSeed",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "currentAuthorityBaseKey",
          isMut: false,
          isSigner: true
        },
        {
          name: "newAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "voteAuthorizeCheckedWithSeed",
          type: {
            defined: "VoteAuthorizeCheckedWithSeed"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 11
      }
    },
    {
      name: "CompactUpdateVoteState",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "voteAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "compactVoteState",
          type: {
            defined: "CompactVoteState"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 12
      }
    },
    {
      name: "CompactUpdateVoteStateSwitch",
      accounts: [
        {
          name: "voteAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "voteAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "compactVoteState",
          type: {
            defined: "CompactVoteState"
          }
        },
        {
          name: "hash",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u32",
        value: 13
      }
    }
  ],
  types: [
    {
      name: "ShortLockout",
      type: {
        kind: "struct",
        fields: [
          {
            name: "offset",
            type: "u8"
          },
          {
            name: "confirmationCount",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CompactVoteState",
      type: {
        kind: "struct",
        fields: [
          {
            name: "root",
            type: "u64"
          },
          {
            name: "lockoutOffsets",
            type: {
              vec: {
                defined: "ShortLockout"
              },
              size: "u8"
            }
          },
          {
            name: "hash",
            type: "publicKey"
          },
          {
            name: "timestamp",
            type: {
              option: "i64"
            }
          }
        ]
      }
    },
    {
      name: "VoteAuthorizeCheckedWithSeed",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authorizationType",
            type: {
              defined: "VoteAuthorize"
            }
          },
          {
            name: "currentAuthorityDerivedKeyOwner",
            type: "publicKey"
          },
          {
            name: "currentAuthorityDerivedKeySeed",
            type: "string"
          }
        ]
      }
    },
    {
      name: "VoteAuthorizeWithSeed",
      type: {
        kind: "struct",
        fields: [
          {
            name: "authorizationType",
            type: {
              defined: "VoteAuthorize"
            }
          },
          {
            name: "currentAuthorityDerivedKeyOwner",
            type: "publicKey"
          },
          {
            name: "currentAuthorityDerivedKeySeed",
            type: "string"
          },
          {
            name: "newAuthority",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "VoteStateUpdate",
      type: {
        kind: "struct",
        fields: [
          {
            name: "lockouts",
            type: {
              vec: {
                defined: "Lockout"
              },
              size: "u64"
            }
          },
          {
            name: "root",
            type: {
              option: "u64"
            }
          },
          {
            name: "hash",
            type: "publicKey"
          },
          {
            name: "timestamp",
            type: {
              option: "i64"
            }
          }
        ]
      }
    },
    {
      name: "Vote",
      type: {
        kind: "struct",
        fields: [
          {
            name: "slots",
            type: {
              vec: "u64",
              size: "u64"
            }
          },
          {
            name: "hash",
            type: "publicKey"
          },
          {
            name: "timestamp",
            type: {
              option: "i64"
            }
          }
        ]
      }
    },
    {
      name: "VoteAuthorize",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Voter"
          },
          { name: "Withdrawer" }
        ],
        size: "u32"
      }
    },
    {
      name: "VoteInit",
      type: {
        kind: "struct",
        fields: [
          {
            name: "nodePubkey",
            type: "publicKey"
          },
          {
            name: "authorizedVoter",
            type: "publicKey"
          },
          {
            name: "authorizedWithdrawer",
            type: "publicKey"
          },
          {
            name: "commission",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Epoch",
      type: {
        kind: "struct",
        fields: [
          {
            name: "epoch",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Credits",
      type: {
        kind: "struct",
        fields: [
          {
            name: "credits",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "PrevCredits",
      type: {
        kind: "struct",
        fields: [
          {
            name: "prevCredits",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "PriorVoters",
      type: {
        kind: "struct",
        fields: [
          {
            name: "buf",
            type: {
              array: [
                {
                  tuple: ["publicKey", "u64", "u64"]
                },
                32
              ]
            }
          },
          {
            name: "idx",
            type: "u64"
          },
          {
            name: "is_empty",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "Lockout",
      type: {
        kind: "struct",
        fields: [
          {
            name: "slot",
            type: "u64"
          },
          {
            name: "confirmation_count",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "BlockTimestamp",
      type: {
        kind: "struct",
        fields: [
          {
            name: "slot",
            type: "u64"
          },
          {
            name: "timestamp",
            type: "i64"
          }
        ]
      }
    },
    {
      name: "LandedVote",
      type: {
        kind: "struct",
        fields: [
          {
            name: "latency",
            type: "u8"
          },
          {
            name: "lockout",
            type: {
              defined: "Lockout"
            }
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "Vote111111111111111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/others/token-auth-rules.ts
var AuthRulesIDL = {
  version: "1.3.0",
  name: "mpl_token_auth_rules",
  instructions: [
    {
      name: "CreateOrUpdate",
      accounts: [
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer and creator of the RuleSet"
        },
        {
          name: "ruleSetPda",
          isMut: true,
          isSigner: false,
          desc: "The PDA account where the RuleSet is stored"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "bufferPda",
          isMut: false,
          isSigner: false,
          desc: "The buffer to copy a complete ruleset from",
          optional: true
        }
      ],
      args: [
        {
          name: "createOrUpdateArgs",
          type: {
            defined: "CreateOrUpdateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "Validate",
      accounts: [
        {
          name: "ruleSetPda",
          isMut: false,
          isSigner: false,
          desc: "The PDA account where the RuleSet is stored"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer for RuleSet state PDA account",
          optional: true
        },
        {
          name: "ruleAuthority",
          isMut: false,
          isSigner: true,
          desc: "Signing authority for any Rule state updates",
          optional: true
        },
        {
          name: "ruleSetStatePda",
          isMut: true,
          isSigner: false,
          desc: "The PDA account where any RuleSet state is stored",
          optional: true
        }
      ],
      args: [
        {
          name: "validateArgs",
          type: {
            defined: "ValidateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "WriteToBuffer",
      accounts: [
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer and creator of the RuleSet"
        },
        {
          name: "bufferPda",
          isMut: true,
          isSigner: false,
          desc: "The PDA account where the RuleSet buffer is stored"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        }
      ],
      args: [
        {
          name: "writeToBufferArgs",
          type: {
            defined: "WriteToBufferArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "PuffRuleSet",
      accounts: [
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer and creator of the RuleSet"
        },
        {
          name: "ruleSetPda",
          isMut: true,
          isSigner: false,
          desc: "The PDA account where the RuleSet is stored"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        }
      ],
      args: [
        {
          name: "puffRuleSetArgs",
          type: {
            defined: "PuffRuleSetArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 3
      }
    }
  ],
  accounts: [
    {
      name: "FrequencyAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "lastUpdate",
            type: "i64"
          },
          {
            name: "period",
            type: "i64"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "SeedsVec",
      type: {
        kind: "struct",
        fields: [
          {
            name: "seeds",
            type: {
              vec: "bytes"
            }
          }
        ]
      }
    },
    {
      name: "ProofInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "proof",
            type: {
              vec: {
                array: ["u8", 32]
              }
            }
          }
        ]
      }
    },
    {
      name: "Payload",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: {
              hashMap: [
                "string",
                {
                  defined: "PayloadType"
                }
              ]
            }
          }
        ]
      }
    },
    {
      name: "RuleSetHeader",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "revMapVersionLocation",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "RuleSetRevisionMapV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "ruleSetRevisions",
            type: {
              vec: "u64"
            }
          }
        ]
      }
    },
    {
      name: "CreateOrUpdateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "serialized_rule_set",
                type: "bytes"
              }
            ]
          }
        ]
      }
    },
    {
      name: "ValidateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "operation",
                type: "string"
              },
              {
                name: "payload",
                type: {
                  defined: "Payload"
                }
              },
              {
                name: "update_rule_state",
                type: "bool"
              },
              {
                name: "rule_set_revision",
                type: {
                  option: "u64"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "WriteToBufferArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "serialized_rule_set",
                type: "bytes"
              },
              {
                name: "overwrite",
                type: "bool"
              }
            ]
          }
        ]
      }
    },
    {
      name: "PuffRuleSetArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "rule_set_name",
                type: "string"
              }
            ]
          }
        ]
      }
    },
    {
      name: "PayloadType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Pubkey",
            fields: ["publicKey"]
          },
          {
            name: "Seeds",
            fields: [
              {
                defined: "SeedsVec"
              }
            ]
          },
          {
            name: "MerkleProof",
            fields: [
              {
                defined: "ProofInfo"
              }
            ]
          },
          {
            name: "Number",
            fields: ["u64"]
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "RuleSet"
          },
          {
            name: "Frequency"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "auth9SigNpDKz4sJJ1DfCTuZrZNSAgh9sFD3rboVmgg",
    binaryVersion: "0.0.11",
    libVersion: "0.0.11"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v125.ts
var TokenMetadataV125IDL = {
  version: "1.2.5",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "(Optional) Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list."
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: false,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "(Optional) Use Authority Record PDA If present the program Assumes a delegated use authority"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "(Optional) Program As Signer (Burner)"
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "(Optional) Collection Authority Record PDA"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "(Optional) Collection Authority Record PDA"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: false,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: false,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: "Failed to unpack instruction data"
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: "Failed to pack instruction data"
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: "Update authority must be equivalent to the metadata's authority and also signer of this transaction"
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: "Maximum editions printed already"
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: "Token mint to failed"
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: "The master edition record passed must match the master record on the edition given"
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: "The destination account does not have the right mint"
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: "An edition can only mint one of its kind!"
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: "Printing mint decimals should be zero"
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: "OneTimePrintingAuthorization mint decimals should be zero"
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: "Token burn failed"
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: "The One Time authorization mint does not match that on the token account!"
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: "The mint on your authorization token holding account does not match your Printing mint!"
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: "The authorization token account has a different owner than the update authority for the master edition!"
    },
    {
      code: 35,
      name: "Disabled",
      msg: "This feature is currently disabled."
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: "If using a creators array, you must be one of the creators listed"
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: "This reservation list already exists!"
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: "This reservation list does not exist!"
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: "This reservation list exists but was never set with reservations"
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: "This reservation list has already been set!"
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: "Provided more addresses than max allowed in single reservation"
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: "This reservation would go beyond the maximum supply of the master edition!"
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: "Address not in reservation!"
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: "In initial reservation setting, spots remaining should equal total spots"
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: "printing these tokens would breach the maximum supply limit of the master edition"
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: "Reservation spots remaining should match total spots when first being created"
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: "Beyond alotted address size in reservation!"
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: "The reservation has only been partially alotted"
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: "You cannot splice over an existing reservation!"
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: "In the legacy system the reservation needs to be of size one for cpu limit reasons"
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Cannont Verify Collection in this Instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: "This token use method is burn and there are no remaining uses, it must be burned"
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: "This Collection Authority Record is invalid."
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: "Creator can not be adjusted once they are verified."
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: "Can not wipe verified creators."
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: "Not allowed to change seller fee basis points."
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v130.ts
var TokenMetadataV130IDL = {
  version: "1.3.0",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list.",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: true,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA If present the program Assumes a delegated use authority",
          optional: true
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)",
          optional: true
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "delegateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Delegated Collection Authority"
        },
        {
          name: "revokeAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority, or Delegated Authority, of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "BurnNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the NFT"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "editionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 or Edition Account of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "VerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "UnverifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "SetAndVerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "CreateMetadataAccountV3",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV3",
          type: {
            defined: "CreateMetadataAccountArgsV3"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "SetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        }
      ],
      args: [
        {
          name: "instructionArgs",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "SetTokenStandard",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Metadata update authority"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 35
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV3",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    },
    {
      name: "CollectionDetails",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: ["u64"]
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: "Failed to unpack instruction data"
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: "Failed to pack instruction data"
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: "Update authority must be equivalent to the metadata's authority and also signer of this transaction"
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: "Maximum editions printed already"
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: "Token mint to failed"
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: "The master edition record passed must match the master record on the edition given"
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: "The destination account does not have the right mint"
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: "An edition can only mint one of its kind!"
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: "Printing mint decimals should be zero"
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: "OneTimePrintingAuthorization mint decimals should be zero"
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: "Token burn failed"
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: "The One Time authorization mint does not match that on the token account!"
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: "The mint on your authorization token holding account does not match your Printing mint!"
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: "The authorization token account has a different owner than the update authority for the master edition!"
    },
    {
      code: 35,
      name: "Disabled",
      msg: "This feature is currently disabled."
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: "If using a creators array, you must be one of the creators listed"
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: "This reservation list already exists!"
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: "This reservation list does not exist!"
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: "This reservation list exists but was never set with reservations"
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: "This reservation list has already been set!"
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: "Provided more addresses than max allowed in single reservation"
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: "This reservation would go beyond the maximum supply of the master edition!"
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: "Address not in reservation!"
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: "In initial reservation setting, spots remaining should equal total spots"
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: "printing these tokens would breach the maximum supply limit of the master edition"
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: "Reservation spots remaining should match total spots when first being created"
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: "Beyond alotted address size in reservation!"
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: "The reservation has only been partially alotted"
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: "You cannot splice over an existing reservation!"
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: "In the legacy system the reservation needs to be of size one for cpu limit reasons"
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Cannont Verify Collection in this Instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: "This token use method is burn and there are no remaining uses, it must be burned"
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: "This Collection Authority Record is invalid."
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: "Creator can not be adjusted once they are verified."
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: "Can not wipe verified creators."
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: "Not allowed to change seller fee basis points."
    },
    {
      code: 97,
      name: "EditionOverrideCannotBeZero",
      msg: "Edition override cannot be zero"
    },
    {
      code: 98,
      name: "InvalidUser",
      msg: "Invalid User"
    },
    {
      code: 99,
      name: "RevokeCollectionAuthoritySignerIncorrect",
      msg: "Revoke Collection Authority signer is incorrect"
    },
    {
      code: 100,
      name: "TokenCloseFailed",
      msg: "Token close failed"
    },
    {
      code: 101,
      name: "UnsizedCollection",
      msg: "Can't use this function on unsized collection"
    },
    {
      code: 102,
      name: "SizedCollection",
      msg: "Can't use this function on a sized collection"
    },
    {
      code: 103,
      name: "MissingCollectionMetadata",
      msg: "Can't burn a verified member of a collection w/o providing collection metadata account"
    },
    {
      code: 104,
      name: "NotAMemberOfCollection",
      msg: "This NFT is not a member of the specified collection."
    },
    {
      code: 105,
      name: "NotVerifiedMemberOfCollection",
      msg: "This NFT is not a verified member of the specified collection."
    },
    {
      code: 106,
      name: "NotACollectionParent",
      msg: "This NFT is not a collection parent NFT."
    },
    {
      code: 107,
      name: "CouldNotDetermineTokenStandard",
      msg: "Could not determine a TokenStandard type."
    },
    {
      code: 108,
      name: "MissingEditionAccount",
      msg: "This mint account has an edition but none was provided."
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    binaryVersion: "0.0.2",
    libVersion: "~0.0.2"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v135.ts
var TokenMetadataV135IDL = {
  version: "1.3.5",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list.",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: true,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA If present the program Assumes a delegated use authority",
          optional: true
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)",
          optional: true
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "delegateAuthority",
          isMut: true,
          isSigner: false,
          desc: "Delegated Collection Authority"
        },
        {
          name: "revokeAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority, or Delegated Authority, of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "BurnNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the NFT"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "VerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "UnverifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "SetAndVerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "CreateMetadataAccountV3",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV3",
          type: {
            defined: "CreateMetadataAccountArgsV3"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "SetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "SetTokenStandard",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Metadata update authority"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "BubblegumSetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "bubblegumSigner",
          isMut: false,
          isSigner: true,
          desc: "Signing PDA of Bubblegum program"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 36
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV3",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetCollectionSizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "size",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    },
    {
      name: "CollectionDetails",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "size",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: "Failed to unpack instruction data"
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: "Failed to pack instruction data"
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: "Update authority must be equivalent to the metadata's authority and also signer of this transaction"
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: "Maximum editions printed already"
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: "Token mint to failed"
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: "The master edition record passed must match the master record on the edition given"
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: "The destination account does not have the right mint"
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: "An edition can only mint one of its kind!"
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: "Printing mint decimals should be zero"
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: "OneTimePrintingAuthorization mint decimals should be zero"
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: "Token burn failed"
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: "The One Time authorization mint does not match that on the token account!"
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: "The mint on your authorization token holding account does not match your Printing mint!"
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: "The authorization token account has a different owner than the update authority for the master edition!"
    },
    {
      code: 35,
      name: "Disabled",
      msg: "This feature is currently disabled."
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: "If using a creators array, you must be one of the creators listed"
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: "This reservation list already exists!"
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: "This reservation list does not exist!"
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: "This reservation list exists but was never set with reservations"
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: "This reservation list has already been set!"
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: "Provided more addresses than max allowed in single reservation"
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: "This reservation would go beyond the maximum supply of the master edition!"
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: "Address not in reservation!"
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: "In initial reservation setting, spots remaining should equal total spots"
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: "printing these tokens would breach the maximum supply limit of the master edition"
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: "Reservation spots remaining should match total spots when first being created"
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: "Beyond alotted address size in reservation!"
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: "The reservation has only been partially alotted"
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: "You cannot splice over an existing reservation!"
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: "In the legacy system the reservation needs to be of size one for cpu limit reasons"
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Cannont Verify Collection in this Instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: "This token use method is burn and there are no remaining uses, it must be burned"
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: "This Collection Authority Record is invalid."
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: "Creator can not be adjusted once they are verified."
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: "Can not wipe verified creators."
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: "Not allowed to change seller fee basis points."
    },
    {
      code: 97,
      name: "EditionOverrideCannotBeZero",
      msg: "Edition override cannot be zero"
    },
    {
      code: 98,
      name: "InvalidUser",
      msg: "Invalid User"
    },
    {
      code: 99,
      name: "RevokeCollectionAuthoritySignerIncorrect",
      msg: "Revoke Collection Authority signer is incorrect"
    },
    {
      code: 100,
      name: "TokenCloseFailed",
      msg: "Token close failed"
    },
    {
      code: 101,
      name: "UnsizedCollection",
      msg: "Can't use this function on unsized collection"
    },
    {
      code: 102,
      name: "SizedCollection",
      msg: "Can't use this function on a sized collection"
    },
    {
      code: 103,
      name: "MissingCollectionMetadata",
      msg: "Can't burn a verified member of a collection w/o providing collection metadata account"
    },
    {
      code: 104,
      name: "NotAMemberOfCollection",
      msg: "This NFT is not a member of the specified collection."
    },
    {
      code: 105,
      name: "NotVerifiedMemberOfCollection",
      msg: "This NFT is not a verified member of the specified collection."
    },
    {
      code: 106,
      name: "NotACollectionParent",
      msg: "This NFT is not a collection parent NFT."
    },
    {
      code: 107,
      name: "CouldNotDetermineTokenStandard",
      msg: "Could not determine a TokenStandard type."
    },
    {
      code: 108,
      name: "MissingEditionAccount",
      msg: "This mint account has an edition but none was provided."
    },
    {
      code: 109,
      name: "NotAMasterEdition",
      msg: "This edition is not a Master Edition"
    },
    {
      code: 110,
      name: "MasterEditionHasPrints",
      msg: "This Master Edition has existing prints"
    },
    {
      code: 111,
      name: "BorshDeserializationError",
      msg: "Borsh Deserialization Error"
    },
    {
      code: 112,
      name: "CannotUpdateVerifiedCollection",
      msg: "Cannot update a verified colleciton in this command"
    },
    {
      code: 113,
      name: "CollectionMasterEditionAccountInvalid",
      msg: "Edition account aoesnt match collection "
    },
    {
      code: 114,
      name: "AlreadyVerified",
      msg: "Item is already verified."
    },
    {
      code: 115,
      name: "AlreadyUnverified",
      msg: "Item is already unverified."
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    binaryVersion: "0.0.8",
    libVersion: "~0.0.4"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v160.ts
var TokenMetadataV160IDL = {
  version: "1.6.0",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list.",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: true,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA If present the program Assumes a delegated use authority",
          optional: true
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)",
          optional: true
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "delegateAuthority",
          isMut: true,
          isSigner: false,
          desc: "Delegated Collection Authority"
        },
        {
          name: "revokeAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority, or Delegated Authority, of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "BurnNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the NFT"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "VerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "UnverifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "SetAndVerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "CreateMetadataAccountV3",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV3",
          type: {
            defined: "CreateMetadataAccountArgsV3"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "SetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "SetTokenStandard",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Metadata update authority"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "BubblegumSetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "bubblegumSigner",
          isMut: false,
          isSigner: true,
          desc: "Signing PDA of Bubblegum program"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 36
      }
    },
    {
      name: "BurnEditionNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "printEditionMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the print edition NFT"
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the original/master NFT"
        },
        {
          name: "printEditionTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account the print edition NFT is in"
        },
        {
          name: "masterEditionTokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account the Master Edition NFT is in"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the original NFT"
        },
        {
          name: "printEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "Print Edition account of the NFT"
        },
        {
          name: "editionMarkerAccount",
          isMut: true,
          isSigner: false,
          desc: "Edition Marker PDA of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 37
      }
    },
    {
      name: "CreateEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account of the token"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 38
      }
    },
    {
      name: "CloseEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 39
      }
    },
    {
      name: "TransferOutOfEscrow",
      accounts: [
        {
          name: "escrow",
          isMut: false,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "attributeMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account for the new attribute"
        },
        {
          name: "attributeSrc",
          isMut: true,
          isSigner: false,
          desc: "Token account source for the new attribute"
        },
        {
          name: "attributeDst",
          isMut: true,
          isSigner: false,
          desc: "Token account, owned by TM, destination for the new attribute"
        },
        {
          name: "escrowMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account that the escrow is attached"
        },
        {
          name: "escrowAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account that holds the token the escrow is attached to"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferOutOfEscrowArgs",
          type: {
            defined: "TransferOutOfEscrowArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 40
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "TokenOwnedEscrow",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "baseToken",
            type: "publicKey"
          },
          {
            name: "authority",
            type: {
              defined: "EscrowAuthority"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV3",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetCollectionSizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "size",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "TransferOutOfEscrowArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          },
          {
            name: "TokenOwnedEscrow"
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    },
    {
      name: "CollectionDetails",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "size",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          }
        ]
      }
    },
    {
      name: "EscrowAuthority",
      type: {
        kind: "enum",
        variants: [
          {
            name: "TokenOwner"
          },
          {
            name: "Creator",
            fields: ["publicKey"]
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: "Failed to unpack instruction data"
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: "Failed to pack instruction data"
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: "Update authority must be equivalent to the metadata's authority and also signer of this transaction"
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: "Maximum editions printed already"
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: "Token mint to failed"
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: "The master edition record passed must match the master record on the edition given"
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: "The destination account does not have the right mint"
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: "An edition can only mint one of its kind!"
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: "Printing mint decimals should be zero"
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: "OneTimePrintingAuthorization mint decimals should be zero"
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: "Token burn failed"
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: "The One Time authorization mint does not match that on the token account!"
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: "The mint on your authorization token holding account does not match your Printing mint!"
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: "The authorization token account has a different owner than the update authority for the master edition!"
    },
    {
      code: 35,
      name: "Disabled",
      msg: "This feature is currently disabled."
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: "If using a creators array, you must be one of the creators listed"
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: "This reservation list already exists!"
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: "This reservation list does not exist!"
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: "This reservation list exists but was never set with reservations"
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: "This reservation list has already been set!"
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: "Provided more addresses than max allowed in single reservation"
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: "This reservation would go beyond the maximum supply of the master edition!"
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: "Address not in reservation!"
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: "In initial reservation setting, spots remaining should equal total spots"
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: "printing these tokens would breach the maximum supply limit of the master edition"
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: "Reservation spots remaining should match total spots when first being created"
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: "Beyond alotted address size in reservation!"
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: "The reservation has only been partially alotted"
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: "You cannot splice over an existing reservation!"
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: "In the legacy system the reservation needs to be of size one for cpu limit reasons"
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Cannont Verify Collection in this Instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: "This token use method is burn and there are no remaining uses, it must be burned"
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: "This Collection Authority Record is invalid."
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: "Creator can not be adjusted once they are verified."
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: "Can not wipe verified creators."
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: "Not allowed to change seller fee basis points."
    },
    {
      code: 97,
      name: "EditionOverrideCannotBeZero",
      msg: "Edition override cannot be zero"
    },
    {
      code: 98,
      name: "InvalidUser",
      msg: "Invalid User"
    },
    {
      code: 99,
      name: "RevokeCollectionAuthoritySignerIncorrect",
      msg: "Revoke Collection Authority signer is incorrect"
    },
    {
      code: 100,
      name: "TokenCloseFailed",
      msg: "Token close failed"
    },
    {
      code: 101,
      name: "UnsizedCollection",
      msg: "Can't use this function on unsized collection"
    },
    {
      code: 102,
      name: "SizedCollection",
      msg: "Can't use this function on a sized collection"
    },
    {
      code: 103,
      name: "MissingCollectionMetadata",
      msg: "Can't burn a verified member of a collection w/o providing collection metadata account"
    },
    {
      code: 104,
      name: "NotAMemberOfCollection",
      msg: "This NFT is not a member of the specified collection."
    },
    {
      code: 105,
      name: "NotVerifiedMemberOfCollection",
      msg: "This NFT is not a verified member of the specified collection."
    },
    {
      code: 106,
      name: "NotACollectionParent",
      msg: "This NFT is not a collection parent NFT."
    },
    {
      code: 107,
      name: "CouldNotDetermineTokenStandard",
      msg: "Could not determine a TokenStandard type."
    },
    {
      code: 108,
      name: "MissingEditionAccount",
      msg: "This mint account has an edition but none was provided."
    },
    {
      code: 109,
      name: "NotAMasterEdition",
      msg: "This edition is not a Master Edition"
    },
    {
      code: 110,
      name: "MasterEditionHasPrints",
      msg: "This Master Edition has existing prints"
    },
    {
      code: 111,
      name: "BorshDeserializationError",
      msg: "Borsh Deserialization Error"
    },
    {
      code: 112,
      name: "CannotUpdateVerifiedCollection",
      msg: "Cannot update a verified colleciton in this command"
    },
    {
      code: 113,
      name: "CollectionMasterEditionAccountInvalid",
      msg: "Edition account doesnt match collection "
    },
    {
      code: 114,
      name: "AlreadyVerified",
      msg: "Item is already verified."
    },
    {
      code: 115,
      name: "AlreadyUnverified",
      msg: "Item is already unverified."
    },
    {
      code: 116,
      name: "NotAPrintEdition",
      msg: "This edition is not a Print Edition"
    },
    {
      code: 117,
      name: "InvalidMasterEdition",
      msg: "Invalid Master Edition"
    },
    {
      code: 118,
      name: "InvalidPrintEdition",
      msg: "Invalid Print Edition"
    },
    {
      code: 119,
      name: "InvalidEditionMarker",
      msg: "Invalid Edition Marker"
    },
    {
      code: 120,
      name: "ReservationListDeprecated",
      msg: "Reservation List is Deprecated"
    },
    {
      code: 121,
      name: "PrintEditionDoesNotMatchMasterEdition",
      msg: "Print Edition does not match Master Edition"
    },
    {
      code: 122,
      name: "EditionNumberGreaterThanMaxSupply",
      msg: "Edition Number greater than max supply"
    },
    {
      code: 123,
      name: "MustUnverify",
      msg: "Must unverify before migrating collections."
    },
    {
      code: 124,
      name: "InvalidEscrowBumpSeed",
      msg: "Invalid Escrow Account Bump Seed"
    },
    {
      code: 125,
      name: "MustBeEscrowAuthority",
      msg: "Must Escrow Authority"
    },
    {
      code: 126,
      name: "InvalidSystemProgram",
      msg: "Invalid System Program"
    },
    {
      code: 127,
      name: "MustBeNonFungible",
      msg: "Must be a Non Fungible Token"
    },
    {
      code: 128,
      name: "InsufficientTokens",
      msg: "Insufficient tokens for transfer"
    },
    {
      code: 129,
      name: "BorshSerializationError",
      msg: "Borsh Serialization Error"
    },
    {
      code: 130,
      name: "NoFreezeAuthoritySet",
      msg: "Cannot create NFT with no Freeze Authority."
    },
    {
      code: 131,
      name: "InvalidCollectionSizeChange",
      msg: "Invalid collection size change"
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    binaryVersion: "0.0.9",
    libVersion: "0.0.9"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v162.ts
var TokenMetadataV162IDL = {
  version: "1.6.2",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list.",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: true,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA If present the program Assumes a delegated use authority",
          optional: true
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)",
          optional: true
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "delegateAuthority",
          isMut: true,
          isSigner: false,
          desc: "Delegated Collection Authority"
        },
        {
          name: "revokeAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority, or Delegated Authority, of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "BurnNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the NFT"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "VerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "UnverifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "SetAndVerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "CreateMetadataAccountV3",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV3",
          type: {
            defined: "CreateMetadataAccountArgsV3"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "SetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "SetTokenStandard",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Metadata update authority"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "BubblegumSetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "bubblegumSigner",
          isMut: false,
          isSigner: true,
          desc: "Signing PDA of Bubblegum program"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 36
      }
    },
    {
      name: "BurnEditionNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "printEditionMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the print edition NFT"
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the original/master NFT"
        },
        {
          name: "printEditionTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account the print edition NFT is in"
        },
        {
          name: "masterEditionTokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account the Master Edition NFT is in"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the original NFT"
        },
        {
          name: "printEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "Print Edition account of the NFT"
        },
        {
          name: "editionMarkerAccount",
          isMut: true,
          isSigner: false,
          desc: "Edition Marker PDA of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 37
      }
    },
    {
      name: "CreateEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account of the token"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 38
      }
    },
    {
      name: "CloseEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 39
      }
    },
    {
      name: "TransferOutOfEscrow",
      accounts: [
        {
          name: "escrow",
          isMut: false,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "attributeMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account for the new attribute"
        },
        {
          name: "attributeSrc",
          isMut: true,
          isSigner: false,
          desc: "Token account source for the new attribute"
        },
        {
          name: "attributeDst",
          isMut: true,
          isSigner: false,
          desc: "Token account, owned by TM, destination for the new attribute"
        },
        {
          name: "escrowMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account that the escrow is attached"
        },
        {
          name: "escrowAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account that holds the token the escrow is attached to"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferOutOfEscrowArgs",
          type: {
            defined: "TransferOutOfEscrowArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 40
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "TokenOwnedEscrow",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "baseToken",
            type: "publicKey"
          },
          {
            name: "authority",
            type: {
              defined: "EscrowAuthority"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "SetCollectionSizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "size",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "TransferOutOfEscrowArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV3",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          },
          {
            name: "TokenOwnedEscrow"
          }
        ]
      }
    },
    {
      name: "CollectionDetails",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "size",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "EscrowAuthority",
      type: {
        kind: "enum",
        variants: [
          {
            name: "TokenOwner"
          },
          {
            name: "Creator",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: "Failed to unpack instruction data"
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: "Failed to pack instruction data"
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: "Update authority must be equivalent to the metadata's authority and also signer of this transaction"
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: "Maximum editions printed already"
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: "Token mint to failed"
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: "The master edition record passed must match the master record on the edition given"
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: "The destination account does not have the right mint"
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: "An edition can only mint one of its kind!"
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: "Printing mint decimals should be zero"
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: "OneTimePrintingAuthorization mint decimals should be zero"
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: "Token burn failed"
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: "The One Time authorization mint does not match that on the token account!"
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: "The mint on your authorization token holding account does not match your Printing mint!"
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: "The authorization token account has a different owner than the update authority for the master edition!"
    },
    {
      code: 35,
      name: "Disabled",
      msg: "This feature is currently disabled."
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: "If using a creators array, you must be one of the creators listed"
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: "This reservation list already exists!"
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: "This reservation list does not exist!"
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: "This reservation list exists but was never set with reservations"
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: "This reservation list has already been set!"
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: "Provided more addresses than max allowed in single reservation"
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: "This reservation would go beyond the maximum supply of the master edition!"
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: "Address not in reservation!"
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: "In initial reservation setting, spots remaining should equal total spots"
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: "printing these tokens would breach the maximum supply limit of the master edition"
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: "Reservation spots remaining should match total spots when first being created"
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: "Beyond alotted address size in reservation!"
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: "The reservation has only been partially alotted"
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: "You cannot splice over an existing reservation!"
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: "In the legacy system the reservation needs to be of size one for cpu limit reasons"
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Cannont Verify Collection in this Instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: "This token use method is burn and there are no remaining uses, it must be burned"
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: "This Collection Authority Record is invalid."
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: "Creator can not be adjusted once they are verified."
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: "Can not wipe verified creators."
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: "Not allowed to change seller fee basis points."
    },
    {
      code: 97,
      name: "EditionOverrideCannotBeZero",
      msg: "Edition override cannot be zero"
    },
    {
      code: 98,
      name: "InvalidUser",
      msg: "Invalid User"
    },
    {
      code: 99,
      name: "RevokeCollectionAuthoritySignerIncorrect",
      msg: "Revoke Collection Authority signer is incorrect"
    },
    {
      code: 100,
      name: "TokenCloseFailed",
      msg: "Token close failed"
    },
    {
      code: 101,
      name: "UnsizedCollection",
      msg: "Can't use this function on unsized collection"
    },
    {
      code: 102,
      name: "SizedCollection",
      msg: "Can't use this function on a sized collection"
    },
    {
      code: 103,
      name: "MissingCollectionMetadata",
      msg: "Can't burn a verified member of a collection w/o providing collection metadata account"
    },
    {
      code: 104,
      name: "NotAMemberOfCollection",
      msg: "This NFT is not a member of the specified collection."
    },
    {
      code: 105,
      name: "NotVerifiedMemberOfCollection",
      msg: "This NFT is not a verified member of the specified collection."
    },
    {
      code: 106,
      name: "NotACollectionParent",
      msg: "This NFT is not a collection parent NFT."
    },
    {
      code: 107,
      name: "CouldNotDetermineTokenStandard",
      msg: "Could not determine a TokenStandard type."
    },
    {
      code: 108,
      name: "MissingEditionAccount",
      msg: "This mint account has an edition but none was provided."
    },
    {
      code: 109,
      name: "NotAMasterEdition",
      msg: "This edition is not a Master Edition"
    },
    {
      code: 110,
      name: "MasterEditionHasPrints",
      msg: "This Master Edition has existing prints"
    },
    {
      code: 111,
      name: "BorshDeserializationError",
      msg: "Borsh Deserialization Error"
    },
    {
      code: 112,
      name: "CannotUpdateVerifiedCollection",
      msg: "Cannot update a verified colleciton in this command"
    },
    {
      code: 113,
      name: "CollectionMasterEditionAccountInvalid",
      msg: "Edition account doesnt match collection "
    },
    {
      code: 114,
      name: "AlreadyVerified",
      msg: "Item is already verified."
    },
    {
      code: 115,
      name: "AlreadyUnverified",
      msg: "Item is already unverified."
    },
    {
      code: 116,
      name: "NotAPrintEdition",
      msg: "This edition is not a Print Edition"
    },
    {
      code: 117,
      name: "InvalidMasterEdition",
      msg: "Invalid Master Edition"
    },
    {
      code: 118,
      name: "InvalidPrintEdition",
      msg: "Invalid Print Edition"
    },
    {
      code: 119,
      name: "InvalidEditionMarker",
      msg: "Invalid Edition Marker"
    },
    {
      code: 120,
      name: "ReservationListDeprecated",
      msg: "Reservation List is Deprecated"
    },
    {
      code: 121,
      name: "PrintEditionDoesNotMatchMasterEdition",
      msg: "Print Edition does not match Master Edition"
    },
    {
      code: 122,
      name: "EditionNumberGreaterThanMaxSupply",
      msg: "Edition Number greater than max supply"
    },
    {
      code: 123,
      name: "MustUnverify",
      msg: "Must unverify before migrating collections."
    },
    {
      code: 124,
      name: "InvalidEscrowBumpSeed",
      msg: "Invalid Escrow Account Bump Seed"
    },
    {
      code: 125,
      name: "MustBeEscrowAuthority",
      msg: "Must Escrow Authority"
    },
    {
      code: 126,
      name: "InvalidSystemProgram",
      msg: "Invalid System Program"
    },
    {
      code: 127,
      name: "MustBeNonFungible",
      msg: "Must be a Non Fungible Token"
    },
    {
      code: 128,
      name: "InsufficientTokens",
      msg: "Insufficient tokens for transfer"
    },
    {
      code: 129,
      name: "BorshSerializationError",
      msg: "Borsh Serialization Error"
    },
    {
      code: 130,
      name: "NoFreezeAuthoritySet",
      msg: "Cannot create NFT with no Freeze Authority."
    },
    {
      code: 131,
      name: "InvalidCollectionSizeChange",
      msg: "Invalid collection size change"
    },
    {
      code: 132,
      name: "InvalidBubblegumSigner",
      msg: "Invalid bubblegum signer"
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    binaryVersion: "0.0.11",
    libVersion: "0.0.11"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v170.ts
var TokenMetadataV170IDL = {
  version: "1.7.0",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list.",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: true,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA If present the program Assumes a delegated use authority",
          optional: true
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)",
          optional: true
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "delegateAuthority",
          isMut: true,
          isSigner: false,
          desc: "Delegated Collection Authority"
        },
        {
          name: "revokeAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority, or Delegated Authority, of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "BurnNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the NFT"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "VerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "UnverifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "SetAndVerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "CreateMetadataAccountV3",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV3",
          type: {
            defined: "CreateMetadataAccountArgsV3"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "SetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "SetTokenStandard",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Metadata update authority"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "BubblegumSetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "bubblegumSigner",
          isMut: false,
          isSigner: true,
          desc: "Signing PDA of Bubblegum program"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 36
      }
    },
    {
      name: "BurnEditionNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "printEditionMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the print edition NFT"
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the original/master NFT"
        },
        {
          name: "printEditionTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account the print edition NFT is in"
        },
        {
          name: "masterEditionTokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account the Master Edition NFT is in"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the original NFT"
        },
        {
          name: "printEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "Print Edition account of the NFT"
        },
        {
          name: "editionMarkerAccount",
          isMut: true,
          isSigner: false,
          desc: "Edition Marker PDA of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 37
      }
    },
    {
      name: "CreateEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account of the token"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 38
      }
    },
    {
      name: "CloseEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 39
      }
    },
    {
      name: "TransferOutOfEscrow",
      accounts: [
        {
          name: "escrow",
          isMut: false,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "attributeMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account for the new attribute"
        },
        {
          name: "attributeSrc",
          isMut: true,
          isSigner: false,
          desc: "Token account source for the new attribute"
        },
        {
          name: "attributeDst",
          isMut: true,
          isSigner: false,
          desc: "Token account, owned by TM, destination for the new attribute"
        },
        {
          name: "escrowMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account that the escrow is attached"
        },
        {
          name: "escrowAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account that holds the token the escrow is attached to"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferOutOfEscrowArgs",
          type: {
            defined: "TransferOutOfEscrowArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 40
      }
    },
    {
      name: "Burn",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Asset owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition of the asset"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        }
      ],
      args: [
        {
          name: "burnArgs",
          type: {
            defined: "BurnArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 41
      }
    },
    {
      name: "Create",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Unallocated metadata account with address as pda of ['metadata', program id, mint id]"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition account with address as pda of ['metadata', program id, mint, 'edition']",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority for the metadata account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        }
      ],
      args: [
        {
          name: "createArgs",
          type: {
            defined: "CreateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 42
      }
    },
    {
      name: "Mint",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token or Associated Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Owner of the token account",
          optional: true
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "(Mint or Update) authority"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Metadata delegate record",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "mintArgs",
          type: {
            defined: "MintArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 43
      }
    },
    {
      name: "Delegate",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "delegateArgs",
          type: {
            defined: "DelegateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 44
      }
    },
    {
      name: "Revoke",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "revokeArgs",
          type: {
            defined: "RevokeArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 45
      }
    },
    {
      name: "Lock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "lockArgs",
          type: {
            defined: "LockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 46
      }
    },
    {
      name: "Unlock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "unlockArgs",
          type: {
            defined: "UnlockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 47
      }
    },
    {
      name: "Migrate",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "collectionMetadata",
          isMut: false,
          isSigner: false,
          desc: "Collection metadata account"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record account"
        },
        {
          name: "tokenRecord",
          isMut: false,
          isSigner: false,
          desc: "Token record account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instruction sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "migrateArgs",
          type: {
            defined: "MigrateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 48
      }
    },
    {
      name: "Transfer",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination token account"
        },
        {
          name: "destinationOwner",
          isMut: false,
          isSigner: false,
          desc: "Destination token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition of token asset",
          optional: true
        },
        {
          name: "ownerTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "destinationTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Transfer authority (token or delegate owner)"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferArgs",
          type: {
            defined: "TransferArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 49
      }
    },
    {
      name: "Update",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "updateArgs",
          type: {
            defined: "UpdateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 50
      }
    },
    {
      name: "Use",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Token owner or delegate"
        },
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "useArgs",
          type: {
            defined: "UseArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 51
      }
    },
    {
      name: "Verify",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        }
      ],
      args: [
        {
          name: "verifyArgs",
          type: {
            defined: "VerifyArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 52
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "programmableConfig",
            type: {
              option: {
                defined: "ProgrammableConfig"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "TokenOwnedEscrow",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "baseToken",
            type: "publicKey"
          },
          {
            name: "authority",
            type: {
              defined: "EscrowAuthority"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "TokenRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "state",
            type: {
              defined: "TokenState"
            }
          },
          {
            name: "ruleSetRevision",
            type: {
              option: "u64"
            }
          },
          {
            name: "delegate",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "delegateRole",
            type: {
              option: {
                defined: "TokenDelegateRole"
              }
            }
          },
          {
            name: "lockedTransfer",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "delegate",
            type: "publicKey"
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "SetCollectionSizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "size",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "TransferOutOfEscrowArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV3",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "AuthorizationData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "payload",
            type: {
              defined: "Payload"
            }
          }
        ]
      }
    },
    {
      name: "AssetData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "tokenStandard",
            type: {
              defined: "TokenStandard"
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "ruleSet",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "SeedsVec",
      type: {
        kind: "struct",
        fields: [
          {
            name: "seeds",
            type: {
              vec: "bytes"
            }
          }
        ]
      }
    },
    {
      name: "LeafInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "leaf",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "proof",
            type: {
              vec: {
                array: ["u8", 32]
              }
            }
          }
        ]
      }
    },
    {
      name: "Payload",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: {
              hashMap: [
                {
                  defined: "PayloadKey"
                },
                {
                  defined: "PayloadType"
                }
              ]
            }
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "BurnArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "VerifyArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "DelegateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "SaleV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "TransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "UpdateV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "UtilityV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StakingV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StandardV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              }
            ]
          },
          {
            name: "LockedTransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "locked_address",
                type: "publicKey"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "RevokeArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "SaleV1"
          },
          {
            name: "TransferV1"
          },
          {
            name: "UpdateV1"
          },
          {
            name: "UtilityV1"
          },
          {
            name: "StakingV1"
          },
          {
            name: "StandardV1"
          },
          {
            name: "LockedTransferV1"
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Authority"
          },
          {
            name: "Collection"
          },
          {
            name: "Use"
          },
          {
            name: "Update"
          }
        ]
      }
    },
    {
      name: "CreateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "asset_data",
                type: {
                  defined: "AssetData"
                }
              },
              {
                name: "decimals",
                type: {
                  option: "u8"
                }
              },
              {
                name: "print_supply",
                type: {
                  option: {
                    defined: "PrintSupply"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MintArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "TransferArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UpdateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "collection_details",
                type: {
                  defined: "CollectionDetailsToggle"
                }
              },
              {
                name: "uses",
                type: {
                  defined: "UsesToggle"
                }
              },
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Collection"
              }
            ]
          }
        ]
      }
    },
    {
      name: "UsesToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Uses"
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionDetailsToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "CollectionDetails"
              }
            ]
          }
        ]
      }
    },
    {
      name: "RuleSetToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "MigrateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "migration_type",
                type: {
                  defined: "MigrationType"
                }
              },
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "LockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UnlockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UseArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          },
          {
            name: "ProgrammableNonFungible"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          },
          {
            name: "TokenOwnedEscrow"
          },
          {
            name: "TokenRecord"
          },
          {
            name: "MetadataDelegate"
          }
        ]
      }
    },
    {
      name: "CollectionDetails",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "size",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "EscrowAuthority",
      type: {
        kind: "enum",
        variants: [
          {
            name: "TokenOwner"
          },
          {
            name: "Creator",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "PrintSupply",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Zero"
          },
          {
            name: "Limited",
            fields: ["u64"]
          },
          {
            name: "Unlimited"
          }
        ]
      }
    },
    {
      name: "ProgrammableConfig",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MigrationType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "ProgrammableV1"
          }
        ]
      }
    },
    {
      name: "TokenState",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Unlocked"
          },
          {
            name: "Locked"
          },
          {
            name: "Listed"
          }
        ]
      }
    },
    {
      name: "TokenDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Sale"
          },
          {
            name: "Transfer"
          },
          {
            name: "Utility"
          },
          {
            name: "Staking"
          },
          {
            name: "Standard"
          },
          {
            name: "LockedTransfer"
          },
          {
            name: "Migration"
          }
        ]
      }
    },
    {
      name: "AuthorityType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Metadata"
          },
          {
            name: "Delegate"
          },
          {
            name: "Holder"
          }
        ]
      }
    },
    {
      name: "PayloadType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Pubkey",
            fields: ["publicKey"]
          },
          {
            name: "Seeds",
            fields: [
              {
                defined: "SeedsVec"
              }
            ]
          },
          {
            name: "MerkleProof",
            fields: [
              {
                defined: "LeafInfo"
              }
            ]
          },
          {
            name: "Number",
            fields: ["u64"]
          }
        ]
      }
    },
    {
      name: "PayloadKey",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Target"
          },
          {
            name: "Holder"
          },
          {
            name: "Authority"
          },
          {
            name: "Amount"
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: "Failed to unpack instruction data"
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: "Failed to pack instruction data"
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: "Update authority must be equivalent to the metadata's authority and also signer of this transaction"
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: "Maximum editions printed already"
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: "Token mint to failed"
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: "The master edition record passed must match the master record on the edition given"
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: "The destination account does not have the right mint"
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: "An edition can only mint one of its kind!"
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: "Printing mint decimals should be zero"
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: "OneTimePrintingAuthorization mint decimals should be zero"
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: "Token burn failed"
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: "The One Time authorization mint does not match that on the token account!"
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: "The mint on your authorization token holding account does not match your Printing mint!"
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: "The authorization token account has a different owner than the update authority for the master edition!"
    },
    {
      code: 35,
      name: "Disabled",
      msg: "This feature is currently disabled."
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: "If using a creators array, you must be one of the creators listed"
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: "This reservation list already exists!"
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: "This reservation list does not exist!"
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: "This reservation list exists but was never set with reservations"
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: "This reservation list has already been set!"
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: "Provided more addresses than max allowed in single reservation"
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: "This reservation would go beyond the maximum supply of the master edition!"
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: "Address not in reservation!"
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: "In initial reservation setting, spots remaining should equal total spots"
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: "printing these tokens would breach the maximum supply limit of the master edition"
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: "Reservation spots remaining should match total spots when first being created"
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: "Beyond alotted address size in reservation!"
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: "The reservation has only been partially alotted"
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: "You cannot splice over an existing reservation!"
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: "In the legacy system the reservation needs to be of size one for cpu limit reasons"
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Collection cannot be verified in this instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: "This token use method is burn and there are no remaining uses, it must be burned"
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: "This Collection Authority Record is invalid."
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: "Creator can not be adjusted once they are verified."
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: "Can not wipe verified creators."
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: "Not allowed to change seller fee basis points."
    },
    {
      code: 97,
      name: "EditionOverrideCannotBeZero",
      msg: "Edition override cannot be zero"
    },
    {
      code: 98,
      name: "InvalidUser",
      msg: "Invalid User"
    },
    {
      code: 99,
      name: "RevokeCollectionAuthoritySignerIncorrect",
      msg: "Revoke Collection Authority signer is incorrect"
    },
    {
      code: 100,
      name: "TokenCloseFailed",
      msg: "Token close failed"
    },
    {
      code: 101,
      name: "UnsizedCollection",
      msg: "Can't use this function on unsized collection"
    },
    {
      code: 102,
      name: "SizedCollection",
      msg: "Can't use this function on a sized collection"
    },
    {
      code: 103,
      name: "MissingCollectionMetadata",
      msg: "Can't burn a verified member of a collection w/o providing collection metadata account"
    },
    {
      code: 104,
      name: "NotAMemberOfCollection",
      msg: "This NFT is not a member of the specified collection."
    },
    {
      code: 105,
      name: "NotVerifiedMemberOfCollection",
      msg: "This NFT is not a verified member of the specified collection."
    },
    {
      code: 106,
      name: "NotACollectionParent",
      msg: "This NFT is not a collection parent NFT."
    },
    {
      code: 107,
      name: "CouldNotDetermineTokenStandard",
      msg: "Could not determine a TokenStandard type."
    },
    {
      code: 108,
      name: "MissingEditionAccount",
      msg: "This mint account has an edition but none was provided."
    },
    {
      code: 109,
      name: "NotAMasterEdition",
      msg: "This edition is not a Master Edition"
    },
    {
      code: 110,
      name: "MasterEditionHasPrints",
      msg: "This Master Edition has existing prints"
    },
    {
      code: 111,
      name: "BorshDeserializationError",
      msg: "Borsh Deserialization Error"
    },
    {
      code: 112,
      name: "CannotUpdateVerifiedCollection",
      msg: "Cannot update a verified collection in this command"
    },
    {
      code: 113,
      name: "CollectionMasterEditionAccountInvalid",
      msg: "Edition account doesnt match collection "
    },
    {
      code: 114,
      name: "AlreadyVerified",
      msg: "Item is already verified."
    },
    {
      code: 115,
      name: "AlreadyUnverified",
      msg: "Item is already unverified."
    },
    {
      code: 116,
      name: "NotAPrintEdition",
      msg: "This edition is not a Print Edition"
    },
    {
      code: 117,
      name: "InvalidMasterEdition",
      msg: "Invalid Master Edition"
    },
    {
      code: 118,
      name: "InvalidPrintEdition",
      msg: "Invalid Print Edition"
    },
    {
      code: 119,
      name: "InvalidEditionMarker",
      msg: "Invalid Edition Marker"
    },
    {
      code: 120,
      name: "ReservationListDeprecated",
      msg: "Reservation List is Deprecated"
    },
    {
      code: 121,
      name: "PrintEditionDoesNotMatchMasterEdition",
      msg: "Print Edition does not match Master Edition"
    },
    {
      code: 122,
      name: "EditionNumberGreaterThanMaxSupply",
      msg: "Edition Number greater than max supply"
    },
    {
      code: 123,
      name: "MustUnverify",
      msg: "Must unverify before migrating collections."
    },
    {
      code: 124,
      name: "InvalidEscrowBumpSeed",
      msg: "Invalid Escrow Account Bump Seed"
    },
    {
      code: 125,
      name: "MustBeEscrowAuthority",
      msg: "Must Escrow Authority"
    },
    {
      code: 126,
      name: "InvalidSystemProgram",
      msg: "Invalid System Program"
    },
    {
      code: 127,
      name: "MustBeNonFungible",
      msg: "Must be a Non Fungible Token"
    },
    {
      code: 128,
      name: "InsufficientTokens",
      msg: "Insufficient tokens for transfer"
    },
    {
      code: 129,
      name: "BorshSerializationError",
      msg: "Borsh Serialization Error"
    },
    {
      code: 130,
      name: "NoFreezeAuthoritySet",
      msg: "Cannot create NFT with no Freeze Authority."
    },
    {
      code: 131,
      name: "InvalidCollectionSizeChange",
      msg: "Invalid collection size change"
    },
    {
      code: 132,
      name: "InvalidBubblegumSigner",
      msg: "Invalid bubblegum signer"
    },
    {
      code: 133,
      name: "EscrowParentHasDelegate",
      msg: "Escrow parent cannot have a delegate"
    },
    {
      code: 134,
      name: "MintIsNotSigner",
      msg: "Mint needs to be signer to initialize the account"
    },
    {
      code: 135,
      name: "InvalidTokenStandard",
      msg: "Invalid token standard"
    },
    {
      code: 136,
      name: "InvalidMintForTokenStandard",
      msg: "Invalid mint account for specified token standard"
    },
    {
      code: 137,
      name: "InvalidAuthorizationRules",
      msg: "Invalid authorization rules account"
    },
    {
      code: 138,
      name: "MissingAuthorizationRules",
      msg: "Missing authorization rules account"
    },
    {
      code: 139,
      name: "MissingProgrammableConfig",
      msg: "Missing programmable configuration"
    },
    {
      code: 140,
      name: "InvalidProgrammableConfig",
      msg: "Invalid programmable configuration"
    },
    {
      code: 141,
      name: "DelegateAlreadyExists",
      msg: "Delegate already exists"
    },
    {
      code: 142,
      name: "DelegateNotFound",
      msg: "Delegate not found"
    },
    {
      code: 143,
      name: "MissingAccountInBuilder",
      msg: "Required account not set in instruction builder"
    },
    {
      code: 144,
      name: "MissingArgumentInBuilder",
      msg: "Required argument not set in instruction builder"
    },
    {
      code: 145,
      name: "FeatureNotSupported",
      msg: "Feature not supported currently"
    },
    {
      code: 146,
      name: "InvalidSystemWallet",
      msg: "Invalid system wallet"
    },
    {
      code: 147,
      name: "OnlySaleDelegateCanTransfer",
      msg: "Only the sale delegate can transfer while its set"
    },
    {
      code: 148,
      name: "MissingTokenAccount",
      msg: "Missing token account"
    },
    {
      code: 149,
      name: "MissingSplTokenProgram",
      msg: "Missing SPL token program"
    },
    {
      code: 150,
      name: "MissingAuthorizationRulesProgram",
      msg: "Missing authorization rules program"
    },
    {
      code: 151,
      name: "InvalidDelegateRoleForTransfer",
      msg: "Invalid delegate role for transfer"
    },
    {
      code: 152,
      name: "InvalidTransferAuthority",
      msg: "Invalid transfer authority"
    },
    {
      code: 153,
      name: "InstructionNotSupported",
      msg: "Instruction not supported for ProgrammableNonFungible assets"
    },
    {
      code: 154,
      name: "KeyMismatch",
      msg: "Public key does not match expected value"
    },
    {
      code: 155,
      name: "LockedToken",
      msg: "Token is locked"
    },
    {
      code: 156,
      name: "UnlockedToken",
      msg: "Token is unlocked"
    },
    {
      code: 157,
      name: "MissingDelegateRole",
      msg: "Missing delegate role"
    },
    {
      code: 158,
      name: "InvalidAuthorityType",
      msg: "Invalid authority type"
    },
    {
      code: 159,
      name: "MissingTokenRecord",
      msg: "Missing token record account"
    },
    {
      code: 160,
      name: "MintSupplyMustBeZero",
      msg: "Mint supply must be zero for programmable assets"
    },
    {
      code: 161,
      name: "DataIsEmptyOrZeroed",
      msg: "Data is empty or zeroed"
    },
    {
      code: 162,
      name: "MissingTokenOwnerAccount",
      msg: "Missing token owner"
    },
    {
      code: 163,
      name: "InvalidMasterEditionAccountLength",
      msg: "Master edition account has an invalid length"
    },
    {
      code: 164,
      name: "IncorrectTokenState",
      msg: "Incorrect token state"
    },
    {
      code: 165,
      name: "InvalidDelegateRole",
      msg: "Invalid delegate role"
    },
    {
      code: 166,
      name: "MissingPrintSupply",
      msg: "Print supply is required for non-fungibles"
    },
    {
      code: 167,
      name: "MissingMasterEditionAccount",
      msg: "Missing master edition account"
    },
    {
      code: 168,
      name: "AmountMustBeGreaterThanZero",
      msg: "Amount must be greater than zero"
    },
    {
      code: 169,
      name: "InvalidDelegateArgs",
      msg: "Invalid delegate args"
    },
    {
      code: 170,
      name: "MissingLockedTransferAddress",
      msg: "Missing address for locked transfer"
    },
    {
      code: 171,
      name: "InvalidLockedTransferAddress",
      msg: "Invalid destination address for locked transfer"
    },
    {
      code: 172,
      name: "DataIncrementLimitExceeded",
      msg: "Exceeded account realloc increase limit"
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    binaryVersion: "0.0.11",
    libVersion: "0.0.11"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v170beta2.ts
var TokenMetadataV170Beta2IDL = {
  version: "1.7.0-beta.2",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list.",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: true,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA If present the program Assumes a delegated use authority",
          optional: true
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)",
          optional: true
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "delegateAuthority",
          isMut: true,
          isSigner: false,
          desc: "Delegated Collection Authority"
        },
        {
          name: "revokeAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority, or Delegated Authority, of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "BurnNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the NFT"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "VerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "UnverifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "SetAndVerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "CreateMetadataAccountV3",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV3",
          type: {
            defined: "CreateMetadataAccountArgsV3"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "SetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "SetTokenStandard",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Metadata update authority"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "BubblegumSetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "bubblegumSigner",
          isMut: false,
          isSigner: true,
          desc: "Signing PDA of Bubblegum program"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 36
      }
    },
    {
      name: "BurnEditionNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "printEditionMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the print edition NFT"
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the original/master NFT"
        },
        {
          name: "printEditionTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account the print edition NFT is in"
        },
        {
          name: "masterEditionTokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account the Master Edition NFT is in"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the original NFT"
        },
        {
          name: "printEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "Print Edition account of the NFT"
        },
        {
          name: "editionMarkerAccount",
          isMut: true,
          isSigner: false,
          desc: "Edition Marker PDA of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 37
      }
    },
    {
      name: "CreateEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account of the token"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 38
      }
    },
    {
      name: "CloseEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 39
      }
    },
    {
      name: "TransferOutOfEscrow",
      accounts: [
        {
          name: "escrow",
          isMut: false,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "attributeMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account for the new attribute"
        },
        {
          name: "attributeSrc",
          isMut: true,
          isSigner: false,
          desc: "Token account source for the new attribute"
        },
        {
          name: "attributeDst",
          isMut: true,
          isSigner: false,
          desc: "Token account, owned by TM, destination for the new attribute"
        },
        {
          name: "escrowMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account that the escrow is attached"
        },
        {
          name: "escrowAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account that holds the token the escrow is attached to"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferOutOfEscrowArgs",
          type: {
            defined: "TransferOutOfEscrowArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 40
      }
    },
    {
      name: "Burn",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Asset owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition of the asset"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        }
      ],
      args: [
        {
          name: "burnArgs",
          type: {
            defined: "BurnArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 41
      }
    },
    {
      name: "Create",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Unallocated metadata account with address as pda of ['metadata', program id, mint id]"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition account with address as pda of ['metadata', program id, mint, 'edition']",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority for the metadata account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        }
      ],
      args: [
        {
          name: "createArgs",
          type: {
            defined: "CreateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 42
      }
    },
    {
      name: "Mint",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token or Associated Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Owner of the token account",
          optional: true
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "(Mint or Update) authority"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Metadata delegate record",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "mintArgs",
          type: {
            defined: "MintArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 43
      }
    },
    {
      name: "Delegate",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "delegateArgs",
          type: {
            defined: "DelegateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 44
      }
    },
    {
      name: "Revoke",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "revokeArgs",
          type: {
            defined: "RevokeArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 45
      }
    },
    {
      name: "Lock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "lockArgs",
          type: {
            defined: "LockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 46
      }
    },
    {
      name: "Unlock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "unlockArgs",
          type: {
            defined: "UnlockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 47
      }
    },
    {
      name: "Migrate",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "collectionMetadata",
          isMut: false,
          isSigner: false,
          desc: "Collection metadata account"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record account"
        },
        {
          name: "tokenRecord",
          isMut: false,
          isSigner: false,
          desc: "Token record account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instruction sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "migrateArgs",
          type: {
            defined: "MigrateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 48
      }
    },
    {
      name: "Transfer",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination token account"
        },
        {
          name: "destinationOwner",
          isMut: false,
          isSigner: false,
          desc: "Destination token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition of token asset",
          optional: true
        },
        {
          name: "ownerTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "destinationTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Transfer authority (token or delegate owner)"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferArgs",
          type: {
            defined: "TransferArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 49
      }
    },
    {
      name: "Update",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "updateArgs",
          type: {
            defined: "UpdateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 50
      }
    },
    {
      name: "Use",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Token owner or delegate"
        },
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "useArgs",
          type: {
            defined: "UseArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 51
      }
    },
    {
      name: "Verify",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        }
      ],
      args: [
        {
          name: "verifyArgs",
          type: {
            defined: "VerifyArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 52
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "programmableConfig",
            type: {
              option: {
                defined: "ProgrammableConfig"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "TokenOwnedEscrow",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "baseToken",
            type: "publicKey"
          },
          {
            name: "authority",
            type: {
              defined: "EscrowAuthority"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "TokenRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "state",
            type: {
              defined: "TokenState"
            }
          },
          {
            name: "ruleSetRevision",
            type: {
              option: "u64"
            }
          },
          {
            name: "delegate",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "delegateRole",
            type: {
              option: {
                defined: "TokenDelegateRole"
              }
            }
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "delegate",
            type: "publicKey"
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "SetCollectionSizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "size",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "TransferOutOfEscrowArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV3",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "AuthorizationData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "payload",
            type: {
              defined: "Payload"
            }
          }
        ]
      }
    },
    {
      name: "AssetData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "tokenStandard",
            type: {
              defined: "TokenStandard"
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "ruleSet",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "SeedsVec",
      type: {
        kind: "struct",
        fields: [
          {
            name: "seeds",
            type: {
              vec: "bytes"
            }
          }
        ]
      }
    },
    {
      name: "LeafInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "leaf",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "proof",
            type: {
              vec: {
                array: ["u8", 32]
              }
            }
          }
        ]
      }
    },
    {
      name: "Payload",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: {
              hashMap: [
                {
                  defined: "PayloadKey"
                },
                {
                  defined: "PayloadType"
                }
              ]
            }
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "BurnArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "VerifyArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "DelegateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "SaleV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "TransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "UpdateV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "UtilityV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StakingV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StandardV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "RevokeArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "SaleV1"
          },
          {
            name: "TransferV1"
          },
          {
            name: "UpdateV1"
          },
          {
            name: "UtilityV1"
          },
          {
            name: "StakingV1"
          },
          {
            name: "StandardV1"
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Authority"
          },
          {
            name: "Collection"
          },
          {
            name: "Use"
          },
          {
            name: "Update"
          }
        ]
      }
    },
    {
      name: "CreateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "asset_data",
                type: {
                  defined: "AssetData"
                }
              },
              {
                name: "decimals",
                type: {
                  option: "u8"
                }
              },
              {
                name: "print_supply",
                type: {
                  option: {
                    defined: "PrintSupply"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MintArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "TransferArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UpdateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "collection_details",
                type: {
                  defined: "CollectionDetailsToggle"
                }
              },
              {
                name: "uses",
                type: {
                  defined: "UsesToggle"
                }
              },
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Collection"
              }
            ]
          }
        ]
      }
    },
    {
      name: "UsesToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Uses"
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionDetailsToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "CollectionDetails"
              }
            ]
          }
        ]
      }
    },
    {
      name: "RuleSetToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "MigrateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "migration_type",
                type: {
                  defined: "MigrationType"
                }
              },
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "LockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UnlockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UseArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          },
          {
            name: "ProgrammableNonFungible"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          },
          {
            name: "TokenOwnedEscrow"
          },
          {
            name: "TokenRecord"
          },
          {
            name: "MetadataDelegate"
          }
        ]
      }
    },
    {
      name: "CollectionDetails",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "size",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "EscrowAuthority",
      type: {
        kind: "enum",
        variants: [
          {
            name: "TokenOwner"
          },
          {
            name: "Creator",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "PrintSupply",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Zero"
          },
          {
            name: "Limited",
            fields: ["u64"]
          },
          {
            name: "Unlimited"
          }
        ]
      }
    },
    {
      name: "ProgrammableConfig",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MigrationType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "ProgrammableV1"
          }
        ]
      }
    },
    {
      name: "TokenState",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Unlocked"
          },
          {
            name: "Locked"
          },
          {
            name: "Listed"
          }
        ]
      }
    },
    {
      name: "TokenDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Sale"
          },
          {
            name: "Transfer"
          },
          {
            name: "Utility"
          },
          {
            name: "Staking"
          },
          {
            name: "Standard"
          },
          {
            name: "Migration"
          }
        ]
      }
    },
    {
      name: "AuthorityType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Metadata"
          },
          {
            name: "Delegate"
          },
          {
            name: "Holder"
          }
        ]
      }
    },
    {
      name: "PayloadType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Pubkey",
            fields: ["publicKey"]
          },
          {
            name: "Seeds",
            fields: [
              {
                defined: "SeedsVec"
              }
            ]
          },
          {
            name: "MerkleProof",
            fields: [
              {
                defined: "LeafInfo"
              }
            ]
          },
          {
            name: "Number",
            fields: ["u64"]
          }
        ]
      }
    },
    {
      name: "PayloadKey",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Target"
          },
          {
            name: "Holder"
          },
          {
            name: "Authority"
          },
          {
            name: "Amount"
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: "Failed to unpack instruction data"
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: "Failed to pack instruction data"
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: "Update authority must be equivalent to the metadata's authority and also signer of this transaction"
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: "Maximum editions printed already"
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: "Token mint to failed"
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: "The master edition record passed must match the master record on the edition given"
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: "The destination account does not have the right mint"
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: "An edition can only mint one of its kind!"
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: "Printing mint decimals should be zero"
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: "OneTimePrintingAuthorization mint decimals should be zero"
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: "Token burn failed"
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: "The One Time authorization mint does not match that on the token account!"
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: "The mint on your authorization token holding account does not match your Printing mint!"
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: "The authorization token account has a different owner than the update authority for the master edition!"
    },
    {
      code: 35,
      name: "Disabled",
      msg: "This feature is currently disabled."
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: "If using a creators array, you must be one of the creators listed"
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: "This reservation list already exists!"
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: "This reservation list does not exist!"
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: "This reservation list exists but was never set with reservations"
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: "This reservation list has already been set!"
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: "Provided more addresses than max allowed in single reservation"
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: "This reservation would go beyond the maximum supply of the master edition!"
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: "Address not in reservation!"
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: "In initial reservation setting, spots remaining should equal total spots"
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: "printing these tokens would breach the maximum supply limit of the master edition"
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: "Reservation spots remaining should match total spots when first being created"
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: "Beyond alotted address size in reservation!"
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: "The reservation has only been partially alotted"
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: "You cannot splice over an existing reservation!"
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: "In the legacy system the reservation needs to be of size one for cpu limit reasons"
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Collection cannot be verified in this instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: "This token use method is burn and there are no remaining uses, it must be burned"
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: "This Collection Authority Record is invalid."
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: "Creator can not be adjusted once they are verified."
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: "Can not wipe verified creators."
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: "Not allowed to change seller fee basis points."
    },
    {
      code: 97,
      name: "EditionOverrideCannotBeZero",
      msg: "Edition override cannot be zero"
    },
    {
      code: 98,
      name: "InvalidUser",
      msg: "Invalid User"
    },
    {
      code: 99,
      name: "RevokeCollectionAuthoritySignerIncorrect",
      msg: "Revoke Collection Authority signer is incorrect"
    },
    {
      code: 100,
      name: "TokenCloseFailed",
      msg: "Token close failed"
    },
    {
      code: 101,
      name: "UnsizedCollection",
      msg: "Can't use this function on unsized collection"
    },
    {
      code: 102,
      name: "SizedCollection",
      msg: "Can't use this function on a sized collection"
    },
    {
      code: 103,
      name: "MissingCollectionMetadata",
      msg: "Can't burn a verified member of a collection w/o providing collection metadata account"
    },
    {
      code: 104,
      name: "NotAMemberOfCollection",
      msg: "This NFT is not a member of the specified collection."
    },
    {
      code: 105,
      name: "NotVerifiedMemberOfCollection",
      msg: "This NFT is not a verified member of the specified collection."
    },
    {
      code: 106,
      name: "NotACollectionParent",
      msg: "This NFT is not a collection parent NFT."
    },
    {
      code: 107,
      name: "CouldNotDetermineTokenStandard",
      msg: "Could not determine a TokenStandard type."
    },
    {
      code: 108,
      name: "MissingEditionAccount",
      msg: "This mint account has an edition but none was provided."
    },
    {
      code: 109,
      name: "NotAMasterEdition",
      msg: "This edition is not a Master Edition"
    },
    {
      code: 110,
      name: "MasterEditionHasPrints",
      msg: "This Master Edition has existing prints"
    },
    {
      code: 111,
      name: "BorshDeserializationError",
      msg: "Borsh Deserialization Error"
    },
    {
      code: 112,
      name: "CannotUpdateVerifiedCollection",
      msg: "Cannot update a verified collection in this command"
    },
    {
      code: 113,
      name: "CollectionMasterEditionAccountInvalid",
      msg: "Edition account doesnt match collection "
    },
    {
      code: 114,
      name: "AlreadyVerified",
      msg: "Item is already verified."
    },
    {
      code: 115,
      name: "AlreadyUnverified",
      msg: "Item is already unverified."
    },
    {
      code: 116,
      name: "NotAPrintEdition",
      msg: "This edition is not a Print Edition"
    },
    {
      code: 117,
      name: "InvalidMasterEdition",
      msg: "Invalid Master Edition"
    },
    {
      code: 118,
      name: "InvalidPrintEdition",
      msg: "Invalid Print Edition"
    },
    {
      code: 119,
      name: "InvalidEditionMarker",
      msg: "Invalid Edition Marker"
    },
    {
      code: 120,
      name: "ReservationListDeprecated",
      msg: "Reservation List is Deprecated"
    },
    {
      code: 121,
      name: "PrintEditionDoesNotMatchMasterEdition",
      msg: "Print Edition does not match Master Edition"
    },
    {
      code: 122,
      name: "EditionNumberGreaterThanMaxSupply",
      msg: "Edition Number greater than max supply"
    },
    {
      code: 123,
      name: "MustUnverify",
      msg: "Must unverify before migrating collections."
    },
    {
      code: 124,
      name: "InvalidEscrowBumpSeed",
      msg: "Invalid Escrow Account Bump Seed"
    },
    {
      code: 125,
      name: "MustBeEscrowAuthority",
      msg: "Must Escrow Authority"
    },
    {
      code: 126,
      name: "InvalidSystemProgram",
      msg: "Invalid System Program"
    },
    {
      code: 127,
      name: "MustBeNonFungible",
      msg: "Must be a Non Fungible Token"
    },
    {
      code: 128,
      name: "InsufficientTokens",
      msg: "Insufficient tokens for transfer"
    },
    {
      code: 129,
      name: "BorshSerializationError",
      msg: "Borsh Serialization Error"
    },
    {
      code: 130,
      name: "NoFreezeAuthoritySet",
      msg: "Cannot create NFT with no Freeze Authority."
    },
    {
      code: 131,
      name: "InvalidCollectionSizeChange",
      msg: "Invalid collection size change"
    },
    {
      code: 132,
      name: "InvalidBubblegumSigner",
      msg: "Invalid bubblegum signer"
    },
    {
      code: 133,
      name: "EscrowParentHasDelegate",
      msg: "Escrow parent cannot have a delegate"
    },
    {
      code: 134,
      name: "MintIsNotSigner",
      msg: "Mint needs to be signer to initialize the account"
    },
    {
      code: 135,
      name: "InvalidTokenStandard",
      msg: "Invalid token standard"
    },
    {
      code: 136,
      name: "InvalidMintForTokenStandard",
      msg: "Invalid mint account for specified token standard"
    },
    {
      code: 137,
      name: "InvalidAuthorizationRules",
      msg: "Invalid authorization rules account"
    },
    {
      code: 138,
      name: "MissingAuthorizationRules",
      msg: "Missing authorization rules account"
    },
    {
      code: 139,
      name: "MissingProgrammableConfig",
      msg: "Missing programmable configuration"
    },
    {
      code: 140,
      name: "InvalidProgrammableConfig",
      msg: "Invalid programmable configuration"
    },
    {
      code: 141,
      name: "DelegateAlreadyExists",
      msg: "Delegate already exists"
    },
    {
      code: 142,
      name: "DelegateNotFound",
      msg: "Delegate not found"
    },
    {
      code: 143,
      name: "MissingAccountInBuilder",
      msg: "Required account not set in instruction builder"
    },
    {
      code: 144,
      name: "MissingArgumentInBuilder",
      msg: "Required argument not set in instruction builder"
    },
    {
      code: 145,
      name: "FeatureNotSupported",
      msg: "Feature not supported currently"
    },
    {
      code: 146,
      name: "InvalidSystemWallet",
      msg: "Invalid system wallet"
    },
    {
      code: 147,
      name: "OnlySaleDelegateCanTransfer",
      msg: "Only the sale delegate can transfer while its set"
    },
    {
      code: 148,
      name: "MissingTokenAccount",
      msg: "Missing token account"
    },
    {
      code: 149,
      name: "MissingSplTokenProgram",
      msg: "Missing SPL token program"
    },
    {
      code: 150,
      name: "MissingAuthorizationRulesProgram",
      msg: "Missing authorization rules program"
    },
    {
      code: 151,
      name: "InvalidDelegateRoleForTransfer",
      msg: "Invalid delegate role for transfer"
    },
    {
      code: 152,
      name: "InvalidTransferAuthority",
      msg: "Invalid transfer authority"
    },
    {
      code: 153,
      name: "InstructionNotSupported",
      msg: "Instruction not supported for ProgrammableNonFungible assets"
    },
    {
      code: 154,
      name: "KeyMismatch",
      msg: "Public key does not match expected value"
    },
    {
      code: 155,
      name: "LockedToken",
      msg: "Token is locked"
    },
    {
      code: 156,
      name: "UnlockedToken",
      msg: "Token is unlocked"
    },
    {
      code: 157,
      name: "MissingDelegateRole",
      msg: "Missing delegate role"
    },
    {
      code: 158,
      name: "InvalidAuthorityType",
      msg: "Invalid authority type"
    },
    {
      code: 159,
      name: "MissingTokenRecord",
      msg: "Missing token record account"
    },
    {
      code: 160,
      name: "MintSupplyMustBeZero",
      msg: "Mint supply must be zero for programmable assets"
    },
    {
      code: 161,
      name: "DataIsEmptyOrZeroed",
      msg: "Data is empty or zeroed"
    },
    {
      code: 162,
      name: "MissingTokenOwnerAccount",
      msg: "Missing token owner"
    },
    {
      code: 163,
      name: "InvalidMasterEditionAccountLength",
      msg: "Master edition account has an invalid length"
    },
    {
      code: 164,
      name: "IncorrectTokenState",
      msg: "Incorrect token state"
    },
    {
      code: 165,
      name: "InvalidDelegateRole",
      msg: "Invalid delegate role"
    },
    {
      code: 166,
      name: "MissingPrintSupply",
      msg: "Print supply is required for non-fungibles"
    },
    {
      code: 167,
      name: "MissingMasterEditionAccount",
      msg: "Missing master edition account"
    },
    {
      code: 168,
      name: "AmountMustBeGreaterThanZero",
      msg: "Amount must be greater than zero"
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    binaryVersion: "0.0.11",
    libVersion: "0.0.11"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v1100.ts
var TokenMetadataV1100IDL = {
  version: "1.10.0",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list.",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: true,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA If present the program Assumes a delegated use authority",
          optional: true
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)",
          optional: true
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "delegateAuthority",
          isMut: true,
          isSigner: false,
          desc: "Delegated Collection Authority"
        },
        {
          name: "revokeAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority, or Delegated Authority, of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "BurnNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the NFT"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "VerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "UnverifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "SetAndVerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "CreateMetadataAccountV3",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV3",
          type: {
            defined: "CreateMetadataAccountArgsV3"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "SetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "SetTokenStandard",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Metadata update authority"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "BubblegumSetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "bubblegumSigner",
          isMut: false,
          isSigner: true,
          desc: "Signing PDA of Bubblegum program"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 36
      }
    },
    {
      name: "BurnEditionNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "printEditionMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the print edition NFT"
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the original/master NFT"
        },
        {
          name: "printEditionTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account the print edition NFT is in"
        },
        {
          name: "masterEditionTokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account the Master Edition NFT is in"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the original NFT"
        },
        {
          name: "printEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "Print Edition account of the NFT"
        },
        {
          name: "editionMarkerAccount",
          isMut: true,
          isSigner: false,
          desc: "Edition Marker PDA of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 37
      }
    },
    {
      name: "CreateEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account of the token"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 38
      }
    },
    {
      name: "CloseEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 39
      }
    },
    {
      name: "TransferOutOfEscrow",
      accounts: [
        {
          name: "escrow",
          isMut: false,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "attributeMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account for the new attribute"
        },
        {
          name: "attributeSrc",
          isMut: true,
          isSigner: false,
          desc: "Token account source for the new attribute"
        },
        {
          name: "attributeDst",
          isMut: true,
          isSigner: false,
          desc: "Token account, owned by TM, destination for the new attribute"
        },
        {
          name: "escrowMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account that the escrow is attached"
        },
        {
          name: "escrowAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account that holds the token the escrow is attached to"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferOutOfEscrowArgs",
          type: {
            defined: "TransferOutOfEscrowArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 40
      }
    },
    {
      name: "Burn",
      accounts: [
        {
          name: "authority",
          isMut: true,
          isSigner: true,
          desc: "Asset owner or Utility delegate"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition of the asset",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master edition account",
          optional: true
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Master edition mint of the asset",
          optional: true
        },
        {
          name: "masterEditionToken",
          isMut: false,
          isSigner: false,
          desc: "Master edition token account",
          optional: true
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition marker account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [
        {
          name: "burnArgs",
          type: {
            defined: "BurnArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 41
      }
    },
    {
      name: "Create",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Unallocated metadata account with address as pda of ['metadata', program id, mint id]"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition account with address as pda of ['metadata', program id, mint, 'edition']",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority for the metadata account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        }
      ],
      args: [
        {
          name: "createArgs",
          type: {
            defined: "CreateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 42
      }
    },
    {
      name: "Mint",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token or Associated Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Owner of the token account",
          optional: true
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "(Mint or Update) authority"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Metadata delegate record",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "mintArgs",
          type: {
            defined: "MintArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 43
      }
    },
    {
      name: "Delegate",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "delegateArgs",
          type: {
            defined: "DelegateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 44
      }
    },
    {
      name: "Revoke",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "revokeArgs",
          type: {
            defined: "RevokeArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 45
      }
    },
    {
      name: "Lock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate or freeze authority"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "lockArgs",
          type: {
            defined: "LockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 46
      }
    },
    {
      name: "Unlock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate or freeze authority"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "unlockArgs",
          type: {
            defined: "UnlockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 47
      }
    },
    {
      name: "Migrate",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "collectionMetadata",
          isMut: false,
          isSigner: false,
          desc: "Collection metadata account"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record account"
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instruction sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "migrateArgs",
          type: {
            defined: "MigrateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 48
      }
    },
    {
      name: "Transfer",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination token account"
        },
        {
          name: "destinationOwner",
          isMut: false,
          isSigner: false,
          desc: "Destination token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition of token asset",
          optional: true
        },
        {
          name: "ownerTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Owner token record account",
          optional: true
        },
        {
          name: "destinationTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Destination token record account",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Transfer authority (token owner or delegate)"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferArgs",
          type: {
            defined: "TransferArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 49
      }
    },
    {
      name: "Update",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "updateArgs",
          type: {
            defined: "UpdateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 50
      }
    },
    {
      name: "Use",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Token owner or delegate"
        },
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "useArgs",
          type: {
            defined: "UseArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 51
      }
    },
    {
      name: "Verify",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Creator to verify, collection update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection",
          optional: true
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection",
          optional: true
        },
        {
          name: "collectionMasterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition Account of the Collection Token",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [
        {
          name: "verificationArgs",
          type: {
            defined: "VerificationArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 52
      }
    },
    {
      name: "Unverify",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Creator to verify, collection (or metadata if parent burned) update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection",
          optional: true
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [
        {
          name: "verificationArgs",
          type: {
            defined: "VerificationArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 53
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "programmableConfig",
            type: {
              option: {
                defined: "ProgrammableConfig"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "TokenOwnedEscrow",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "baseToken",
            type: "publicKey"
          },
          {
            name: "authority",
            type: {
              defined: "EscrowAuthority"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "TokenRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "state",
            type: {
              defined: "TokenState"
            }
          },
          {
            name: "ruleSetRevision",
            type: {
              option: "u64"
            }
          },
          {
            name: "delegate",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "delegateRole",
            type: {
              option: {
                defined: "TokenDelegateRole"
              }
            }
          },
          {
            name: "lockedTransfer",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "delegate",
            type: "publicKey"
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "SetCollectionSizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "size",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "TransferOutOfEscrowArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV3",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "AuthorizationData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "payload",
            type: {
              defined: "Payload"
            }
          }
        ]
      }
    },
    {
      name: "AssetData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "tokenStandard",
            type: {
              defined: "TokenStandard"
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "ruleSet",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "SeedsVec",
      type: {
        kind: "struct",
        fields: [
          {
            name: "seeds",
            type: {
              vec: "bytes"
            }
          }
        ]
      }
    },
    {
      name: "LeafInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "leaf",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "proof",
            type: {
              vec: {
                array: ["u8", 32]
              }
            }
          }
        ]
      }
    },
    {
      name: "Payload",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: {
              hashMap: [
                "string",
                {
                  defined: "PayloadType"
                }
              ]
            }
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "BurnArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "DelegateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "SaleV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "TransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "UpdateV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "UtilityV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StakingV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StandardV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              }
            ]
          },
          {
            name: "LockedTransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "locked_address",
                type: "publicKey"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "ProgrammableConfigV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "RevokeArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "SaleV1"
          },
          {
            name: "TransferV1"
          },
          {
            name: "UpdateV1"
          },
          {
            name: "UtilityV1"
          },
          {
            name: "StakingV1"
          },
          {
            name: "StandardV1"
          },
          {
            name: "LockedTransferV1"
          },
          {
            name: "ProgrammableConfigV1"
          },
          {
            name: "MigrationV1"
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Authority"
          },
          {
            name: "Collection"
          },
          {
            name: "Use"
          },
          {
            name: "Update"
          },
          {
            name: "ProgrammableConfig"
          }
        ]
      }
    },
    {
      name: "CreateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "asset_data",
                type: {
                  defined: "AssetData"
                }
              },
              {
                name: "decimals",
                type: {
                  option: "u8"
                }
              },
              {
                name: "print_supply",
                type: {
                  option: {
                    defined: "PrintSupply"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MintArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "TransferArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UpdateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "collection_details",
                type: {
                  defined: "CollectionDetailsToggle"
                }
              },
              {
                name: "uses",
                type: {
                  defined: "UsesToggle"
                }
              },
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Collection"
              }
            ]
          }
        ]
      }
    },
    {
      name: "UsesToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Uses"
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionDetailsToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "CollectionDetails"
              }
            ]
          }
        ]
      }
    },
    {
      name: "RuleSetToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "MigrateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "migration_type",
                type: {
                  defined: "MigrationType"
                }
              },
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "LockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UnlockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UseArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "VerificationArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CreatorV1"
          },
          {
            name: "CollectionV1"
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          },
          {
            name: "ProgrammableNonFungible"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          },
          {
            name: "TokenOwnedEscrow"
          },
          {
            name: "TokenRecord"
          },
          {
            name: "MetadataDelegate"
          }
        ]
      }
    },
    {
      name: "CollectionDetails",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "size",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "EscrowAuthority",
      type: {
        kind: "enum",
        variants: [
          {
            name: "TokenOwner"
          },
          {
            name: "Creator",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "PrintSupply",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Zero"
          },
          {
            name: "Limited",
            fields: ["u64"]
          },
          {
            name: "Unlimited"
          }
        ]
      }
    },
    {
      name: "ProgrammableConfig",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MigrationType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "ProgrammableV1"
          }
        ]
      }
    },
    {
      name: "TokenState",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Unlocked"
          },
          {
            name: "Locked"
          },
          {
            name: "Listed"
          }
        ]
      }
    },
    {
      name: "TokenDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Sale"
          },
          {
            name: "Transfer"
          },
          {
            name: "Utility"
          },
          {
            name: "Staking"
          },
          {
            name: "Standard"
          },
          {
            name: "LockedTransfer"
          },
          {
            name: "Migration"
          }
        ]
      }
    },
    {
      name: "AuthorityType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Metadata"
          },
          {
            name: "Holder"
          },
          {
            name: "MetadataDelegate"
          },
          {
            name: "TokenDelegate"
          }
        ]
      }
    },
    {
      name: "PayloadKey",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Amount"
          },
          {
            name: "Authority"
          },
          {
            name: "AuthoritySeeds"
          },
          {
            name: "Delegate"
          },
          {
            name: "DelegateSeeds"
          },
          {
            name: "Destination"
          },
          {
            name: "DestinationSeeds"
          },
          {
            name: "Holder"
          },
          {
            name: "Source"
          },
          {
            name: "SourceSeeds"
          }
        ]
      }
    },
    {
      name: "PayloadType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Pubkey",
            fields: ["publicKey"]
          },
          {
            name: "Seeds",
            fields: [
              {
                defined: "SeedsVec"
              }
            ]
          },
          {
            name: "MerkleProof",
            fields: [
              {
                defined: "LeafInfo"
              }
            ]
          },
          {
            name: "Number",
            fields: ["u64"]
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: "Failed to unpack instruction data"
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: "Failed to pack instruction data"
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: "Update authority must be equivalent to the metadata's authority and also signer of this transaction"
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: "Maximum editions printed already"
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: "Token mint to failed"
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: "The master edition record passed must match the master record on the edition given"
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: "The destination account does not have the right mint"
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: "An edition can only mint one of its kind!"
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: "Printing mint decimals should be zero"
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: "OneTimePrintingAuthorization mint decimals should be zero"
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: "Token burn failed"
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: "The One Time authorization mint does not match that on the token account!"
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: "The mint on your authorization token holding account does not match your Printing mint!"
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: "The authorization token account has a different owner than the update authority for the master edition!"
    },
    {
      code: 35,
      name: "Disabled",
      msg: "This feature is currently disabled."
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: "If using a creators array, you must be one of the creators listed"
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: "This reservation list already exists!"
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: "This reservation list does not exist!"
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: "This reservation list exists but was never set with reservations"
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: "This reservation list has already been set!"
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: "Provided more addresses than max allowed in single reservation"
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: "This reservation would go beyond the maximum supply of the master edition!"
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: "Address not in reservation!"
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: "In initial reservation setting, spots remaining should equal total spots"
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: "printing these tokens would breach the maximum supply limit of the master edition"
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: "Reservation spots remaining should match total spots when first being created"
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: "Beyond alotted address size in reservation!"
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: "The reservation has only been partially alotted"
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: "You cannot splice over an existing reservation!"
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: "In the legacy system the reservation needs to be of size one for cpu limit reasons"
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Collection cannot be verified in this instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: "This token use method is burn and there are no remaining uses, it must be burned"
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: "This Collection Authority Record is invalid."
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: "Creator can not be adjusted once they are verified."
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: "Can not wipe verified creators."
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: "Not allowed to change seller fee basis points."
    },
    {
      code: 97,
      name: "EditionOverrideCannotBeZero",
      msg: "Edition override cannot be zero"
    },
    {
      code: 98,
      name: "InvalidUser",
      msg: "Invalid User"
    },
    {
      code: 99,
      name: "RevokeCollectionAuthoritySignerIncorrect",
      msg: "Revoke Collection Authority signer is incorrect"
    },
    {
      code: 100,
      name: "TokenCloseFailed",
      msg: "Token close failed"
    },
    {
      code: 101,
      name: "UnsizedCollection",
      msg: "Can't use this function on unsized collection"
    },
    {
      code: 102,
      name: "SizedCollection",
      msg: "Can't use this function on a sized collection"
    },
    {
      code: 103,
      name: "MissingCollectionMetadata",
      msg: "Missing collection metadata account"
    },
    {
      code: 104,
      name: "NotAMemberOfCollection",
      msg: "This NFT is not a member of the specified collection."
    },
    {
      code: 105,
      name: "NotVerifiedMemberOfCollection",
      msg: "This NFT is not a verified member of the specified collection."
    },
    {
      code: 106,
      name: "NotACollectionParent",
      msg: "This NFT is not a collection parent NFT."
    },
    {
      code: 107,
      name: "CouldNotDetermineTokenStandard",
      msg: "Could not determine a TokenStandard type."
    },
    {
      code: 108,
      name: "MissingEditionAccount",
      msg: "This mint account has an edition but none was provided."
    },
    {
      code: 109,
      name: "NotAMasterEdition",
      msg: "This edition is not a Master Edition"
    },
    {
      code: 110,
      name: "MasterEditionHasPrints",
      msg: "This Master Edition has existing prints"
    },
    {
      code: 111,
      name: "BorshDeserializationError",
      msg: "Borsh Deserialization Error"
    },
    {
      code: 112,
      name: "CannotUpdateVerifiedCollection",
      msg: "Cannot update a verified collection in this command"
    },
    {
      code: 113,
      name: "CollectionMasterEditionAccountInvalid",
      msg: "Edition account doesnt match collection "
    },
    {
      code: 114,
      name: "AlreadyVerified",
      msg: "Item is already verified."
    },
    {
      code: 115,
      name: "AlreadyUnverified",
      msg: "Item is already unverified."
    },
    {
      code: 116,
      name: "NotAPrintEdition",
      msg: "This edition is not a Print Edition"
    },
    {
      code: 117,
      name: "InvalidMasterEdition",
      msg: "Invalid Master Edition"
    },
    {
      code: 118,
      name: "InvalidPrintEdition",
      msg: "Invalid Print Edition"
    },
    {
      code: 119,
      name: "InvalidEditionMarker",
      msg: "Invalid Edition Marker"
    },
    {
      code: 120,
      name: "ReservationListDeprecated",
      msg: "Reservation List is Deprecated"
    },
    {
      code: 121,
      name: "PrintEditionDoesNotMatchMasterEdition",
      msg: "Print Edition does not match Master Edition"
    },
    {
      code: 122,
      name: "EditionNumberGreaterThanMaxSupply",
      msg: "Edition Number greater than max supply"
    },
    {
      code: 123,
      name: "MustUnverify",
      msg: "Must unverify before migrating collections."
    },
    {
      code: 124,
      name: "InvalidEscrowBumpSeed",
      msg: "Invalid Escrow Account Bump Seed"
    },
    {
      code: 125,
      name: "MustBeEscrowAuthority",
      msg: "Must Escrow Authority"
    },
    {
      code: 126,
      name: "InvalidSystemProgram",
      msg: "Invalid System Program"
    },
    {
      code: 127,
      name: "MustBeNonFungible",
      msg: "Must be a Non Fungible Token"
    },
    {
      code: 128,
      name: "InsufficientTokens",
      msg: "Insufficient tokens for transfer"
    },
    {
      code: 129,
      name: "BorshSerializationError",
      msg: "Borsh Serialization Error"
    },
    {
      code: 130,
      name: "NoFreezeAuthoritySet",
      msg: "Cannot create NFT with no Freeze Authority."
    },
    {
      code: 131,
      name: "InvalidCollectionSizeChange",
      msg: "Invalid collection size change"
    },
    {
      code: 132,
      name: "InvalidBubblegumSigner",
      msg: "Invalid bubblegum signer"
    },
    {
      code: 133,
      name: "EscrowParentHasDelegate",
      msg: "Escrow parent cannot have a delegate"
    },
    {
      code: 134,
      name: "MintIsNotSigner",
      msg: "Mint needs to be signer to initialize the account"
    },
    {
      code: 135,
      name: "InvalidTokenStandard",
      msg: "Invalid token standard"
    },
    {
      code: 136,
      name: "InvalidMintForTokenStandard",
      msg: "Invalid mint account for specified token standard"
    },
    {
      code: 137,
      name: "InvalidAuthorizationRules",
      msg: "Invalid authorization rules account"
    },
    {
      code: 138,
      name: "MissingAuthorizationRules",
      msg: "Missing authorization rules account"
    },
    {
      code: 139,
      name: "MissingProgrammableConfig",
      msg: "Missing programmable configuration"
    },
    {
      code: 140,
      name: "InvalidProgrammableConfig",
      msg: "Invalid programmable configuration"
    },
    {
      code: 141,
      name: "DelegateAlreadyExists",
      msg: "Delegate already exists"
    },
    {
      code: 142,
      name: "DelegateNotFound",
      msg: "Delegate not found"
    },
    {
      code: 143,
      name: "MissingAccountInBuilder",
      msg: "Required account not set in instruction builder"
    },
    {
      code: 144,
      name: "MissingArgumentInBuilder",
      msg: "Required argument not set in instruction builder"
    },
    {
      code: 145,
      name: "FeatureNotSupported",
      msg: "Feature not supported currently"
    },
    {
      code: 146,
      name: "InvalidSystemWallet",
      msg: "Invalid system wallet"
    },
    {
      code: 147,
      name: "OnlySaleDelegateCanTransfer",
      msg: "Only the sale delegate can transfer while its set"
    },
    {
      code: 148,
      name: "MissingTokenAccount",
      msg: "Missing token account"
    },
    {
      code: 149,
      name: "MissingSplTokenProgram",
      msg: "Missing SPL token program"
    },
    {
      code: 150,
      name: "MissingAuthorizationRulesProgram",
      msg: "Missing authorization rules program"
    },
    {
      code: 151,
      name: "InvalidDelegateRoleForTransfer",
      msg: "Invalid delegate role for transfer"
    },
    {
      code: 152,
      name: "InvalidTransferAuthority",
      msg: "Invalid transfer authority"
    },
    {
      code: 153,
      name: "InstructionNotSupported",
      msg: "Instruction not supported for ProgrammableNonFungible assets"
    },
    {
      code: 154,
      name: "KeyMismatch",
      msg: "Public key does not match expected value"
    },
    {
      code: 155,
      name: "LockedToken",
      msg: "Token is locked"
    },
    {
      code: 156,
      name: "UnlockedToken",
      msg: "Token is unlocked"
    },
    {
      code: 157,
      name: "MissingDelegateRole",
      msg: "Missing delegate role"
    },
    {
      code: 158,
      name: "InvalidAuthorityType",
      msg: "Invalid authority type"
    },
    {
      code: 159,
      name: "MissingTokenRecord",
      msg: "Missing token record account"
    },
    {
      code: 160,
      name: "MintSupplyMustBeZero",
      msg: "Mint supply must be zero for programmable assets"
    },
    {
      code: 161,
      name: "DataIsEmptyOrZeroed",
      msg: "Data is empty or zeroed"
    },
    {
      code: 162,
      name: "MissingTokenOwnerAccount",
      msg: "Missing token owner"
    },
    {
      code: 163,
      name: "InvalidMasterEditionAccountLength",
      msg: "Master edition account has an invalid length"
    },
    {
      code: 164,
      name: "IncorrectTokenState",
      msg: "Incorrect token state"
    },
    {
      code: 165,
      name: "InvalidDelegateRole",
      msg: "Invalid delegate role"
    },
    {
      code: 166,
      name: "MissingPrintSupply",
      msg: "Print supply is required for non-fungibles"
    },
    {
      code: 167,
      name: "MissingMasterEditionAccount",
      msg: "Missing master edition account"
    },
    {
      code: 168,
      name: "AmountMustBeGreaterThanZero",
      msg: "Amount must be greater than zero"
    },
    {
      code: 169,
      name: "InvalidDelegateArgs",
      msg: "Invalid delegate args"
    },
    {
      code: 170,
      name: "MissingLockedTransferAddress",
      msg: "Missing address for locked transfer"
    },
    {
      code: 171,
      name: "InvalidLockedTransferAddress",
      msg: "Invalid destination address for locked transfer"
    },
    {
      code: 172,
      name: "DataIncrementLimitExceeded",
      msg: "Exceeded account realloc increase limit"
    },
    {
      code: 173,
      name: "CannotUpdateAssetWithDelegate",
      msg: "Cannot update the rule set of a programmable asset that has a delegate"
    },
    {
      code: 174,
      name: "InvalidAmount",
      msg: "Invalid token amount for this operation or token standard"
    },
    {
      code: 175,
      name: "MissingMasterEditionMintAccount",
      msg: "Missing master edition mint account"
    },
    {
      code: 176,
      name: "MissingMasterEditionTokenAccount",
      msg: "Missing master edition token account"
    },
    {
      code: 177,
      name: "MissingEditionMarkerAccount",
      msg: "Missing edition marker account"
    },
    {
      code: 178,
      name: "CannotBurnWithDelegate",
      msg: "Cannot burn while persistent delegate is set"
    },
    {
      code: 179,
      name: "MissingEdition",
      msg: "Missing edition account"
    },
    {
      code: 180,
      name: "InvalidAssociatedTokenAccountProgram",
      msg: "Invalid Associated Token Account Program"
    },
    {
      code: 181,
      name: "InvalidInstructionsSysvar",
      msg: "Invalid InstructionsSysvar"
    },
    {
      code: 182,
      name: "InvalidParentAccounts",
      msg: "Invalid or Unneeded parent accounts"
    },
    {
      code: 183,
      name: "InvalidUpdateArgs",
      msg: "Authority cannot apply all update args"
    },
    {
      code: 184,
      name: "InsufficientTokenBalance",
      msg: "Token account does not have enough tokens"
    },
    {
      code: 185,
      name: "MissingCollectionMint",
      msg: "Missing collection account"
    },
    {
      code: 186,
      name: "MissingCollectionMasterEdition",
      msg: "Missing collection master edition account"
    },
    {
      code: 187,
      name: "InvalidTokenRecord",
      msg: "Invalid token record account"
    },
    {
      code: 188,
      name: "InvalidCloseAuthority",
      msg: "The close authority needs to be revoked by the Utility Delegate"
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    binaryVersion: "0.0.11",
    libVersion: "0.0.11"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v1110.ts
var TokenMetadataV1110IDL = {
  version: "1.11.0",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list.",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: true,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA If present the program Assumes a delegated use authority",
          optional: true
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)",
          optional: true
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "delegateAuthority",
          isMut: true,
          isSigner: false,
          desc: "Delegated Collection Authority"
        },
        {
          name: "revokeAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority, or Delegated Authority, of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "BurnNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the NFT"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "VerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "UnverifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "SetAndVerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "CreateMetadataAccountV3",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV3",
          type: {
            defined: "CreateMetadataAccountArgsV3"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "SetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "SetTokenStandard",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Metadata update authority"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "BubblegumSetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "bubblegumSigner",
          isMut: false,
          isSigner: true,
          desc: "Signing PDA of Bubblegum program"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 36
      }
    },
    {
      name: "BurnEditionNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "printEditionMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the print edition NFT"
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the original/master NFT"
        },
        {
          name: "printEditionTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account the print edition NFT is in"
        },
        {
          name: "masterEditionTokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account the Master Edition NFT is in"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the original NFT"
        },
        {
          name: "printEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "Print Edition account of the NFT"
        },
        {
          name: "editionMarkerAccount",
          isMut: true,
          isSigner: false,
          desc: "Edition Marker PDA of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 37
      }
    },
    {
      name: "CreateEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account of the token"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 38
      }
    },
    {
      name: "CloseEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 39
      }
    },
    {
      name: "TransferOutOfEscrow",
      accounts: [
        {
          name: "escrow",
          isMut: false,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "attributeMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account for the new attribute"
        },
        {
          name: "attributeSrc",
          isMut: true,
          isSigner: false,
          desc: "Token account source for the new attribute"
        },
        {
          name: "attributeDst",
          isMut: true,
          isSigner: false,
          desc: "Token account, owned by TM, destination for the new attribute"
        },
        {
          name: "escrowMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account that the escrow is attached"
        },
        {
          name: "escrowAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account that holds the token the escrow is attached to"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferOutOfEscrowArgs",
          type: {
            defined: "TransferOutOfEscrowArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 40
      }
    },
    {
      name: "Burn",
      accounts: [
        {
          name: "authority",
          isMut: true,
          isSigner: true,
          desc: "Asset owner or Utility delegate"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition of the asset",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master edition account",
          optional: true
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Master edition mint of the asset",
          optional: true
        },
        {
          name: "masterEditionToken",
          isMut: false,
          isSigner: false,
          desc: "Master edition token account",
          optional: true
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition marker account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [
        {
          name: "burnArgs",
          type: {
            defined: "BurnArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 41
      }
    },
    {
      name: "Create",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Unallocated metadata account with address as pda of ['metadata', program id, mint id]"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition account with address as pda of ['metadata', program id, mint, 'edition']",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority for the metadata account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        }
      ],
      args: [
        {
          name: "createArgs",
          type: {
            defined: "CreateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 42
      }
    },
    {
      name: "Mint",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token or Associated Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Owner of the token account",
          optional: true
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "(Mint or Update) authority"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Metadata delegate record",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "mintArgs",
          type: {
            defined: "MintArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 43
      }
    },
    {
      name: "Delegate",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "delegateArgs",
          type: {
            defined: "DelegateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 44
      }
    },
    {
      name: "Revoke",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "revokeArgs",
          type: {
            defined: "RevokeArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 45
      }
    },
    {
      name: "Lock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate or freeze authority"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "lockArgs",
          type: {
            defined: "LockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 46
      }
    },
    {
      name: "Unlock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate or freeze authority"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "unlockArgs",
          type: {
            defined: "UnlockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 47
      }
    },
    {
      name: "Migrate",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "collectionMetadata",
          isMut: false,
          isSigner: false,
          desc: "Collection metadata account"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record account"
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instruction sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "migrateArgs",
          type: {
            defined: "MigrateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 48
      }
    },
    {
      name: "Transfer",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination token account"
        },
        {
          name: "destinationOwner",
          isMut: false,
          isSigner: false,
          desc: "Destination token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition of token asset",
          optional: true
        },
        {
          name: "ownerTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Owner token record account",
          optional: true
        },
        {
          name: "destinationTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Destination token record account",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Transfer authority (token owner or delegate)"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferArgs",
          type: {
            defined: "TransferArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 49
      }
    },
    {
      name: "Update",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "updateArgs",
          type: {
            defined: "UpdateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 50
      }
    },
    {
      name: "Use",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Token owner or delegate"
        },
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "useArgs",
          type: {
            defined: "UseArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 51
      }
    },
    {
      name: "Verify",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Creator to verify, collection update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection",
          optional: true
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection",
          optional: true
        },
        {
          name: "collectionMasterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition Account of the Collection Token",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [
        {
          name: "verificationArgs",
          type: {
            defined: "VerificationArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 52
      }
    },
    {
      name: "Unverify",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Creator to verify, collection (or metadata if parent burned) update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection",
          optional: true
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [
        {
          name: "verificationArgs",
          type: {
            defined: "VerificationArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 53
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "programmableConfig",
            type: {
              option: {
                defined: "ProgrammableConfig"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "TokenOwnedEscrow",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "baseToken",
            type: "publicKey"
          },
          {
            name: "authority",
            type: {
              defined: "EscrowAuthority"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "TokenRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "state",
            type: {
              defined: "TokenState"
            }
          },
          {
            name: "ruleSetRevision",
            type: {
              option: "u64"
            }
          },
          {
            name: "delegate",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "delegateRole",
            type: {
              option: {
                defined: "TokenDelegateRole"
              }
            }
          },
          {
            name: "lockedTransfer",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "delegate",
            type: "publicKey"
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "SetCollectionSizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "size",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "TransferOutOfEscrowArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV3",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "AuthorizationData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "payload",
            type: {
              defined: "Payload"
            }
          }
        ]
      }
    },
    {
      name: "AssetData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "tokenStandard",
            type: {
              defined: "TokenStandard"
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "ruleSet",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "SeedsVec",
      type: {
        kind: "struct",
        fields: [
          {
            name: "seeds",
            type: {
              vec: "bytes"
            }
          }
        ]
      }
    },
    {
      name: "LeafInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "leaf",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "proof",
            type: {
              vec: {
                array: ["u8", 32]
              }
            }
          }
        ]
      }
    },
    {
      name: "Payload",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: {
              hashMap: [
                "string",
                {
                  defined: "PayloadType"
                }
              ]
            }
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "BurnArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "DelegateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "SaleV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "TransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "DataV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "UtilityV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StakingV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StandardV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              }
            ]
          },
          {
            name: "LockedTransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "locked_address",
                type: "publicKey"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "ProgrammableConfigV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AuthorityItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "DataItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "CollectionItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "ProgrammableConfigItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "RevokeArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "SaleV1"
          },
          {
            name: "TransferV1"
          },
          {
            name: "DataV1"
          },
          {
            name: "UtilityV1"
          },
          {
            name: "StakingV1"
          },
          {
            name: "StandardV1"
          },
          {
            name: "LockedTransferV1"
          },
          {
            name: "ProgrammableConfigV1"
          },
          {
            name: "MigrationV1"
          },
          {
            name: "AuthorityItemV1"
          },
          {
            name: "DataItemV1"
          },
          {
            name: "CollectionItemV1"
          },
          {
            name: "ProgrammableConfigItemV1"
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "AuthorityItem"
          },
          {
            name: "Collection"
          },
          {
            name: "Use"
          },
          {
            name: "Data"
          },
          {
            name: "ProgrammableConfig"
          },
          {
            name: "DataItem"
          },
          {
            name: "CollectionItem"
          },
          {
            name: "ProgrammableConfigItem"
          }
        ]
      }
    },
    {
      name: "CreateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "asset_data",
                type: {
                  defined: "AssetData"
                }
              },
              {
                name: "decimals",
                type: {
                  option: "u8"
                }
              },
              {
                name: "print_supply",
                type: {
                  option: {
                    defined: "PrintSupply"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MintArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "TransferArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UpdateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "collection_details",
                type: {
                  defined: "CollectionDetailsToggle"
                }
              },
              {
                name: "uses",
                type: {
                  defined: "UsesToggle"
                }
              },
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsUpdateAuthorityV2",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "collection_details",
                type: {
                  defined: "CollectionDetailsToggle"
                }
              },
              {
                name: "uses",
                type: {
                  defined: "UsesToggle"
                }
              },
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "token_standard",
                type: {
                  option: {
                    defined: "TokenStandard"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsAuthorityItemDelegateV2",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "token_standard",
                type: {
                  option: {
                    defined: "TokenStandard"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsCollectionDelegateV2",
            fields: [
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsDataDelegateV2",
            fields: [
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsProgrammableConfigDelegateV2",
            fields: [
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsDataItemDelegateV2",
            fields: [
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsCollectionItemDelegateV2",
            fields: [
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsProgrammableConfigItemDelegateV2",
            fields: [
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Collection"
              }
            ]
          }
        ]
      }
    },
    {
      name: "UsesToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Uses"
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionDetailsToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "CollectionDetails"
              }
            ]
          }
        ]
      }
    },
    {
      name: "RuleSetToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "MigrateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "migration_type",
                type: {
                  defined: "MigrationType"
                }
              },
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "LockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UnlockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UseArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "VerificationArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CreatorV1"
          },
          {
            name: "CollectionV1"
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          },
          {
            name: "ProgrammableNonFungible"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          },
          {
            name: "TokenOwnedEscrow"
          },
          {
            name: "TokenRecord"
          },
          {
            name: "MetadataDelegate"
          }
        ]
      }
    },
    {
      name: "CollectionDetails",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "size",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "EscrowAuthority",
      type: {
        kind: "enum",
        variants: [
          {
            name: "TokenOwner"
          },
          {
            name: "Creator",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "PrintSupply",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Zero"
          },
          {
            name: "Limited",
            fields: ["u64"]
          },
          {
            name: "Unlimited"
          }
        ]
      }
    },
    {
      name: "ProgrammableConfig",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MigrationType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "ProgrammableV1"
          }
        ]
      }
    },
    {
      name: "TokenState",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Unlocked"
          },
          {
            name: "Locked"
          },
          {
            name: "Listed"
          }
        ]
      }
    },
    {
      name: "TokenDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Sale"
          },
          {
            name: "Transfer"
          },
          {
            name: "Utility"
          },
          {
            name: "Staking"
          },
          {
            name: "Standard"
          },
          {
            name: "LockedTransfer"
          },
          {
            name: "Migration"
          }
        ]
      }
    },
    {
      name: "AuthorityType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Metadata"
          },
          {
            name: "Holder"
          },
          {
            name: "MetadataDelegate"
          },
          {
            name: "TokenDelegate"
          }
        ]
      }
    },
    {
      name: "PayloadKey",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Amount"
          },
          {
            name: "Authority"
          },
          {
            name: "AuthoritySeeds"
          },
          {
            name: "Delegate"
          },
          {
            name: "DelegateSeeds"
          },
          {
            name: "Destination"
          },
          {
            name: "DestinationSeeds"
          },
          {
            name: "Holder"
          },
          {
            name: "Source"
          },
          {
            name: "SourceSeeds"
          }
        ]
      }
    },
    {
      name: "PayloadType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Pubkey",
            fields: ["publicKey"]
          },
          {
            name: "Seeds",
            fields: [
              {
                defined: "SeedsVec"
              }
            ]
          },
          {
            name: "MerkleProof",
            fields: [
              {
                defined: "LeafInfo"
              }
            ]
          },
          {
            name: "Number",
            fields: ["u64"]
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: "Failed to unpack instruction data"
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: "Failed to pack instruction data"
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: "Update authority must be equivalent to the metadata's authority and also signer of this transaction"
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: "Maximum editions printed already"
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: "Token mint to failed"
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: "The master edition record passed must match the master record on the edition given"
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: "The destination account does not have the right mint"
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: "An edition can only mint one of its kind!"
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: "Printing mint decimals should be zero"
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: "OneTimePrintingAuthorization mint decimals should be zero"
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: "Token burn failed"
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: "The One Time authorization mint does not match that on the token account!"
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: "The mint on your authorization token holding account does not match your Printing mint!"
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: "The authorization token account has a different owner than the update authority for the master edition!"
    },
    {
      code: 35,
      name: "Disabled",
      msg: "This feature is currently disabled."
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: "If using a creators array, you must be one of the creators listed"
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: "This reservation list already exists!"
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: "This reservation list does not exist!"
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: "This reservation list exists but was never set with reservations"
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: "This reservation list has already been set!"
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: "Provided more addresses than max allowed in single reservation"
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: "This reservation would go beyond the maximum supply of the master edition!"
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: "Address not in reservation!"
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: "In initial reservation setting, spots remaining should equal total spots"
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: "printing these tokens would breach the maximum supply limit of the master edition"
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: "Reservation spots remaining should match total spots when first being created"
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: "Beyond alotted address size in reservation!"
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: "The reservation has only been partially alotted"
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: "You cannot splice over an existing reservation!"
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: "In the legacy system the reservation needs to be of size one for cpu limit reasons"
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Collection cannot be verified in this instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: "This token use method is burn and there are no remaining uses, it must be burned"
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: "This Collection Authority Record is invalid."
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: "Creator can not be adjusted once they are verified."
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: "Can not wipe verified creators."
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: "Not allowed to change seller fee basis points."
    },
    {
      code: 97,
      name: "EditionOverrideCannotBeZero",
      msg: "Edition override cannot be zero"
    },
    {
      code: 98,
      name: "InvalidUser",
      msg: "Invalid User"
    },
    {
      code: 99,
      name: "RevokeCollectionAuthoritySignerIncorrect",
      msg: "Revoke Collection Authority signer is incorrect"
    },
    {
      code: 100,
      name: "TokenCloseFailed",
      msg: "Token close failed"
    },
    {
      code: 101,
      name: "UnsizedCollection",
      msg: "Can't use this function on unsized collection"
    },
    {
      code: 102,
      name: "SizedCollection",
      msg: "Can't use this function on a sized collection"
    },
    {
      code: 103,
      name: "MissingCollectionMetadata",
      msg: "Missing collection metadata account"
    },
    {
      code: 104,
      name: "NotAMemberOfCollection",
      msg: "This NFT is not a member of the specified collection."
    },
    {
      code: 105,
      name: "NotVerifiedMemberOfCollection",
      msg: "This NFT is not a verified member of the specified collection."
    },
    {
      code: 106,
      name: "NotACollectionParent",
      msg: "This NFT is not a collection parent NFT."
    },
    {
      code: 107,
      name: "CouldNotDetermineTokenStandard",
      msg: "Could not determine a TokenStandard type."
    },
    {
      code: 108,
      name: "MissingEditionAccount",
      msg: "This mint account has an edition but none was provided."
    },
    {
      code: 109,
      name: "NotAMasterEdition",
      msg: "This edition is not a Master Edition"
    },
    {
      code: 110,
      name: "MasterEditionHasPrints",
      msg: "This Master Edition has existing prints"
    },
    {
      code: 111,
      name: "BorshDeserializationError",
      msg: "Borsh Deserialization Error"
    },
    {
      code: 112,
      name: "CannotUpdateVerifiedCollection",
      msg: "Cannot update a verified collection in this command"
    },
    {
      code: 113,
      name: "CollectionMasterEditionAccountInvalid",
      msg: "Edition account doesnt match collection "
    },
    {
      code: 114,
      name: "AlreadyVerified",
      msg: "Item is already verified."
    },
    {
      code: 115,
      name: "AlreadyUnverified",
      msg: "Item is already unverified."
    },
    {
      code: 116,
      name: "NotAPrintEdition",
      msg: "This edition is not a Print Edition"
    },
    {
      code: 117,
      name: "InvalidMasterEdition",
      msg: "Invalid Master Edition"
    },
    {
      code: 118,
      name: "InvalidPrintEdition",
      msg: "Invalid Print Edition"
    },
    {
      code: 119,
      name: "InvalidEditionMarker",
      msg: "Invalid Edition Marker"
    },
    {
      code: 120,
      name: "ReservationListDeprecated",
      msg: "Reservation List is Deprecated"
    },
    {
      code: 121,
      name: "PrintEditionDoesNotMatchMasterEdition",
      msg: "Print Edition does not match Master Edition"
    },
    {
      code: 122,
      name: "EditionNumberGreaterThanMaxSupply",
      msg: "Edition Number greater than max supply"
    },
    {
      code: 123,
      name: "MustUnverify",
      msg: "Must unverify before migrating collections."
    },
    {
      code: 124,
      name: "InvalidEscrowBumpSeed",
      msg: "Invalid Escrow Account Bump Seed"
    },
    {
      code: 125,
      name: "MustBeEscrowAuthority",
      msg: "Must Escrow Authority"
    },
    {
      code: 126,
      name: "InvalidSystemProgram",
      msg: "Invalid System Program"
    },
    {
      code: 127,
      name: "MustBeNonFungible",
      msg: "Must be a Non Fungible Token"
    },
    {
      code: 128,
      name: "InsufficientTokens",
      msg: "Insufficient tokens for transfer"
    },
    {
      code: 129,
      name: "BorshSerializationError",
      msg: "Borsh Serialization Error"
    },
    {
      code: 130,
      name: "NoFreezeAuthoritySet",
      msg: "Cannot create NFT with no Freeze Authority."
    },
    {
      code: 131,
      name: "InvalidCollectionSizeChange",
      msg: "Invalid collection size change"
    },
    {
      code: 132,
      name: "InvalidBubblegumSigner",
      msg: "Invalid bubblegum signer"
    },
    {
      code: 133,
      name: "EscrowParentHasDelegate",
      msg: "Escrow parent cannot have a delegate"
    },
    {
      code: 134,
      name: "MintIsNotSigner",
      msg: "Mint needs to be signer to initialize the account"
    },
    {
      code: 135,
      name: "InvalidTokenStandard",
      msg: "Invalid token standard"
    },
    {
      code: 136,
      name: "InvalidMintForTokenStandard",
      msg: "Invalid mint account for specified token standard"
    },
    {
      code: 137,
      name: "InvalidAuthorizationRules",
      msg: "Invalid authorization rules account"
    },
    {
      code: 138,
      name: "MissingAuthorizationRules",
      msg: "Missing authorization rules account"
    },
    {
      code: 139,
      name: "MissingProgrammableConfig",
      msg: "Missing programmable configuration"
    },
    {
      code: 140,
      name: "InvalidProgrammableConfig",
      msg: "Invalid programmable configuration"
    },
    {
      code: 141,
      name: "DelegateAlreadyExists",
      msg: "Delegate already exists"
    },
    {
      code: 142,
      name: "DelegateNotFound",
      msg: "Delegate not found"
    },
    {
      code: 143,
      name: "MissingAccountInBuilder",
      msg: "Required account not set in instruction builder"
    },
    {
      code: 144,
      name: "MissingArgumentInBuilder",
      msg: "Required argument not set in instruction builder"
    },
    {
      code: 145,
      name: "FeatureNotSupported",
      msg: "Feature not supported currently"
    },
    {
      code: 146,
      name: "InvalidSystemWallet",
      msg: "Invalid system wallet"
    },
    {
      code: 147,
      name: "OnlySaleDelegateCanTransfer",
      msg: "Only the sale delegate can transfer while its set"
    },
    {
      code: 148,
      name: "MissingTokenAccount",
      msg: "Missing token account"
    },
    {
      code: 149,
      name: "MissingSplTokenProgram",
      msg: "Missing SPL token program"
    },
    {
      code: 150,
      name: "MissingAuthorizationRulesProgram",
      msg: "Missing authorization rules program"
    },
    {
      code: 151,
      name: "InvalidDelegateRoleForTransfer",
      msg: "Invalid delegate role for transfer"
    },
    {
      code: 152,
      name: "InvalidTransferAuthority",
      msg: "Invalid transfer authority"
    },
    {
      code: 153,
      name: "InstructionNotSupported",
      msg: "Instruction not supported for ProgrammableNonFungible assets"
    },
    {
      code: 154,
      name: "KeyMismatch",
      msg: "Public key does not match expected value"
    },
    {
      code: 155,
      name: "LockedToken",
      msg: "Token is locked"
    },
    {
      code: 156,
      name: "UnlockedToken",
      msg: "Token is unlocked"
    },
    {
      code: 157,
      name: "MissingDelegateRole",
      msg: "Missing delegate role"
    },
    {
      code: 158,
      name: "InvalidAuthorityType",
      msg: "Invalid authority type"
    },
    {
      code: 159,
      name: "MissingTokenRecord",
      msg: "Missing token record account"
    },
    {
      code: 160,
      name: "MintSupplyMustBeZero",
      msg: "Mint supply must be zero for programmable assets"
    },
    {
      code: 161,
      name: "DataIsEmptyOrZeroed",
      msg: "Data is empty or zeroed"
    },
    {
      code: 162,
      name: "MissingTokenOwnerAccount",
      msg: "Missing token owner"
    },
    {
      code: 163,
      name: "InvalidMasterEditionAccountLength",
      msg: "Master edition account has an invalid length"
    },
    {
      code: 164,
      name: "IncorrectTokenState",
      msg: "Incorrect token state"
    },
    {
      code: 165,
      name: "InvalidDelegateRole",
      msg: "Invalid delegate role"
    },
    {
      code: 166,
      name: "MissingPrintSupply",
      msg: "Print supply is required for non-fungibles"
    },
    {
      code: 167,
      name: "MissingMasterEditionAccount",
      msg: "Missing master edition account"
    },
    {
      code: 168,
      name: "AmountMustBeGreaterThanZero",
      msg: "Amount must be greater than zero"
    },
    {
      code: 169,
      name: "InvalidDelegateArgs",
      msg: "Invalid delegate args"
    },
    {
      code: 170,
      name: "MissingLockedTransferAddress",
      msg: "Missing address for locked transfer"
    },
    {
      code: 171,
      name: "InvalidLockedTransferAddress",
      msg: "Invalid destination address for locked transfer"
    },
    {
      code: 172,
      name: "DataIncrementLimitExceeded",
      msg: "Exceeded account realloc increase limit"
    },
    {
      code: 173,
      name: "CannotUpdateAssetWithDelegate",
      msg: "Cannot update the rule set of a programmable asset that has a delegate"
    },
    {
      code: 174,
      name: "InvalidAmount",
      msg: "Invalid token amount for this operation or token standard"
    },
    {
      code: 175,
      name: "MissingMasterEditionMintAccount",
      msg: "Missing master edition mint account"
    },
    {
      code: 176,
      name: "MissingMasterEditionTokenAccount",
      msg: "Missing master edition token account"
    },
    {
      code: 177,
      name: "MissingEditionMarkerAccount",
      msg: "Missing edition marker account"
    },
    {
      code: 178,
      name: "CannotBurnWithDelegate",
      msg: "Cannot burn while persistent delegate is set"
    },
    {
      code: 179,
      name: "MissingEdition",
      msg: "Missing edition account"
    },
    {
      code: 180,
      name: "InvalidAssociatedTokenAccountProgram",
      msg: "Invalid Associated Token Account Program"
    },
    {
      code: 181,
      name: "InvalidInstructionsSysvar",
      msg: "Invalid InstructionsSysvar"
    },
    {
      code: 182,
      name: "InvalidParentAccounts",
      msg: "Invalid or Unneeded parent accounts"
    },
    {
      code: 183,
      name: "InvalidUpdateArgs",
      msg: "Authority cannot apply all update args"
    },
    {
      code: 184,
      name: "InsufficientTokenBalance",
      msg: "Token account does not have enough tokens"
    },
    {
      code: 185,
      name: "MissingCollectionMint",
      msg: "Missing collection account"
    },
    {
      code: 186,
      name: "MissingCollectionMasterEdition",
      msg: "Missing collection master edition account"
    },
    {
      code: 187,
      name: "InvalidTokenRecord",
      msg: "Invalid token record account"
    },
    {
      code: 188,
      name: "InvalidCloseAuthority",
      msg: "The close authority needs to be revoked by the Utility Delegate"
    },
    {
      code: 189,
      name: "InvalidInstruction",
      msg: "Invalid or removed instruction"
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    binaryVersion: "0.0.11",
    libVersion: "0.0.11"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v1120.ts
var TokenMetadataV1120IDL = {
  version: "1.12.0",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list.",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: true,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA If present the program Assumes a delegated use authority",
          optional: true
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)",
          optional: true
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "delegateAuthority",
          isMut: true,
          isSigner: false,
          desc: "Delegated Collection Authority"
        },
        {
          name: "revokeAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority, or Delegated Authority, of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "BurnNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the NFT"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "VerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "UnverifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "SetAndVerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "CreateMetadataAccountV3",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV3",
          type: {
            defined: "CreateMetadataAccountArgsV3"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "SetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "SetTokenStandard",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Metadata update authority"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "BubblegumSetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "bubblegumSigner",
          isMut: false,
          isSigner: true,
          desc: "Signing PDA of Bubblegum program"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 36
      }
    },
    {
      name: "BurnEditionNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "printEditionMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the print edition NFT"
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the original/master NFT"
        },
        {
          name: "printEditionTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account the print edition NFT is in"
        },
        {
          name: "masterEditionTokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account the Master Edition NFT is in"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the original NFT"
        },
        {
          name: "printEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "Print Edition account of the NFT"
        },
        {
          name: "editionMarkerAccount",
          isMut: true,
          isSigner: false,
          desc: "Edition Marker PDA of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 37
      }
    },
    {
      name: "CreateEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account of the token"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 38
      }
    },
    {
      name: "CloseEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 39
      }
    },
    {
      name: "TransferOutOfEscrow",
      accounts: [
        {
          name: "escrow",
          isMut: false,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "attributeMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account for the new attribute"
        },
        {
          name: "attributeSrc",
          isMut: true,
          isSigner: false,
          desc: "Token account source for the new attribute"
        },
        {
          name: "attributeDst",
          isMut: true,
          isSigner: false,
          desc: "Token account, owned by TM, destination for the new attribute"
        },
        {
          name: "escrowMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account that the escrow is attached"
        },
        {
          name: "escrowAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account that holds the token the escrow is attached to"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferOutOfEscrowArgs",
          type: {
            defined: "TransferOutOfEscrowArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 40
      }
    },
    {
      name: "Burn",
      accounts: [
        {
          name: "authority",
          isMut: true,
          isSigner: true,
          desc: "Asset owner or Utility delegate"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition of the asset",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master edition account",
          optional: true
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Master edition mint of the asset",
          optional: true
        },
        {
          name: "masterEditionToken",
          isMut: false,
          isSigner: false,
          desc: "Master edition token account",
          optional: true
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition marker account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [
        {
          name: "burnArgs",
          type: {
            defined: "BurnArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 41
      }
    },
    {
      name: "Create",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Unallocated metadata account with address as pda of ['metadata', program id, mint id]"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition account with address as pda of ['metadata', program id, mint, 'edition']",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority for the metadata account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        }
      ],
      args: [
        {
          name: "createArgs",
          type: {
            defined: "CreateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 42
      }
    },
    {
      name: "Mint",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token or Associated Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Owner of the token account",
          optional: true
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "(Mint or Update) authority"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Metadata delegate record",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "mintArgs",
          type: {
            defined: "MintArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 43
      }
    },
    {
      name: "Delegate",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "delegateArgs",
          type: {
            defined: "DelegateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 44
      }
    },
    {
      name: "Revoke",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "revokeArgs",
          type: {
            defined: "RevokeArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 45
      }
    },
    {
      name: "Lock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate or freeze authority"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "lockArgs",
          type: {
            defined: "LockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 46
      }
    },
    {
      name: "Unlock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate or freeze authority"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "unlockArgs",
          type: {
            defined: "UnlockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 47
      }
    },
    {
      name: "Migrate",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "collectionMetadata",
          isMut: false,
          isSigner: false,
          desc: "Collection metadata account"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record account"
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instruction sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "migrateArgs",
          type: {
            defined: "MigrateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 48
      }
    },
    {
      name: "Transfer",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination token account"
        },
        {
          name: "destinationOwner",
          isMut: false,
          isSigner: false,
          desc: "Destination token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition of token asset",
          optional: true
        },
        {
          name: "ownerTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Owner token record account",
          optional: true
        },
        {
          name: "destinationTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Destination token record account",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Transfer authority (token owner or delegate)"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferArgs",
          type: {
            defined: "TransferArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 49
      }
    },
    {
      name: "Update",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "updateArgs",
          type: {
            defined: "UpdateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 50
      }
    },
    {
      name: "Use",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Token owner or delegate"
        },
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "useArgs",
          type: {
            defined: "UseArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 51
      }
    },
    {
      name: "Verify",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Creator to verify, collection update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection",
          optional: true
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection",
          optional: true
        },
        {
          name: "collectionMasterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition Account of the Collection Token",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [
        {
          name: "verificationArgs",
          type: {
            defined: "VerificationArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 52
      }
    },
    {
      name: "Unverify",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Creator to verify, collection (or metadata if parent burned) update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection",
          optional: true
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [
        {
          name: "verificationArgs",
          type: {
            defined: "VerificationArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 53
      }
    },
    {
      name: "Collect",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority to collect fees"
        },
        {
          name: "pdaAccount",
          isMut: false,
          isSigner: false,
          desc: "PDA to retrieve fees from"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 54
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "programmableConfig",
            type: {
              option: {
                defined: "ProgrammableConfig"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "TokenOwnedEscrow",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "baseToken",
            type: "publicKey"
          },
          {
            name: "authority",
            type: {
              defined: "EscrowAuthority"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "TokenRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "state",
            type: {
              defined: "TokenState"
            }
          },
          {
            name: "ruleSetRevision",
            type: {
              option: "u64"
            }
          },
          {
            name: "delegate",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "delegateRole",
            type: {
              option: {
                defined: "TokenDelegateRole"
              }
            }
          },
          {
            name: "lockedTransfer",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "delegate",
            type: "publicKey"
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "SetCollectionSizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "size",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "TransferOutOfEscrowArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV3",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "AuthorizationData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "payload",
            type: {
              defined: "Payload"
            }
          }
        ]
      }
    },
    {
      name: "AssetData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "tokenStandard",
            type: {
              defined: "TokenStandard"
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "ruleSet",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "SeedsVec",
      type: {
        kind: "struct",
        fields: [
          {
            name: "seeds",
            type: {
              vec: "bytes"
            }
          }
        ]
      }
    },
    {
      name: "LeafInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "leaf",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "proof",
            type: {
              vec: {
                array: ["u8", 32]
              }
            }
          }
        ]
      }
    },
    {
      name: "Payload",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: {
              hashMap: [
                "string",
                {
                  defined: "PayloadType"
                }
              ]
            }
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "BurnArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "DelegateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "SaleV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "TransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "DataV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "UtilityV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StakingV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StandardV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              }
            ]
          },
          {
            name: "LockedTransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "locked_address",
                type: "publicKey"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "ProgrammableConfigV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AuthorityItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "DataItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "CollectionItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "ProgrammableConfigItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "RevokeArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "SaleV1"
          },
          {
            name: "TransferV1"
          },
          {
            name: "DataV1"
          },
          {
            name: "UtilityV1"
          },
          {
            name: "StakingV1"
          },
          {
            name: "StandardV1"
          },
          {
            name: "LockedTransferV1"
          },
          {
            name: "ProgrammableConfigV1"
          },
          {
            name: "MigrationV1"
          },
          {
            name: "AuthorityItemV1"
          },
          {
            name: "DataItemV1"
          },
          {
            name: "CollectionItemV1"
          },
          {
            name: "ProgrammableConfigItemV1"
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "AuthorityItem"
          },
          {
            name: "Collection"
          },
          {
            name: "Use"
          },
          {
            name: "Data"
          },
          {
            name: "ProgrammableConfig"
          },
          {
            name: "DataItem"
          },
          {
            name: "CollectionItem"
          },
          {
            name: "ProgrammableConfigItem"
          }
        ]
      }
    },
    {
      name: "CreateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "asset_data",
                type: {
                  defined: "AssetData"
                }
              },
              {
                name: "decimals",
                type: {
                  option: "u8"
                }
              },
              {
                name: "print_supply",
                type: {
                  option: {
                    defined: "PrintSupply"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MintArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "TransferArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UpdateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "collection_details",
                type: {
                  defined: "CollectionDetailsToggle"
                }
              },
              {
                name: "uses",
                type: {
                  defined: "UsesToggle"
                }
              },
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsUpdateAuthorityV2",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "collection_details",
                type: {
                  defined: "CollectionDetailsToggle"
                }
              },
              {
                name: "uses",
                type: {
                  defined: "UsesToggle"
                }
              },
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "token_standard",
                type: {
                  option: {
                    defined: "TokenStandard"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsAuthorityItemDelegateV2",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "token_standard",
                type: {
                  option: {
                    defined: "TokenStandard"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsCollectionDelegateV2",
            fields: [
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsDataDelegateV2",
            fields: [
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsProgrammableConfigDelegateV2",
            fields: [
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsDataItemDelegateV2",
            fields: [
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsCollectionItemDelegateV2",
            fields: [
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsProgrammableConfigItemDelegateV2",
            fields: [
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Collection"
              }
            ]
          }
        ]
      }
    },
    {
      name: "UsesToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Uses"
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionDetailsToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "CollectionDetails"
              }
            ]
          }
        ]
      }
    },
    {
      name: "RuleSetToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "MigrateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "migration_type",
                type: {
                  defined: "MigrationType"
                }
              },
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "LockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UnlockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UseArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "VerificationArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CreatorV1"
          },
          {
            name: "CollectionV1"
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          },
          {
            name: "ProgrammableNonFungible"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          },
          {
            name: "TokenOwnedEscrow"
          },
          {
            name: "TokenRecord"
          },
          {
            name: "MetadataDelegate"
          }
        ]
      }
    },
    {
      name: "CollectionDetails",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "size",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "EscrowAuthority",
      type: {
        kind: "enum",
        variants: [
          {
            name: "TokenOwner"
          },
          {
            name: "Creator",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "PrintSupply",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Zero"
          },
          {
            name: "Limited",
            fields: ["u64"]
          },
          {
            name: "Unlimited"
          }
        ]
      }
    },
    {
      name: "ProgrammableConfig",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MigrationType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "ProgrammableV1"
          }
        ]
      }
    },
    {
      name: "TokenState",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Unlocked"
          },
          {
            name: "Locked"
          },
          {
            name: "Listed"
          }
        ]
      }
    },
    {
      name: "TokenDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Sale"
          },
          {
            name: "Transfer"
          },
          {
            name: "Utility"
          },
          {
            name: "Staking"
          },
          {
            name: "Standard"
          },
          {
            name: "LockedTransfer"
          },
          {
            name: "Migration"
          }
        ]
      }
    },
    {
      name: "AuthorityType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Metadata"
          },
          {
            name: "Holder"
          },
          {
            name: "MetadataDelegate"
          },
          {
            name: "TokenDelegate"
          }
        ]
      }
    },
    {
      name: "PayloadKey",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Amount"
          },
          {
            name: "Authority"
          },
          {
            name: "AuthoritySeeds"
          },
          {
            name: "Delegate"
          },
          {
            name: "DelegateSeeds"
          },
          {
            name: "Destination"
          },
          {
            name: "DestinationSeeds"
          },
          {
            name: "Holder"
          },
          {
            name: "Source"
          },
          {
            name: "SourceSeeds"
          }
        ]
      }
    },
    {
      name: "PayloadType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Pubkey",
            fields: ["publicKey"]
          },
          {
            name: "Seeds",
            fields: [
              {
                defined: "SeedsVec"
              }
            ]
          },
          {
            name: "MerkleProof",
            fields: [
              {
                defined: "LeafInfo"
              }
            ]
          },
          {
            name: "Number",
            fields: ["u64"]
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: "Failed to unpack instruction data"
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: "Failed to pack instruction data"
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: "Update authority must be equivalent to the metadata's authority and also signer of this transaction"
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: "Maximum editions printed already"
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: "Token mint to failed"
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: "The master edition record passed must match the master record on the edition given"
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: "The destination account does not have the right mint"
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: "An edition can only mint one of its kind!"
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: "Printing mint decimals should be zero"
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: "OneTimePrintingAuthorization mint decimals should be zero"
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: "Token burn failed"
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: "The One Time authorization mint does not match that on the token account!"
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: "The mint on your authorization token holding account does not match your Printing mint!"
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: "The authorization token account has a different owner than the update authority for the master edition!"
    },
    {
      code: 35,
      name: "Disabled",
      msg: "This feature is currently disabled."
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: "If using a creators array, you must be one of the creators listed"
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: "This reservation list already exists!"
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: "This reservation list does not exist!"
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: "This reservation list exists but was never set with reservations"
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: "This reservation list has already been set!"
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: "Provided more addresses than max allowed in single reservation"
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: "This reservation would go beyond the maximum supply of the master edition!"
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: "Address not in reservation!"
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: "In initial reservation setting, spots remaining should equal total spots"
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: "printing these tokens would breach the maximum supply limit of the master edition"
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: "Reservation spots remaining should match total spots when first being created"
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: "Beyond alotted address size in reservation!"
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: "The reservation has only been partially alotted"
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: "You cannot splice over an existing reservation!"
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: "In the legacy system the reservation needs to be of size one for cpu limit reasons"
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Collection cannot be verified in this instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: "This token use method is burn and there are no remaining uses, it must be burned"
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: "This Collection Authority Record is invalid."
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: "Creator can not be adjusted once they are verified."
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: "Can not wipe verified creators."
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: "Not allowed to change seller fee basis points."
    },
    {
      code: 97,
      name: "EditionOverrideCannotBeZero",
      msg: "Edition override cannot be zero"
    },
    {
      code: 98,
      name: "InvalidUser",
      msg: "Invalid User"
    },
    {
      code: 99,
      name: "RevokeCollectionAuthoritySignerIncorrect",
      msg: "Revoke Collection Authority signer is incorrect"
    },
    {
      code: 100,
      name: "TokenCloseFailed",
      msg: "Token close failed"
    },
    {
      code: 101,
      name: "UnsizedCollection",
      msg: "Can't use this function on unsized collection"
    },
    {
      code: 102,
      name: "SizedCollection",
      msg: "Can't use this function on a sized collection"
    },
    {
      code: 103,
      name: "MissingCollectionMetadata",
      msg: "Missing collection metadata account"
    },
    {
      code: 104,
      name: "NotAMemberOfCollection",
      msg: "This NFT is not a member of the specified collection."
    },
    {
      code: 105,
      name: "NotVerifiedMemberOfCollection",
      msg: "This NFT is not a verified member of the specified collection."
    },
    {
      code: 106,
      name: "NotACollectionParent",
      msg: "This NFT is not a collection parent NFT."
    },
    {
      code: 107,
      name: "CouldNotDetermineTokenStandard",
      msg: "Could not determine a TokenStandard type."
    },
    {
      code: 108,
      name: "MissingEditionAccount",
      msg: "This mint account has an edition but none was provided."
    },
    {
      code: 109,
      name: "NotAMasterEdition",
      msg: "This edition is not a Master Edition"
    },
    {
      code: 110,
      name: "MasterEditionHasPrints",
      msg: "This Master Edition has existing prints"
    },
    {
      code: 111,
      name: "BorshDeserializationError",
      msg: "Borsh Deserialization Error"
    },
    {
      code: 112,
      name: "CannotUpdateVerifiedCollection",
      msg: "Cannot update a verified collection in this command"
    },
    {
      code: 113,
      name: "CollectionMasterEditionAccountInvalid",
      msg: "Edition account doesnt match collection "
    },
    {
      code: 114,
      name: "AlreadyVerified",
      msg: "Item is already verified."
    },
    {
      code: 115,
      name: "AlreadyUnverified",
      msg: "Item is already unverified."
    },
    {
      code: 116,
      name: "NotAPrintEdition",
      msg: "This edition is not a Print Edition"
    },
    {
      code: 117,
      name: "InvalidMasterEdition",
      msg: "Invalid Master Edition"
    },
    {
      code: 118,
      name: "InvalidPrintEdition",
      msg: "Invalid Print Edition"
    },
    {
      code: 119,
      name: "InvalidEditionMarker",
      msg: "Invalid Edition Marker"
    },
    {
      code: 120,
      name: "ReservationListDeprecated",
      msg: "Reservation List is Deprecated"
    },
    {
      code: 121,
      name: "PrintEditionDoesNotMatchMasterEdition",
      msg: "Print Edition does not match Master Edition"
    },
    {
      code: 122,
      name: "EditionNumberGreaterThanMaxSupply",
      msg: "Edition Number greater than max supply"
    },
    {
      code: 123,
      name: "MustUnverify",
      msg: "Must unverify before migrating collections."
    },
    {
      code: 124,
      name: "InvalidEscrowBumpSeed",
      msg: "Invalid Escrow Account Bump Seed"
    },
    {
      code: 125,
      name: "MustBeEscrowAuthority",
      msg: "Must Escrow Authority"
    },
    {
      code: 126,
      name: "InvalidSystemProgram",
      msg: "Invalid System Program"
    },
    {
      code: 127,
      name: "MustBeNonFungible",
      msg: "Must be a Non Fungible Token"
    },
    {
      code: 128,
      name: "InsufficientTokens",
      msg: "Insufficient tokens for transfer"
    },
    {
      code: 129,
      name: "BorshSerializationError",
      msg: "Borsh Serialization Error"
    },
    {
      code: 130,
      name: "NoFreezeAuthoritySet",
      msg: "Cannot create NFT with no Freeze Authority."
    },
    {
      code: 131,
      name: "InvalidCollectionSizeChange",
      msg: "Invalid collection size change"
    },
    {
      code: 132,
      name: "InvalidBubblegumSigner",
      msg: "Invalid bubblegum signer"
    },
    {
      code: 133,
      name: "EscrowParentHasDelegate",
      msg: "Escrow parent cannot have a delegate"
    },
    {
      code: 134,
      name: "MintIsNotSigner",
      msg: "Mint needs to be signer to initialize the account"
    },
    {
      code: 135,
      name: "InvalidTokenStandard",
      msg: "Invalid token standard"
    },
    {
      code: 136,
      name: "InvalidMintForTokenStandard",
      msg: "Invalid mint account for specified token standard"
    },
    {
      code: 137,
      name: "InvalidAuthorizationRules",
      msg: "Invalid authorization rules account"
    },
    {
      code: 138,
      name: "MissingAuthorizationRules",
      msg: "Missing authorization rules account"
    },
    {
      code: 139,
      name: "MissingProgrammableConfig",
      msg: "Missing programmable configuration"
    },
    {
      code: 140,
      name: "InvalidProgrammableConfig",
      msg: "Invalid programmable configuration"
    },
    {
      code: 141,
      name: "DelegateAlreadyExists",
      msg: "Delegate already exists"
    },
    {
      code: 142,
      name: "DelegateNotFound",
      msg: "Delegate not found"
    },
    {
      code: 143,
      name: "MissingAccountInBuilder",
      msg: "Required account not set in instruction builder"
    },
    {
      code: 144,
      name: "MissingArgumentInBuilder",
      msg: "Required argument not set in instruction builder"
    },
    {
      code: 145,
      name: "FeatureNotSupported",
      msg: "Feature not supported currently"
    },
    {
      code: 146,
      name: "InvalidSystemWallet",
      msg: "Invalid system wallet"
    },
    {
      code: 147,
      name: "OnlySaleDelegateCanTransfer",
      msg: "Only the sale delegate can transfer while its set"
    },
    {
      code: 148,
      name: "MissingTokenAccount",
      msg: "Missing token account"
    },
    {
      code: 149,
      name: "MissingSplTokenProgram",
      msg: "Missing SPL token program"
    },
    {
      code: 150,
      name: "MissingAuthorizationRulesProgram",
      msg: "Missing authorization rules program"
    },
    {
      code: 151,
      name: "InvalidDelegateRoleForTransfer",
      msg: "Invalid delegate role for transfer"
    },
    {
      code: 152,
      name: "InvalidTransferAuthority",
      msg: "Invalid transfer authority"
    },
    {
      code: 153,
      name: "InstructionNotSupported",
      msg: "Instruction not supported for ProgrammableNonFungible assets"
    },
    {
      code: 154,
      name: "KeyMismatch",
      msg: "Public key does not match expected value"
    },
    {
      code: 155,
      name: "LockedToken",
      msg: "Token is locked"
    },
    {
      code: 156,
      name: "UnlockedToken",
      msg: "Token is unlocked"
    },
    {
      code: 157,
      name: "MissingDelegateRole",
      msg: "Missing delegate role"
    },
    {
      code: 158,
      name: "InvalidAuthorityType",
      msg: "Invalid authority type"
    },
    {
      code: 159,
      name: "MissingTokenRecord",
      msg: "Missing token record account"
    },
    {
      code: 160,
      name: "MintSupplyMustBeZero",
      msg: "Mint supply must be zero for programmable assets"
    },
    {
      code: 161,
      name: "DataIsEmptyOrZeroed",
      msg: "Data is empty or zeroed"
    },
    {
      code: 162,
      name: "MissingTokenOwnerAccount",
      msg: "Missing token owner"
    },
    {
      code: 163,
      name: "InvalidMasterEditionAccountLength",
      msg: "Master edition account has an invalid length"
    },
    {
      code: 164,
      name: "IncorrectTokenState",
      msg: "Incorrect token state"
    },
    {
      code: 165,
      name: "InvalidDelegateRole",
      msg: "Invalid delegate role"
    },
    {
      code: 166,
      name: "MissingPrintSupply",
      msg: "Print supply is required for non-fungibles"
    },
    {
      code: 167,
      name: "MissingMasterEditionAccount",
      msg: "Missing master edition account"
    },
    {
      code: 168,
      name: "AmountMustBeGreaterThanZero",
      msg: "Amount must be greater than zero"
    },
    {
      code: 169,
      name: "InvalidDelegateArgs",
      msg: "Invalid delegate args"
    },
    {
      code: 170,
      name: "MissingLockedTransferAddress",
      msg: "Missing address for locked transfer"
    },
    {
      code: 171,
      name: "InvalidLockedTransferAddress",
      msg: "Invalid destination address for locked transfer"
    },
    {
      code: 172,
      name: "DataIncrementLimitExceeded",
      msg: "Exceeded account realloc increase limit"
    },
    {
      code: 173,
      name: "CannotUpdateAssetWithDelegate",
      msg: "Cannot update the rule set of a programmable asset that has a delegate"
    },
    {
      code: 174,
      name: "InvalidAmount",
      msg: "Invalid token amount for this operation or token standard"
    },
    {
      code: 175,
      name: "MissingMasterEditionMintAccount",
      msg: "Missing master edition mint account"
    },
    {
      code: 176,
      name: "MissingMasterEditionTokenAccount",
      msg: "Missing master edition token account"
    },
    {
      code: 177,
      name: "MissingEditionMarkerAccount",
      msg: "Missing edition marker account"
    },
    {
      code: 178,
      name: "CannotBurnWithDelegate",
      msg: "Cannot burn while persistent delegate is set"
    },
    {
      code: 179,
      name: "MissingEdition",
      msg: "Missing edition account"
    },
    {
      code: 180,
      name: "InvalidAssociatedTokenAccountProgram",
      msg: "Invalid Associated Token Account Program"
    },
    {
      code: 181,
      name: "InvalidInstructionsSysvar",
      msg: "Invalid InstructionsSysvar"
    },
    {
      code: 182,
      name: "InvalidParentAccounts",
      msg: "Invalid or Unneeded parent accounts"
    },
    {
      code: 183,
      name: "InvalidUpdateArgs",
      msg: "Authority cannot apply all update args"
    },
    {
      code: 184,
      name: "InsufficientTokenBalance",
      msg: "Token account does not have enough tokens"
    },
    {
      code: 185,
      name: "MissingCollectionMint",
      msg: "Missing collection account"
    },
    {
      code: 186,
      name: "MissingCollectionMasterEdition",
      msg: "Missing collection master edition account"
    },
    {
      code: 187,
      name: "InvalidTokenRecord",
      msg: "Invalid token record account"
    },
    {
      code: 188,
      name: "InvalidCloseAuthority",
      msg: "The close authority needs to be revoked by the Utility Delegate"
    },
    {
      code: 189,
      name: "InvalidInstruction",
      msg: "Invalid or removed instruction"
    },
    {
      code: 190,
      name: "MissingDelegateRecord",
      msg: "Missing delegate record"
    },
    {
      code: 191,
      name: "InvalidFeeAccount",
      msg: ""
    },
    {
      code: 192,
      name: "InvalidMetadataFlags",
      msg: ""
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    binaryVersion: "0.0.11",
    libVersion: "0.0.11"
  }
};

// src/idls/shank/others/token-metadata/token-metadata-v1130.ts
var TokenMetadataV1130IDL = {
  version: "1.13.0",
  name: "mpl_token_metadata",
  instructions: [
    {
      name: "CreateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgs",
          type: {
            defined: "CreateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "UpdateMetadataAccount",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgs",
          type: {
            defined: "UpdateMetadataAccountArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "DeprecatedCreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V1 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint - A mint you control that can mint tokens that can be exchanged for limited editions of your master edition via the MintNewEditionFromMasterEditionViaToken endpoint"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization printing mint - A mint you control that prints tokens that gives the bearer permission to mint any number of tokens from the printing mint one time via an endpoint with the token-metadata program for your metadata. Also burns the token."
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Current Update authority key"
        },
        {
          name: "printingMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Printing mint authority - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "oneTimePrintingAuthorizationMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "One time authorization printing mint authority - must be provided if using max supply. THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY."
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "DeprecatedMintNewEditionFromMasterEditionViaPrintingToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition V1 (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing Mint of master record edition"
        },
        {
          name: "masterTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account containing Printing mint token to be transferred"
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master mint id, edition_number])"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority for this token"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info for new metadata account"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "Reservation List - If present, and you are on this list, you can get an edition number given by your position on the list.",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "UpdatePrimarySaleHappenedViaToken",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true,
          desc: "Owner on the token account"
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Account containing tokens from the metadata's mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "DeprecatedSetReservationList",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: true,
          desc: "The resource you tied the reservation list too"
        }
      ],
      args: [
        {
          name: "setReservationListArgs",
          type: {
            defined: "SetReservationListArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "DeprecatedCreateReservationList",
      accounts: [
        {
          name: "reservationList",
          isMut: true,
          isSigner: false,
          desc: "PDA for ReservationList of ['metadata', program id, master edition key, 'reservation', resource-key]"
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: " Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "resource",
          isMut: false,
          isSigner: false,
          desc: "A resource you wish to tie the reservation list to. This is so your later visitors who come to redeem can derive your reservation list PDA with something they can easily get at. You choose what this should be."
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "SignMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "DeprecatedMintPrintingTokensViaToken",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account containing one time authorization token"
        },
        {
          name: "oneTimePrintingAuthorizationMint",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "burnAuthority",
          isMut: false,
          isSigner: true,
          desc: "Burn authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "DeprecatedMintPrintingTokens",
      accounts: [
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination account"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition V1 key (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent"
        }
      ],
      args: [
        {
          name: "mintPrintingTokensViaTokenArgs",
          type: {
            defined: "MintPrintingTokensViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "CreateMasterEdition",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaToken",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "tokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token (#8)"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "ConvertMasterEditionV1ToV2",
      accounts: [
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V1 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "oneTimeAuth",
          isMut: true,
          isSigner: false,
          desc: "One time authorization mint"
        },
        {
          name: "printingMint",
          isMut: true,
          isSigner: false,
          desc: "Printing mint"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaVaultProxy",
      accounts: [
        {
          name: "newMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "newEdition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition']"
        },
        {
          name: "newMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionMarkPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "newMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "vaultAuthority",
          isMut: false,
          isSigner: true,
          desc: "Vault authority"
        },
        {
          name: "safetyDepositStore",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit token store account"
        },
        {
          name: "safetyDepositBox",
          isMut: false,
          isSigner: false,
          desc: "Safety deposit box"
        },
        {
          name: "vault",
          isMut: false,
          isSigner: false,
          desc: "Vault"
        },
        {
          name: "newMetadataUpdateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority info for new metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "tokenVaultProgram",
          isMut: false,
          isSigner: false,
          desc: "Token vault program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "mintNewEditionFromMasterEditionViaTokenArgs",
          type: {
            defined: "MintNewEditionFromMasterEditionViaTokenArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "PuffMetadata",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "UpdateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority key"
        }
      ],
      args: [
        {
          name: "updateMetadataAccountArgsV2",
          type: {
            defined: "UpdateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "CreateMetadataAccountV2",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV2",
          type: {
            defined: "CreateMetadataAccountArgsV2"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "CreateMasterEditionV3",
      accounts: [
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition V2 account with address as pda of ['metadata', program id, mint, 'edition']"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Metadata mint"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority on the metadata's mint - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMasterEditionArgs",
          type: {
            defined: "CreateMasterEditionArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "VerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "Utilize",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token Account Of NFT"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the Metadata"
        },
        {
          name: "useAuthority",
          isMut: true,
          isSigner: true,
          desc: "A Use Authority / Can be the current Owner of the NFT"
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false,
          desc: "Owner"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info"
        },
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA If present the program Assumes a delegated use authority",
          optional: true
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)",
          optional: true
        }
      ],
      args: [
        {
          name: "utilizeArgs",
          type: {
            defined: "UtilizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "ApproveUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "burner",
          isMut: false,
          isSigner: false,
          desc: "Program As Signer (Burner)"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "approveUseAuthorityArgs",
          type: {
            defined: "ApproveUseAuthorityArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "RevokeUseAuthority",
      accounts: [
        {
          name: "useAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Use Authority Record PDA"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "Owner"
        },
        {
          name: "user",
          isMut: false,
          isSigner: false,
          desc: "A Use Authority"
        },
        {
          name: "ownerTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Owned Token Account Of Mint"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "UnverifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "ApproveCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "newCollectionAuthority",
          isMut: false,
          isSigner: false,
          desc: "A Collection Authority"
        },
        {
          name: "updateAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority of Collection NFT"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Collection Metadata"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "RevokeCollectionAuthority",
      accounts: [
        {
          name: "collectionAuthorityRecord",
          isMut: true,
          isSigner: false,
          desc: "Collection Authority Record PDA"
        },
        {
          name: "delegateAuthority",
          isMut: true,
          isSigner: false,
          desc: "Delegated Collection Authority"
        },
        {
          name: "revokeAuthority",
          isMut: true,
          isSigner: true,
          desc: "Update Authority, or Delegated Authority, of Collection NFT"
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of Metadata"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "SetAndVerifyCollection",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: false,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    {
      name: "FreezeDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to freeze"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "ThawDelegatedAccount",
      accounts: [
        {
          name: "delegate",
          isMut: true,
          isSigner: true,
          desc: "Delegate"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to thaw"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Token mint"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "RemoveCreatorVerification",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "creator",
          isMut: false,
          isSigner: true,
          desc: "Creator"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "BurnNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the NFT"
        },
        {
          name: "tokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "VerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "UnverifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: false,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "SetAndVerifySizedCollectionItem",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: false,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update Authority of Collection NFT and NFT"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collection",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection"
        },
        {
          name: "collectionMasterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 Account of the Collection Token"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "CreateMetadataAccountV3",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "update authority info"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false,
          desc: "Rent info",
          optional: true
        }
      ],
      args: [
        {
          name: "createMetadataAccountArgsV3",
          type: {
            defined: "CreateMetadataAccountArgsV3"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "SetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "SetTokenStandard",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: true,
          desc: "Metadata update authority"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "BubblegumSetCollectionSize",
      accounts: [
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Collection Metadata account"
        },
        {
          name: "collectionAuthority",
          isMut: true,
          isSigner: true,
          desc: "Collection Update authority"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection"
        },
        {
          name: "bubblegumSigner",
          isMut: false,
          isSigner: true,
          desc: "Signing PDA of Bubblegum program"
        },
        {
          name: "collectionAuthorityRecord",
          isMut: false,
          isSigner: false,
          desc: "Collection Authority Record PDA",
          optional: true
        }
      ],
      args: [
        {
          name: "setCollectionSizeArgs",
          type: {
            defined: "SetCollectionSizeArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 36
      }
    },
    {
      name: "BurnEditionNft",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "owner",
          isMut: true,
          isSigner: true,
          desc: "NFT owner"
        },
        {
          name: "printEditionMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of the print edition NFT"
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the original/master NFT"
        },
        {
          name: "printEditionTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account the print edition NFT is in"
        },
        {
          name: "masterEditionTokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account the Master Edition NFT is in"
        },
        {
          name: "masterEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "MasterEdition2 of the original NFT"
        },
        {
          name: "printEditionAccount",
          isMut: true,
          isSigner: false,
          desc: "Print Edition account of the NFT"
        },
        {
          name: "editionMarkerAccount",
          isMut: true,
          isSigner: false,
          desc: "Edition Marker PDA of the NFT"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 37
      }
    },
    {
      name: "CreateEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account of the token"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 38
      }
    },
    {
      name: "CloseEscrowAccount",
      accounts: [
        {
          name: "escrow",
          isMut: true,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "tokenAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 39
      }
    },
    {
      name: "TransferOutOfEscrow",
      accounts: [
        {
          name: "escrow",
          isMut: false,
          isSigner: false,
          desc: "Escrow account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Wallet paying for the transaction and new account"
        },
        {
          name: "attributeMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account for the new attribute"
        },
        {
          name: "attributeSrc",
          isMut: true,
          isSigner: false,
          desc: "Token account source for the new attribute"
        },
        {
          name: "attributeDst",
          isMut: true,
          isSigner: false,
          desc: "Token account, owned by TM, destination for the new attribute"
        },
        {
          name: "escrowMint",
          isMut: false,
          isSigner: false,
          desc: "Mint account that the escrow is attached"
        },
        {
          name: "escrowAccount",
          isMut: false,
          isSigner: false,
          desc: "Token account that holds the token the escrow is attached to"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "ataProgram",
          isMut: false,
          isSigner: false,
          desc: "Associated Token program"
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority/creator of the escrow account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferOutOfEscrowArgs",
          type: {
            defined: "TransferOutOfEscrowArgs"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 40
      }
    },
    {
      name: "Burn",
      accounts: [
        {
          name: "authority",
          isMut: true,
          isSigner: true,
          desc: "Asset owner or Utility delegate"
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata of the Collection",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition of the asset",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account to close"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master edition account",
          optional: true
        },
        {
          name: "masterEditionMint",
          isMut: false,
          isSigner: false,
          desc: "Master edition mint of the asset",
          optional: true
        },
        {
          name: "masterEditionToken",
          isMut: false,
          isSigner: false,
          desc: "Master edition token account",
          optional: true
        },
        {
          name: "editionMarker",
          isMut: true,
          isSigner: false,
          desc: "Edition marker account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        }
      ],
      args: [
        {
          name: "burnArgs",
          type: {
            defined: "BurnArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 41
      }
    },
    {
      name: "Create",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Unallocated metadata account with address as pda of ['metadata', program id, mint id]"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Unallocated edition account with address as pda of ['metadata', program id, mint, 'edition']",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "Update authority for the metadata account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        }
      ],
      args: [
        {
          name: "createArgs",
          type: {
            defined: "CreateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 42
      }
    },
    {
      name: "Mint",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token or Associated Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Owner of the token account",
          optional: true
        },
        {
          name: "metadata",
          isMut: false,
          isSigner: false,
          desc: "Metadata account (pda of ['metadata', program id, mint id])"
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "(Mint or Update) authority"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Metadata delegate record",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "mintArgs",
          type: {
            defined: "MintArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 43
      }
    },
    {
      name: "Delegate",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "delegateArgs",
          type: {
            defined: "DelegateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 44
      }
    },
    {
      name: "Revoke",
      accounts: [
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record account",
          optional: true
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false,
          desc: "Owner of the delegated account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "masterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of metadata"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account of mint",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or token owner"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "revokeArgs",
          type: {
            defined: "RevokeArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 45
      }
    },
    {
      name: "Lock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate or freeze authority"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "lockArgs",
          type: {
            defined: "LockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 46
      }
    },
    {
      name: "Unlock",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Delegate or freeze authority"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token owner account",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "unlockArgs",
          type: {
            defined: "UnlockArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 47
      }
    },
    {
      name: "Migrate",
      accounts: [
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account"
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority"
        },
        {
          name: "collectionMetadata",
          isMut: false,
          isSigner: false,
          desc: "Collection metadata account"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record account"
        },
        {
          name: "tokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instruction sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 48
      }
    },
    {
      name: "Transfer",
      accounts: [
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account"
        },
        {
          name: "tokenOwner",
          isMut: false,
          isSigner: false,
          desc: "Token account owner"
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false,
          desc: "Destination token account"
        },
        {
          name: "destinationOwner",
          isMut: false,
          isSigner: false,
          desc: "Destination token account owner"
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint of token asset"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition of token asset",
          optional: true
        },
        {
          name: "ownerTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Owner token record account",
          optional: true
        },
        {
          name: "destinationTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Destination token record account",
          optional: true
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Transfer authority (token owner or delegate)"
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System Program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "transferArgs",
          type: {
            defined: "TransferArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 49
      }
    },
    {
      name: "Update",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: false,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: false,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "updateArgs",
          type: {
            defined: "UpdateArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 50
      }
    },
    {
      name: "Use",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Token owner or delegate"
        },
        {
          name: "delegateRecord",
          isMut: true,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "token",
          isMut: true,
          isSigner: false,
          desc: "Token account",
          optional: true
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false,
          desc: "Mint account"
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "Edition account",
          optional: true
        },
        {
          name: "payer",
          isMut: false,
          isSigner: true,
          desc: "Payer"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Token Program",
          optional: true
        },
        {
          name: "authorizationRulesProgram",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules Program",
          optional: true
        },
        {
          name: "authorizationRules",
          isMut: false,
          isSigner: false,
          desc: "Token Authorization Rules account",
          optional: true
        }
      ],
      args: [
        {
          name: "useArgs",
          type: {
            defined: "UseArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 51
      }
    },
    {
      name: "Verify",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Creator to verify, collection update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection",
          optional: true
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection",
          optional: true
        },
        {
          name: "collectionMasterEdition",
          isMut: false,
          isSigner: false,
          desc: "Master Edition Account of the Collection Token",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [
        {
          name: "verificationArgs",
          type: {
            defined: "VerificationArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 52
      }
    },
    {
      name: "Unverify",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Creator to verify, collection (or metadata if parent burned) update authority or delegate"
        },
        {
          name: "delegateRecord",
          isMut: false,
          isSigner: false,
          desc: "Delegate record PDA",
          optional: true
        },
        {
          name: "metadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata account"
        },
        {
          name: "collectionMint",
          isMut: false,
          isSigner: false,
          desc: "Mint of the Collection",
          optional: true
        },
        {
          name: "collectionMetadata",
          isMut: true,
          isSigner: false,
          desc: "Metadata Account of the Collection",
          optional: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        }
      ],
      args: [
        {
          name: "verificationArgs",
          type: {
            defined: "VerificationArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 53
      }
    },
    {
      name: "Collect",
      accounts: [
        {
          name: "authority",
          isMut: false,
          isSigner: true,
          desc: "Authority to collect fees"
        },
        {
          name: "pdaAccount",
          isMut: false,
          isSigner: false,
          desc: "PDA to retrieve fees from"
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 54
      }
    },
    {
      name: "Print",
      accounts: [
        {
          name: "editionMetadata",
          isMut: true,
          isSigner: false,
          desc: "New Metadata key (pda of ['metadata', program id, mint id])"
        },
        {
          name: "edition",
          isMut: true,
          isSigner: false,
          desc: "New Edition (pda of ['metadata', program id, mint id, 'edition'])"
        },
        {
          name: "editionMint",
          isMut: true,
          isSigner: false,
          desc: "Mint of new token - THIS WILL TRANSFER AUTHORITY AWAY FROM THIS KEY"
        },
        {
          name: "editionTokenAccountOwner",
          isMut: false,
          isSigner: false,
          desc: "Owner of the token account of new token"
        },
        {
          name: "editionTokenAccount",
          isMut: true,
          isSigner: false,
          desc: "Token account of new token"
        },
        {
          name: "editionMintAuthority",
          isMut: false,
          isSigner: true,
          desc: "Mint authority of new mint"
        },
        {
          name: "editionTokenRecord",
          isMut: true,
          isSigner: false,
          desc: "Token record account",
          optional: true
        },
        {
          name: "masterEdition",
          isMut: true,
          isSigner: false,
          desc: "Master Record Edition V2 (pda of ['metadata', program id, master metadata mint id, 'edition'])"
        },
        {
          name: "editionMarkerPda",
          isMut: true,
          isSigner: false,
          desc: "Edition pda to mark creation - will be checked for pre-existence. (pda of ['metadata', program id, master metadata mint id, 'edition', edition_number]) where edition_number is NOT the edition number you pass in args but actually edition_number = floor(edition/EDITION_MARKER_BIT_SIZE)."
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true,
          desc: "payer"
        },
        {
          name: "masterTokenAccountOwner",
          isMut: false,
          isSigner: true,
          desc: "owner of token account containing master token"
        },
        {
          name: "masterTokenAccount",
          isMut: false,
          isSigner: false,
          desc: "token account containing token from master metadata mint"
        },
        {
          name: "masterMetadata",
          isMut: false,
          isSigner: false,
          desc: "Master record metadata account"
        },
        {
          name: "updateAuthority",
          isMut: false,
          isSigner: false,
          desc: "The update authority of the master edition."
        },
        {
          name: "splTokenProgram",
          isMut: false,
          isSigner: false,
          desc: "Token program"
        },
        {
          name: "splAtaProgram",
          isMut: false,
          isSigner: false,
          desc: "SPL Associated Token Account program"
        },
        {
          name: "sysvarInstructions",
          isMut: false,
          isSigner: false,
          desc: "Instructions sysvar account"
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false,
          desc: "System program"
        }
      ],
      args: [
        {
          name: "printArgs",
          type: {
            defined: "PrintArgs"
          }
        }
      ],
      defaultOptionalAccounts: true,
      discriminant: {
        type: "u8",
        value: 55
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "Edition",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "parent",
            type: "publicKey"
          },
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          },
          {
            name: "printingMint",
            type: "publicKey"
          },
          {
            name: "oneTimePrintingAuthorizationMint",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "ReservationListV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "ReservationV1"
              }
            }
          }
        ]
      }
    },
    {
      name: "Metadata",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "editionNonce",
            type: {
              option: "u8"
            }
          },
          {
            name: "tokenStandard",
            type: {
              option: {
                defined: "TokenStandard"
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "programmableConfig",
            type: {
              option: {
                defined: "ProgrammableConfig"
              }
            }
          }
        ]
      }
    },
    {
      name: "ReservationListV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "masterEdition",
            type: "publicKey"
          },
          {
            name: "supplySnapshot",
            type: {
              option: "u64"
            }
          },
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: "u64"
          },
          {
            name: "currentReservationSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "MasterEditionV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "EditionMarker",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: {
              array: ["u8", 31]
            }
          }
        ]
      }
    },
    {
      name: "UseAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "allowedUses",
            type: "u64"
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "CollectionAuthorityRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "TokenOwnedEscrow",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "baseToken",
            type: "publicKey"
          },
          {
            name: "authority",
            type: {
              defined: "EscrowAuthority"
            }
          },
          {
            name: "bump",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "TokenRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "state",
            type: {
              defined: "TokenState"
            }
          },
          {
            name: "ruleSetRevision",
            type: {
              option: "u64"
            }
          },
          {
            name: "delegate",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "delegateRole",
            type: {
              option: {
                defined: "TokenDelegateRole"
              }
            }
          },
          {
            name: "lockedTransfer",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRecord",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "bump",
            type: "u8"
          },
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "delegate",
            type: "publicKey"
          },
          {
            name: "updateAuthority",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "EditionMarkerV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "key",
            type: {
              defined: "Key"
            }
          },
          {
            name: "ledger",
            type: "bytes"
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "SetCollectionSizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "size",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "Data"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "Data"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "MintPrintingTokensViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "supply",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "SetReservationListArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "reservations",
            type: {
              vec: {
                defined: "Reservation"
              }
            }
          },
          {
            name: "totalReservationSpots",
            type: {
              option: "u64"
            }
          },
          {
            name: "offset",
            type: "u64"
          },
          {
            name: "totalSpotOffset",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMasterEditionArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "maxSupply",
            type: {
              option: "u64"
            }
          }
        ]
      }
    },
    {
      name: "MintNewEditionFromMasterEditionViaTokenArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "edition",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "TransferOutOfEscrowArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "amount",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "CreateMetadataAccountArgsV3",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              defined: "DataV2"
            }
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          }
        ]
      }
    },
    {
      name: "UpdateMetadataAccountArgsV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "data",
            type: {
              option: {
                defined: "DataV2"
              }
            }
          },
          {
            name: "updateAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "primarySaleHappened",
            type: {
              option: "bool"
            }
          },
          {
            name: "isMutable",
            type: {
              option: "bool"
            }
          }
        ]
      }
    },
    {
      name: "ApproveUseAuthorityArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "UtilizeArgs",
      type: {
        kind: "struct",
        fields: [
          {
            name: "numberOfUses",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "AuthorizationData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "payload",
            type: {
              defined: "Payload"
            }
          }
        ]
      }
    },
    {
      name: "AssetData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "primarySaleHappened",
            type: "bool"
          },
          {
            name: "isMutable",
            type: "bool"
          },
          {
            name: "tokenStandard",
            type: {
              defined: "TokenStandard"
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          },
          {
            name: "collectionDetails",
            type: {
              option: {
                defined: "CollectionDetails"
              }
            }
          },
          {
            name: "ruleSet",
            type: {
              option: "publicKey"
            }
          }
        ]
      }
    },
    {
      name: "Collection",
      type: {
        kind: "struct",
        fields: [
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "key",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Creator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "verified",
            type: "bool"
          },
          {
            name: "share",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "Data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          }
        ]
      }
    },
    {
      name: "DataV2",
      type: {
        kind: "struct",
        fields: [
          {
            name: "name",
            type: "string"
          },
          {
            name: "symbol",
            type: "string"
          },
          {
            name: "uri",
            type: "string"
          },
          {
            name: "sellerFeeBasisPoints",
            type: "u16"
          },
          {
            name: "creators",
            type: {
              option: {
                vec: {
                  defined: "Creator"
                }
              }
            }
          },
          {
            name: "collection",
            type: {
              option: {
                defined: "Collection"
              }
            }
          },
          {
            name: "uses",
            type: {
              option: {
                defined: "Uses"
              }
            }
          }
        ]
      }
    },
    {
      name: "Reservation",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u64"
          },
          {
            name: "totalSpots",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ReservationV1",
      type: {
        kind: "struct",
        fields: [
          {
            name: "address",
            type: "publicKey"
          },
          {
            name: "spotsRemaining",
            type: "u8"
          },
          {
            name: "totalSpots",
            type: "u8"
          }
        ]
      }
    },
    {
      name: "SeedsVec",
      type: {
        kind: "struct",
        fields: [
          {
            name: "seeds",
            type: {
              vec: "bytes"
            }
          }
        ]
      }
    },
    {
      name: "LeafInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "leaf",
            type: {
              array: ["u8", 32]
            }
          },
          {
            name: "proof",
            type: {
              vec: {
                array: ["u8", 32]
              }
            }
          }
        ]
      }
    },
    {
      name: "Payload",
      type: {
        kind: "struct",
        fields: [
          {
            name: "map",
            type: {
              hashMap: [
                "string",
                {
                  defined: "PayloadType"
                }
              ]
            }
          }
        ]
      }
    },
    {
      name: "Uses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "useMethod",
            type: {
              defined: "UseMethod"
            }
          },
          {
            name: "remaining",
            type: "u64"
          },
          {
            name: "total",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "BurnArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "DelegateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "SaleV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "TransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "DataV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "UtilityV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StakingV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "StandardV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              }
            ]
          },
          {
            name: "LockedTransferV1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "locked_address",
                type: "publicKey"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "ProgrammableConfigV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AuthorityItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "DataItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "CollectionItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "ProgrammableConfigItemV1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "RevokeArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "SaleV1"
          },
          {
            name: "TransferV1"
          },
          {
            name: "DataV1"
          },
          {
            name: "UtilityV1"
          },
          {
            name: "StakingV1"
          },
          {
            name: "StandardV1"
          },
          {
            name: "LockedTransferV1"
          },
          {
            name: "ProgrammableConfigV1"
          },
          {
            name: "MigrationV1"
          },
          {
            name: "AuthorityItemV1"
          },
          {
            name: "DataItemV1"
          },
          {
            name: "CollectionItemV1"
          },
          {
            name: "ProgrammableConfigItemV1"
          }
        ]
      }
    },
    {
      name: "MetadataDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "AuthorityItem"
          },
          {
            name: "Collection"
          },
          {
            name: "Use"
          },
          {
            name: "Data"
          },
          {
            name: "ProgrammableConfig"
          },
          {
            name: "DataItem"
          },
          {
            name: "CollectionItem"
          },
          {
            name: "ProgrammableConfigItem"
          }
        ]
      }
    },
    {
      name: "CreateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "asset_data",
                type: {
                  defined: "AssetData"
                }
              },
              {
                name: "decimals",
                type: {
                  option: "u8"
                }
              },
              {
                name: "print_supply",
                type: {
                  option: {
                    defined: "PrintSupply"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MintArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "TransferArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "amount",
                type: "u64"
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UpdateArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "collection_details",
                type: {
                  defined: "CollectionDetailsToggle"
                }
              },
              {
                name: "uses",
                type: {
                  defined: "UsesToggle"
                }
              },
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsUpdateAuthorityV2",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "collection_details",
                type: {
                  defined: "CollectionDetailsToggle"
                }
              },
              {
                name: "uses",
                type: {
                  defined: "UsesToggle"
                }
              },
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "token_standard",
                type: {
                  option: {
                    defined: "TokenStandard"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsAuthorityItemDelegateV2",
            fields: [
              {
                name: "new_update_authority",
                type: {
                  option: "publicKey"
                }
              },
              {
                name: "primary_sale_happened",
                type: {
                  option: "bool"
                }
              },
              {
                name: "is_mutable",
                type: {
                  option: "bool"
                }
              },
              {
                name: "token_standard",
                type: {
                  option: {
                    defined: "TokenStandard"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsCollectionDelegateV2",
            fields: [
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsDataDelegateV2",
            fields: [
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsProgrammableConfigDelegateV2",
            fields: [
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsDataItemDelegateV2",
            fields: [
              {
                name: "data",
                type: {
                  option: {
                    defined: "Data"
                  }
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsCollectionItemDelegateV2",
            fields: [
              {
                name: "collection",
                type: {
                  defined: "CollectionToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          },
          {
            name: "AsProgrammableConfigItemDelegateV2",
            fields: [
              {
                name: "rule_set",
                type: {
                  defined: "RuleSetToggle"
                }
              },
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Collection"
              }
            ]
          }
        ]
      }
    },
    {
      name: "UsesToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "Uses"
              }
            ]
          }
        ]
      }
    },
    {
      name: "CollectionDetailsToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: [
              {
                defined: "CollectionDetails"
              }
            ]
          }
        ]
      }
    },
    {
      name: "RuleSetToggle",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Clear"
          },
          {
            name: "Set",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "PrintArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "edition",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "LockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UnlockArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "UseArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "authorization_data",
                type: {
                  option: {
                    defined: "AuthorizationData"
                  }
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "VerificationArgs",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CreatorV1"
          },
          {
            name: "CollectionV1"
          }
        ]
      }
    },
    {
      name: "TokenStandard",
      type: {
        kind: "enum",
        variants: [
          {
            name: "NonFungible"
          },
          {
            name: "FungibleAsset"
          },
          {
            name: "Fungible"
          },
          {
            name: "NonFungibleEdition"
          },
          {
            name: "ProgrammableNonFungible"
          },
          {
            name: "ProgrammableNonFungibleEdition"
          }
        ]
      }
    },
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "EditionV1"
          },
          {
            name: "MasterEditionV1"
          },
          {
            name: "ReservationListV1"
          },
          {
            name: "MetadataV1"
          },
          {
            name: "ReservationListV2"
          },
          {
            name: "MasterEditionV2"
          },
          {
            name: "EditionMarker"
          },
          {
            name: "UseAuthorityRecord"
          },
          {
            name: "CollectionAuthorityRecord"
          },
          {
            name: "TokenOwnedEscrow"
          },
          {
            name: "TokenRecord"
          },
          {
            name: "MetadataDelegate"
          },
          {
            name: "EditionMarkerV2"
          }
        ]
      }
    },
    {
      name: "CollectionDetails",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "size",
                type: "u64"
              }
            ]
          }
        ]
      }
    },
    {
      name: "EscrowAuthority",
      type: {
        kind: "enum",
        variants: [
          {
            name: "TokenOwner"
          },
          {
            name: "Creator",
            fields: ["publicKey"]
          }
        ]
      }
    },
    {
      name: "PrintSupply",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Zero"
          },
          {
            name: "Limited",
            fields: ["u64"]
          },
          {
            name: "Unlimited"
          }
        ]
      }
    },
    {
      name: "ProgrammableConfig",
      type: {
        kind: "enum",
        variants: [
          {
            name: "V1",
            fields: [
              {
                name: "rule_set",
                type: {
                  option: "publicKey"
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "MigrationType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "CollectionV1"
          },
          {
            name: "ProgrammableV1"
          }
        ]
      }
    },
    {
      name: "TokenState",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Unlocked"
          },
          {
            name: "Locked"
          },
          {
            name: "Listed"
          }
        ]
      }
    },
    {
      name: "TokenDelegateRole",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Sale"
          },
          {
            name: "Transfer"
          },
          {
            name: "Utility"
          },
          {
            name: "Staking"
          },
          {
            name: "Standard"
          },
          {
            name: "LockedTransfer"
          },
          {
            name: "Migration"
          }
        ]
      }
    },
    {
      name: "AuthorityType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "None"
          },
          {
            name: "Metadata"
          },
          {
            name: "Holder"
          },
          {
            name: "MetadataDelegate"
          },
          {
            name: "TokenDelegate"
          }
        ]
      }
    },
    {
      name: "PayloadKey",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Amount"
          },
          {
            name: "Authority"
          },
          {
            name: "AuthoritySeeds"
          },
          {
            name: "Delegate"
          },
          {
            name: "DelegateSeeds"
          },
          {
            name: "Destination"
          },
          {
            name: "DestinationSeeds"
          },
          {
            name: "Holder"
          },
          {
            name: "Source"
          },
          {
            name: "SourceSeeds"
          }
        ]
      }
    },
    {
      name: "PayloadType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Pubkey",
            fields: ["publicKey"]
          },
          {
            name: "Seeds",
            fields: [
              {
                defined: "SeedsVec"
              }
            ]
          },
          {
            name: "MerkleProof",
            fields: [
              {
                defined: "LeafInfo"
              }
            ]
          },
          {
            name: "Number",
            fields: ["u64"]
          }
        ]
      }
    },
    {
      name: "UseMethod",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Burn"
          },
          {
            name: "Multiple"
          },
          {
            name: "Single"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InstructionUnpackError",
      msg: ""
    },
    {
      code: 1,
      name: "InstructionPackError",
      msg: ""
    },
    {
      code: 2,
      name: "NotRentExempt",
      msg: "Lamport balance below rent-exempt threshold"
    },
    {
      code: 3,
      name: "AlreadyInitialized",
      msg: "Already initialized"
    },
    {
      code: 4,
      name: "Uninitialized",
      msg: "Uninitialized"
    },
    {
      code: 5,
      name: "InvalidMetadataKey",
      msg: " Metadata's key must match seed of ['metadata', program id, mint] provided"
    },
    {
      code: 6,
      name: "InvalidEditionKey",
      msg: "Edition's key must match seed of ['metadata', program id, name, 'edition'] provided"
    },
    {
      code: 7,
      name: "UpdateAuthorityIncorrect",
      msg: "Update Authority given does not match"
    },
    {
      code: 8,
      name: "UpdateAuthorityIsNotSigner",
      msg: "Update Authority needs to be signer to update metadata"
    },
    {
      code: 9,
      name: "NotMintAuthority",
      msg: "You must be the mint authority and signer on this transaction"
    },
    {
      code: 10,
      name: "InvalidMintAuthority",
      msg: "Mint authority provided does not match the authority on the mint"
    },
    {
      code: 11,
      name: "NameTooLong",
      msg: "Name too long"
    },
    {
      code: 12,
      name: "SymbolTooLong",
      msg: "Symbol too long"
    },
    {
      code: 13,
      name: "UriTooLong",
      msg: "URI too long"
    },
    {
      code: 14,
      name: "UpdateAuthorityMustBeEqualToMetadataAuthorityAndSigner",
      msg: ""
    },
    {
      code: 15,
      name: "MintMismatch",
      msg: "Mint given does not match mint on Metadata"
    },
    {
      code: 16,
      name: "EditionsMustHaveExactlyOneToken",
      msg: "Editions must have exactly one token"
    },
    {
      code: 17,
      name: "MaxEditionsMintedAlready",
      msg: ""
    },
    {
      code: 18,
      name: "TokenMintToFailed",
      msg: ""
    },
    {
      code: 19,
      name: "MasterRecordMismatch",
      msg: ""
    },
    {
      code: 20,
      name: "DestinationMintMismatch",
      msg: ""
    },
    {
      code: 21,
      name: "EditionAlreadyMinted",
      msg: ""
    },
    {
      code: 22,
      name: "PrintingMintDecimalsShouldBeZero",
      msg: ""
    },
    {
      code: 23,
      name: "OneTimePrintingAuthorizationMintDecimalsShouldBeZero",
      msg: ""
    },
    {
      code: 24,
      name: "EditionMintDecimalsShouldBeZero",
      msg: "EditionMintDecimalsShouldBeZero"
    },
    {
      code: 25,
      name: "TokenBurnFailed",
      msg: ""
    },
    {
      code: 26,
      name: "TokenAccountOneTimeAuthMintMismatch",
      msg: ""
    },
    {
      code: 27,
      name: "DerivedKeyInvalid",
      msg: "Derived key invalid"
    },
    {
      code: 28,
      name: "PrintingMintMismatch",
      msg: "The Printing mint does not match that on the master edition!"
    },
    {
      code: 29,
      name: "OneTimePrintingAuthMintMismatch",
      msg: "The One Time Printing Auth mint does not match that on the master edition!"
    },
    {
      code: 30,
      name: "TokenAccountMintMismatch",
      msg: "The mint of the token account does not match the Printing mint!"
    },
    {
      code: 31,
      name: "TokenAccountMintMismatchV2",
      msg: "The mint of the token account does not match the master metadata mint!"
    },
    {
      code: 32,
      name: "NotEnoughTokens",
      msg: "Not enough tokens to mint a limited edition"
    },
    {
      code: 33,
      name: "PrintingMintAuthorizationAccountMismatch",
      msg: ""
    },
    {
      code: 34,
      name: "AuthorizationTokenAccountOwnerMismatch",
      msg: ""
    },
    {
      code: 35,
      name: "Disabled",
      msg: ""
    },
    {
      code: 36,
      name: "CreatorsTooLong",
      msg: "Creators list too long"
    },
    {
      code: 37,
      name: "CreatorsMustBeAtleastOne",
      msg: "Creators must be at least one if set"
    },
    {
      code: 38,
      name: "MustBeOneOfCreators",
      msg: ""
    },
    {
      code: 39,
      name: "NoCreatorsPresentOnMetadata",
      msg: "This metadata does not have creators"
    },
    {
      code: 40,
      name: "CreatorNotFound",
      msg: "This creator address was not found"
    },
    {
      code: 41,
      name: "InvalidBasisPoints",
      msg: "Basis points cannot be more than 10000"
    },
    {
      code: 42,
      name: "PrimarySaleCanOnlyBeFlippedToTrue",
      msg: "Primary sale can only be flipped to true and is immutable"
    },
    {
      code: 43,
      name: "OwnerMismatch",
      msg: "Owner does not match that on the account given"
    },
    {
      code: 44,
      name: "NoBalanceInAccountForAuthorization",
      msg: "This account has no tokens to be used for authorization"
    },
    {
      code: 45,
      name: "ShareTotalMustBe100",
      msg: "Share total must equal 100 for creator array"
    },
    {
      code: 46,
      name: "ReservationExists",
      msg: ""
    },
    {
      code: 47,
      name: "ReservationDoesNotExist",
      msg: ""
    },
    {
      code: 48,
      name: "ReservationNotSet",
      msg: ""
    },
    {
      code: 49,
      name: "ReservationAlreadyMade",
      msg: ""
    },
    {
      code: 50,
      name: "BeyondMaxAddressSize",
      msg: ""
    },
    {
      code: 51,
      name: "NumericalOverflowError",
      msg: "NumericalOverflowError"
    },
    {
      code: 52,
      name: "ReservationBreachesMaximumSupply",
      msg: ""
    },
    {
      code: 53,
      name: "AddressNotInReservation",
      msg: ""
    },
    {
      code: 54,
      name: "CannotVerifyAnotherCreator",
      msg: "You cannot unilaterally verify another creator, they must sign"
    },
    {
      code: 55,
      name: "CannotUnverifyAnotherCreator",
      msg: "You cannot unilaterally unverify another creator"
    },
    {
      code: 56,
      name: "SpotMismatch",
      msg: ""
    },
    {
      code: 57,
      name: "IncorrectOwner",
      msg: "Incorrect account owner"
    },
    {
      code: 58,
      name: "PrintingWouldBreachMaximumSupply",
      msg: ""
    },
    {
      code: 59,
      name: "DataIsImmutable",
      msg: "Data is immutable"
    },
    {
      code: 60,
      name: "DuplicateCreatorAddress",
      msg: "No duplicate creator addresses"
    },
    {
      code: 61,
      name: "ReservationSpotsRemainingShouldMatchTotalSpotsAtStart",
      msg: ""
    },
    {
      code: 62,
      name: "InvalidTokenProgram",
      msg: "Invalid token program"
    },
    {
      code: 63,
      name: "DataTypeMismatch",
      msg: "Data type mismatch"
    },
    {
      code: 64,
      name: "BeyondAlottedAddressSize",
      msg: ""
    },
    {
      code: 65,
      name: "ReservationNotComplete",
      msg: ""
    },
    {
      code: 66,
      name: "TriedToReplaceAnExistingReservation",
      msg: ""
    },
    {
      code: 67,
      name: "InvalidOperation",
      msg: "Invalid operation"
    },
    {
      code: 68,
      name: "InvalidOwner",
      msg: "Invalid Owner"
    },
    {
      code: 69,
      name: "PrintingMintSupplyMustBeZeroForConversion",
      msg: "Printing mint supply must be zero for conversion"
    },
    {
      code: 70,
      name: "OneTimeAuthMintSupplyMustBeZeroForConversion",
      msg: "One Time Auth mint supply must be zero for conversion"
    },
    {
      code: 71,
      name: "InvalidEditionIndex",
      msg: "You tried to insert one edition too many into an edition mark pda"
    },
    {
      code: 72,
      name: "ReservationArrayShouldBeSizeOne",
      msg: ""
    },
    {
      code: 73,
      name: "IsMutableCanOnlyBeFlippedToFalse",
      msg: "Is Mutable can only be flipped to false"
    },
    {
      code: 74,
      name: "CollectionCannotBeVerifiedInThisInstruction",
      msg: "Collection cannot be verified in this instruction"
    },
    {
      code: 75,
      name: "Removed",
      msg: "This instruction was deprecated in a previous release and is now removed"
    },
    {
      code: 76,
      name: "MustBeBurned",
      msg: ""
    },
    {
      code: 77,
      name: "InvalidUseMethod",
      msg: "This use method is invalid"
    },
    {
      code: 78,
      name: "CannotChangeUseMethodAfterFirstUse",
      msg: "Cannot Change Use Method after the first use"
    },
    {
      code: 79,
      name: "CannotChangeUsesAfterFirstUse",
      msg: "Cannot Change Remaining or Available uses after the first use"
    },
    {
      code: 80,
      name: "CollectionNotFound",
      msg: "Collection Not Found on Metadata"
    },
    {
      code: 81,
      name: "InvalidCollectionUpdateAuthority",
      msg: "Collection Update Authority is invalid"
    },
    {
      code: 82,
      name: "CollectionMustBeAUniqueMasterEdition",
      msg: "Collection Must Be a Unique Master Edition v2"
    },
    {
      code: 83,
      name: "UseAuthorityRecordAlreadyExists",
      msg: "The Use Authority Record Already Exists, to modify it Revoke, then Approve"
    },
    {
      code: 84,
      name: "UseAuthorityRecordAlreadyRevoked",
      msg: "The Use Authority Record is empty or already revoked"
    },
    {
      code: 85,
      name: "Unusable",
      msg: "This token has no uses"
    },
    {
      code: 86,
      name: "NotEnoughUses",
      msg: "There are not enough Uses left on this token."
    },
    {
      code: 87,
      name: "CollectionAuthorityRecordAlreadyExists",
      msg: "This Collection Authority Record Already Exists."
    },
    {
      code: 88,
      name: "CollectionAuthorityDoesNotExist",
      msg: "This Collection Authority Record Does Not Exist."
    },
    {
      code: 89,
      name: "InvalidUseAuthorityRecord",
      msg: "This Use Authority Record is invalid."
    },
    {
      code: 90,
      name: "InvalidCollectionAuthorityRecord",
      msg: ""
    },
    {
      code: 91,
      name: "InvalidFreezeAuthority",
      msg: "Metadata does not match the freeze authority on the mint"
    },
    {
      code: 92,
      name: "InvalidDelegate",
      msg: "All tokens in this account have not been delegated to this user."
    },
    {
      code: 93,
      name: "CannotAdjustVerifiedCreator",
      msg: ""
    },
    {
      code: 94,
      name: "CannotRemoveVerifiedCreator",
      msg: "Verified creators cannot be removed."
    },
    {
      code: 95,
      name: "CannotWipeVerifiedCreators",
      msg: ""
    },
    {
      code: 96,
      name: "NotAllowedToChangeSellerFeeBasisPoints",
      msg: ""
    },
    {
      code: 97,
      name: "EditionOverrideCannotBeZero",
      msg: "Edition override cannot be zero"
    },
    {
      code: 98,
      name: "InvalidUser",
      msg: "Invalid User"
    },
    {
      code: 99,
      name: "RevokeCollectionAuthoritySignerIncorrect",
      msg: "Revoke Collection Authority signer is incorrect"
    },
    {
      code: 100,
      name: "TokenCloseFailed",
      msg: ""
    },
    {
      code: 101,
      name: "UnsizedCollection",
      msg: "Can't use this function on unsized collection"
    },
    {
      code: 102,
      name: "SizedCollection",
      msg: "Can't use this function on a sized collection"
    },
    {
      code: 103,
      name: "MissingCollectionMetadata",
      msg: "Missing collection metadata account"
    },
    {
      code: 104,
      name: "NotAMemberOfCollection",
      msg: "This NFT is not a member of the specified collection."
    },
    {
      code: 105,
      name: "NotVerifiedMemberOfCollection",
      msg: "This NFT is not a verified member of the specified collection."
    },
    {
      code: 106,
      name: "NotACollectionParent",
      msg: "This NFT is not a collection parent NFT."
    },
    {
      code: 107,
      name: "CouldNotDetermineTokenStandard",
      msg: "Could not determine a TokenStandard type."
    },
    {
      code: 108,
      name: "MissingEditionAccount",
      msg: "This mint account has an edition but none was provided."
    },
    {
      code: 109,
      name: "NotAMasterEdition",
      msg: "This edition is not a Master Edition"
    },
    {
      code: 110,
      name: "MasterEditionHasPrints",
      msg: "This Master Edition has existing prints"
    },
    {
      code: 111,
      name: "BorshDeserializationError",
      msg: ""
    },
    {
      code: 112,
      name: "CannotUpdateVerifiedCollection",
      msg: "Cannot update a verified collection in this command"
    },
    {
      code: 113,
      name: "CollectionMasterEditionAccountInvalid",
      msg: "Edition account doesnt match collection "
    },
    {
      code: 114,
      name: "AlreadyVerified",
      msg: "Item is already verified."
    },
    {
      code: 115,
      name: "AlreadyUnverified",
      msg: ""
    },
    {
      code: 116,
      name: "NotAPrintEdition",
      msg: "This edition is not a Print Edition"
    },
    {
      code: 117,
      name: "InvalidMasterEdition",
      msg: "Invalid Master Edition"
    },
    {
      code: 118,
      name: "InvalidPrintEdition",
      msg: "Invalid Print Edition"
    },
    {
      code: 119,
      name: "InvalidEditionMarker",
      msg: "Invalid Edition Marker"
    },
    {
      code: 120,
      name: "ReservationListDeprecated",
      msg: "Reservation List is Deprecated"
    },
    {
      code: 121,
      name: "PrintEditionDoesNotMatchMasterEdition",
      msg: "Print Edition does not match Master Edition"
    },
    {
      code: 122,
      name: "EditionNumberGreaterThanMaxSupply",
      msg: "Edition Number greater than max supply"
    },
    {
      code: 123,
      name: "MustUnverify",
      msg: "Must unverify before migrating collections."
    },
    {
      code: 124,
      name: "InvalidEscrowBumpSeed",
      msg: "Invalid Escrow Account Bump Seed"
    },
    {
      code: 125,
      name: "MustBeEscrowAuthority",
      msg: "Must Escrow Authority"
    },
    {
      code: 126,
      name: "InvalidSystemProgram",
      msg: "Invalid System Program"
    },
    {
      code: 127,
      name: "MustBeNonFungible",
      msg: "Must be a Non Fungible Token"
    },
    {
      code: 128,
      name: "InsufficientTokens",
      msg: "Insufficient tokens for transfer"
    },
    {
      code: 129,
      name: "BorshSerializationError",
      msg: "Borsh Serialization Error"
    },
    {
      code: 130,
      name: "NoFreezeAuthoritySet",
      msg: "Cannot create NFT with no Freeze Authority."
    },
    {
      code: 131,
      name: "InvalidCollectionSizeChange",
      msg: "Invalid collection size change"
    },
    {
      code: 132,
      name: "InvalidBubblegumSigner",
      msg: "Invalid bubblegum signer"
    },
    {
      code: 133,
      name: "EscrowParentHasDelegate",
      msg: "Escrow parent cannot have a delegate"
    },
    {
      code: 134,
      name: "MintIsNotSigner",
      msg: "Mint needs to be signer to initialize the account"
    },
    {
      code: 135,
      name: "InvalidTokenStandard",
      msg: "Invalid token standard"
    },
    {
      code: 136,
      name: "InvalidMintForTokenStandard",
      msg: "Invalid mint account for specified token standard"
    },
    {
      code: 137,
      name: "InvalidAuthorizationRules",
      msg: "Invalid authorization rules account"
    },
    {
      code: 138,
      name: "MissingAuthorizationRules",
      msg: "Missing authorization rules account"
    },
    {
      code: 139,
      name: "MissingProgrammableConfig",
      msg: "Missing programmable configuration"
    },
    {
      code: 140,
      name: "InvalidProgrammableConfig",
      msg: "Invalid programmable configuration"
    },
    {
      code: 141,
      name: "DelegateAlreadyExists",
      msg: "Delegate already exists"
    },
    {
      code: 142,
      name: "DelegateNotFound",
      msg: "Delegate not found"
    },
    {
      code: 143,
      name: "MissingAccountInBuilder",
      msg: "Required account not set in instruction builder"
    },
    {
      code: 144,
      name: "MissingArgumentInBuilder",
      msg: "Required argument not set in instruction builder"
    },
    {
      code: 145,
      name: "FeatureNotSupported",
      msg: "Feature not supported currently"
    },
    {
      code: 146,
      name: "InvalidSystemWallet",
      msg: "Invalid system wallet"
    },
    {
      code: 147,
      name: "OnlySaleDelegateCanTransfer",
      msg: "Only the sale delegate can transfer while its set"
    },
    {
      code: 148,
      name: "MissingTokenAccount",
      msg: "Missing token account"
    },
    {
      code: 149,
      name: "MissingSplTokenProgram",
      msg: "Missing SPL token program"
    },
    {
      code: 150,
      name: "MissingAuthorizationRulesProgram",
      msg: "Missing authorization rules program"
    },
    {
      code: 151,
      name: "InvalidDelegateRoleForTransfer",
      msg: "Invalid delegate role for transfer"
    },
    {
      code: 152,
      name: "InvalidTransferAuthority",
      msg: "Invalid transfer authority"
    },
    {
      code: 153,
      name: "InstructionNotSupported",
      msg: "Instruction not supported for ProgrammableNonFungible assets"
    },
    {
      code: 154,
      name: "KeyMismatch",
      msg: "Public key does not match expected value"
    },
    {
      code: 155,
      name: "LockedToken",
      msg: "Token is locked"
    },
    {
      code: 156,
      name: "UnlockedToken",
      msg: "Token is unlocked"
    },
    {
      code: 157,
      name: "MissingDelegateRole",
      msg: "Missing delegate role"
    },
    {
      code: 158,
      name: "InvalidAuthorityType",
      msg: "Invalid authority type"
    },
    {
      code: 159,
      name: "MissingTokenRecord",
      msg: "Missing token record account"
    },
    {
      code: 160,
      name: "MintSupplyMustBeZero",
      msg: "Mint supply must be zero for programmable assets"
    },
    {
      code: 161,
      name: "DataIsEmptyOrZeroed",
      msg: "Data is empty or zeroed"
    },
    {
      code: 162,
      name: "MissingTokenOwnerAccount",
      msg: "Missing token owner"
    },
    {
      code: 163,
      name: "InvalidMasterEditionAccountLength",
      msg: "Master edition account has an invalid length"
    },
    {
      code: 164,
      name: "IncorrectTokenState",
      msg: "Incorrect token state"
    },
    {
      code: 165,
      name: "InvalidDelegateRole",
      msg: "Invalid delegate role"
    },
    {
      code: 166,
      name: "MissingPrintSupply",
      msg: "Print supply is required for non-fungibles"
    },
    {
      code: 167,
      name: "MissingMasterEditionAccount",
      msg: "Missing master edition account"
    },
    {
      code: 168,
      name: "AmountMustBeGreaterThanZero",
      msg: "Amount must be greater than zero"
    },
    {
      code: 169,
      name: "InvalidDelegateArgs",
      msg: "Invalid delegate args"
    },
    {
      code: 170,
      name: "MissingLockedTransferAddress",
      msg: "Missing address for locked transfer"
    },
    {
      code: 171,
      name: "InvalidLockedTransferAddress",
      msg: "Invalid destination address for locked transfer"
    },
    {
      code: 172,
      name: "DataIncrementLimitExceeded",
      msg: "Exceeded account realloc increase limit"
    },
    {
      code: 173,
      name: "CannotUpdateAssetWithDelegate",
      msg: "Cannot update the rule set of a programmable asset that has a delegate"
    },
    {
      code: 174,
      name: "InvalidAmount",
      msg: "Invalid token amount for this operation or token standard"
    },
    {
      code: 175,
      name: "MissingMasterEditionMintAccount",
      msg: "Missing master edition mint account"
    },
    {
      code: 176,
      name: "MissingMasterEditionTokenAccount",
      msg: "Missing master edition token account"
    },
    {
      code: 177,
      name: "MissingEditionMarkerAccount",
      msg: "Missing edition marker account"
    },
    {
      code: 178,
      name: "CannotBurnWithDelegate",
      msg: "Cannot burn while persistent delegate is set"
    },
    {
      code: 179,
      name: "MissingEdition",
      msg: "Missing edition account"
    },
    {
      code: 180,
      name: "InvalidAssociatedTokenAccountProgram",
      msg: "Invalid Associated Token Account Program"
    },
    {
      code: 181,
      name: "InvalidInstructionsSysvar",
      msg: "Invalid InstructionsSysvar"
    },
    {
      code: 182,
      name: "InvalidParentAccounts",
      msg: "Invalid or Unneeded parent accounts"
    },
    {
      code: 183,
      name: "InvalidUpdateArgs",
      msg: "Authority cannot apply all update args"
    },
    {
      code: 184,
      name: "InsufficientTokenBalance",
      msg: "Token account does not have enough tokens"
    },
    {
      code: 185,
      name: "MissingCollectionMint",
      msg: "Missing collection account"
    },
    {
      code: 186,
      name: "MissingCollectionMasterEdition",
      msg: "Missing collection master edition account"
    },
    {
      code: 187,
      name: "InvalidTokenRecord",
      msg: "Invalid token record account"
    },
    {
      code: 188,
      name: "InvalidCloseAuthority",
      msg: "The close authority needs to be revoked by the Utility Delegate"
    },
    {
      code: 189,
      name: "InvalidInstruction",
      msg: "Invalid or removed instruction"
    },
    {
      code: 190,
      name: "MissingDelegateRecord",
      msg: "Missing delegate record"
    },
    {
      code: 191,
      name: "InvalidFeeAccount",
      msg: ""
    },
    {
      code: 192,
      name: "InvalidMetadataFlags",
      msg: ""
    }
  ],
  metadata: {
    origin: "shank",
    address: "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    binaryVersion: "0.0.11",
    libVersion: "0.0.11"
  }
};

// src/idls/shank/spl/address-lookup-table.ts
var AddressLookupTableIDL = {
  version: "0.0.0",
  name: "address_lookup_table",
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "AddressLookupTable",
      type: {
        kind: "struct",
        fields: [
          {
            name: "meta",
            type: {
              defined: "LookupTableMeta"
            }
          },
          {
            name: "addresses",
            type: {
              defined: "LookupTableAddresses"
            }
          }
        ]
      }
    }
  ],
  instructions: [
    {
      name: "CreateLookupTable",
      accounts: [
        {
          name: "lookUpTable",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: true,
          isSigner: true
        },
        {
          name: "funder",
          isMut: true,
          isSigner: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "recentSlot",
          type: { defined: "Slot" }
        },
        {
          name: "bumpSeed",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u32",
        value: 0
      }
    },
    {
      name: "FreezeLookupTable",
      accounts: [
        {
          name: "lookUpTable",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 1
      }
    },
    {
      name: "ExtendLookupTable",
      accounts: [
        {
          name: "lookUpTable",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "funder",
          isMut: true,
          isSigner: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "newAddresses",
          type: {
            vec: "publicKey",
            size: "u64"
          }
        }
      ],
      discriminant: {
        type: "u32",
        value: 2
      }
    },
    {
      name: "DeactivateLookupTable",
      accounts: [
        {
          name: "lookUpTable",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 3
      }
    },
    {
      name: "CloseLookupTable",
      accounts: [
        {
          name: "lookUpTable",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "lamportsRecipient",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u32",
        value: 4
      }
    }
  ],
  types: [
    {
      name: "Key",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "LookupTable"
          }
        ]
      }
    },
    {
      name: "Slot",
      type: {
        kind: "struct",
        fields: [
          {
            name: "slot",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "LookupTableMeta",
      type: {
        kind: "struct",
        fields: [
          {
            name: "deactivation_slot",
            type: "u64"
          },
          {
            name: "last_extended_slot",
            type: "u64"
          },
          {
            name: "last_extended_slot_start_index",
            type: "u8"
          },
          {
            name: "authority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "_padding",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "LookupTableAddresses",
      type: {
        kind: "struct",
        fields: [
          {
            name: "addresses",
            type: {
              vec: "publicKey",
              size: "remainder"
            }
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "AddressLookupTab1e1111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/spl/associated-token-program.ts
var AssociatedTokenIDL = {
  version: "1.1.1",
  name: "spl_associated_token_account",
  instructions: [
    {
      name: "create",
      accounts: [
        {
          name: "fundingAddress",
          isMut: true,
          isSigner: true
        },
        {
          name: "associatedAccountAddress",
          isMut: true,
          isSigner: false
        },
        {
          name: "walletAddress",
          isMut: false,
          isSigner: false
        },
        {
          name: "tokenMintAddress",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "createIdempotent",
      accounts: [
        {
          name: "fundingAddress",
          isMut: true,
          isSigner: true
        },
        {
          name: "associatedAccountAddress",
          isMut: true,
          isSigner: false
        },
        {
          name: "walletAddress",
          isMut: false,
          isSigner: false
        },
        {
          name: "tokenMintAddress",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "recoverNested",
      accounts: [
        {
          name: "nestedAssociatedAccountAddress",
          isMut: true,
          isSigner: false
        },
        {
          name: "nestedTokenMintAddress",
          isMut: false,
          isSigner: false
        },
        {
          name: "destinationAssociatedAccountAddress",
          isMut: true,
          isSigner: false
        },
        {
          name: "ownerAssociatedAccountAddress",
          isMut: false,
          isSigner: false
        },
        {
          name: "ownerTokenMintAddress",
          isMut: false,
          isSigner: false
        },
        {
          name: "walletAddress",
          isMut: true,
          isSigner: true
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 2
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "InvalidOwner",
      msg: "Associated token account owner does not match address derivation"
    }
  ],
  metadata: {
    origin: "shank",
    address: "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL",
    binaryVersion: "1.1.1",
    libVersion: "1.1.1"
  }
};

// src/idls/shank/spl/name-service.ts
var NameServiceIDL = {
  version: "0.0.0",
  name: "name",
  accounts: [
    {
      name: "NameRecordHeader",
      type: {
        kind: "struct",
        fields: [
          {
            name: "parentName",
            type: "publicKey"
          },
          {
            name: "owner",
            type: "publicKey"
          },
          {
            name: "class",
            type: "publicKey"
          }
          // {
          //   name: "data",
          //   type: "string",
          // },
        ]
      }
    }
  ],
  instructions: [
    {
      name: "Create",
      accounts: [
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "fundingAccount",
          isMut: true,
          isSigner: true
        },
        {
          name: "nameRecord",
          isMut: true,
          isSigner: false
        },
        {
          name: "accountClass",
          isMut: false,
          isSigner: true
        },
        {
          name: "parentNameRecord",
          isMut: false,
          isSigner: false
        },
        {
          name: "parentNameRecordClass",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "hashedName",
          type: {
            vec: "u8",
            size: "u32"
          }
        },
        {
          name: "lamports",
          type: "u64"
        },
        {
          name: "space",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "Update",
      accounts: [
        {
          name: "nameRecord",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "parentNameRecord",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "offset",
          type: "u32"
        },
        {
          name: "data",
          type: {
            vec: "u8",
            size: "u32"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "Transfer",
      accounts: [
        {
          name: "nameRecord",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "parentNameRecord",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "newOwner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "Delete",
      accounts: [
        {
          name: "nameRecord",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "refundAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "Realloc",
      accounts: [
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true
        },
        {
          name: "nameRecord",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "space",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 4
      }
    }
  ],
  types: [],
  metadata: {
    origin: "shank",
    address: "namesLPneVptA9Z5rqUDD9tMTWEJwofgaYwp8cawRkX",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/spl/stake-pool.ts
var StakePoolIDL = {
  version: "0.7.0",
  name: "spl_stake_pool",
  instructions: [
    {
      name: "initialize",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "manager",
          isMut: false,
          isSigner: true
        },
        {
          name: "staker",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakePoolWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorList",
          isMut: true,
          isSigner: false
        },
        {
          name: "reserveStake",
          isMut: false,
          isSigner: false
        },
        {
          name: "poolMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "managerPoolAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "depositAuthority",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "fee",
          type: {
            defined: "Fee"
          }
        },
        {
          name: "withdrawalFee",
          type: {
            defined: "Fee"
          }
        },
        {
          name: "depositFee",
          type: {
            defined: "Fee"
          }
        },
        {
          name: "referralFee",
          type: "u8"
        },
        {
          name: "maxValidators",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "addValidatorToPool",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "staker",
          isMut: false,
          isSigner: true
        },
        {
          name: "reserveStakeAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakePoolWithdraw",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorList",
          isMut: true,
          isSigner: false
        },
        {
          name: "stake",
          isMut: true,
          isSigner: false
        },
        {
          name: "validator",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarRent",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarClock",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarStakeHistory",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarStakeConfig",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "seed",
          type: "u32"
        }
      ],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "removeValidatorFromPool",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "staker",
          isMut: false,
          isSigner: true
        },
        {
          name: "stakePoolWithdraw",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorList",
          isMut: true,
          isSigner: false
        },
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "transientStakeAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarClock",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "decreaseValidatorStake",
      accounts: [
        {
          name: "stakePool",
          isMut: false,
          isSigner: false
        },
        {
          name: "staker",
          isMut: false,
          isSigner: true
        },
        {
          name: "stakePoolWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorList",
          isMut: true,
          isSigner: false
        },
        {
          name: "canonicalStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "transientStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "sysvarClock",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarRent",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "lamports",
          type: "u64"
        },
        {
          name: "transientStakeSeed",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "increaseValidatorStake",
      accounts: [
        {
          name: "stakePool",
          isMut: false,
          isSigner: false
        },
        {
          name: "staker",
          isMut: false,
          isSigner: true
        },
        {
          name: "stakePoolWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorList",
          isMut: true,
          isSigner: false
        },
        {
          name: "stakePoolReserveStake",
          isMut: true,
          isSigner: false
        },
        {
          name: "transientStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "validatorStakeAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorVoteAccountToDelegateTo",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarClock",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarRent",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeHistorySysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeConfigSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "lamports",
          type: "u64"
        },
        {
          name: "transientStakeSeed",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "setPreferredValidator",
      accounts: [
        {
          name: "stakePoolAddress",
          isMut: true,
          isSigner: false
        },
        {
          name: "staker",
          isMut: false,
          isSigner: true
        },
        {
          name: "validatorList",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "validatorType",
          type: {
            defined: "PreferredValidatorType"
          }
        },
        {
          name: "validatorVoteAddress",
          type: {
            option: "publicKey"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "updateValidatorListBalance",
      accounts: [
        {
          name: "stakePool",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakePoolWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "storageAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "reserveStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "sysvarClock",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarStakeHistory",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorStakeAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "transientStakeAccount",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "startIndex",
          type: "u32"
        },
        {
          name: "noMerge",
          type: "bool"
        }
      ],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "updateStakePoolBalance",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "stakePoolWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorStakeList",
          isMut: true,
          isSigner: false
        },
        {
          name: "reserveStakeAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "accountToReceivePoolFeeTokens",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolMintAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokenProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "cleanupRemovedValidatorEntries",
      accounts: [
        {
          name: "stakePool",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorListStorage",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "depositStake",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "validatorStakeList",
          isMut: true,
          isSigner: false
        },
        {
          name: "stakePoolDepositAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "stakePoolWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "validatorStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "reserveStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "userAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokensAmount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolFeesAmount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokenMintAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "sysvarClockAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarStakeHistoryAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "poolTokenProgramId",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgramId",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "withdrawStake",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "validatorStakeList",
          isMut: true,
          isSigner: false
        },
        {
          name: "stakePoolWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "uninitializedStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "userAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "userTransferAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "userAccountWithPoolTokensToBurnFrom",
          isMut: true,
          isSigner: false
        },
        {
          name: "accountToReceivePoolFeeTokens",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokenMintAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "sysvarClockAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "poolTokenProgramId",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgramId",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "setManager",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "manager",
          isMut: false,
          isSigner: true
        },
        {
          name: "newManager",
          isMut: false,
          isSigner: true
        },
        {
          name: "newFeeReceiver",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "setFee",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "manager",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "fee",
          type: {
            defined: "FeeType"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "setStaker",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "currentStaker",
          isMut: false,
          isSigner: true
        },
        {
          name: "newStaker",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "depositSol",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "stakePoolWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "reserveStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "depositer",
          isMut: false,
          isSigner: true
        },
        {
          name: "userAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "feeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "referralFeeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "tokenProgramId",
          isMut: false,
          isSigner: false
        },
        {
          name: "depositAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "depositAmount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "setFundingAuthority",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "manager",
          isMut: false,
          isSigner: true
        },
        {
          name: "newAuthority",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "fundingType",
          type: {
            defined: "FundingType"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "withdrawSol",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "transferAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "burnPoolTokens",
          isMut: true,
          isSigner: false
        },
        {
          name: "reserveStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "feeTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "sysvarClock",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarStakeHistory",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "solWithdrawAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "arg",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "createTokenMetadata",
      accounts: [
        {
          name: "stakePool",
          isMut: false,
          isSigner: false
        },
        {
          name: "manager",
          isMut: false,
          isSigner: true
        },
        {
          name: "stakePoolWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "poolMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true
        },
        {
          name: "tokenMetadata",
          isMut: true,
          isSigner: false
        },
        {
          name: "mplTokenMetadata",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "name",
          type: "string"
        },
        {
          name: "symbol",
          type: "string"
        },
        {
          name: "uri",
          type: "string"
        }
      ],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "updateTokenMetadata",
      accounts: [
        {
          name: "stakePool",
          isMut: false,
          isSigner: false
        },
        {
          name: "manager",
          isMut: false,
          isSigner: true
        },
        {
          name: "stakePoolWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "tokenMetadata",
          isMut: true,
          isSigner: false
        },
        {
          name: "mplTokenMetadata",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "name",
          type: "string"
        },
        {
          name: "symbol",
          type: "string"
        },
        {
          name: "uri",
          type: "string"
        }
      ],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "increaseAdditionalValidatorStake",
      accounts: [
        {
          name: "stakePool",
          isMut: false,
          isSigner: false
        },
        {
          name: "staker",
          isMut: false,
          isSigner: true
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorList",
          isMut: true,
          isSigner: false
        },
        {
          name: "reserveStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "uninitializedEphemeralStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "transientStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "validatorStakeAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorVoteAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeHistorySysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeConfigSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "lamports",
          type: "u64"
        },
        {
          name: "transientStakeSeed",
          type: "u64"
        },
        {
          name: "ephemeralStakeSeed",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "decreaseAdditionalValidatorStake",
      accounts: [
        {
          name: "stakePool",
          isMut: false,
          isSigner: false
        },
        {
          name: "staker",
          isMut: false,
          isSigner: true
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorList",
          isMut: true,
          isSigner: false
        },
        {
          name: "sourceCanonicalStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "uninitializedEphemeralStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "transientStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeHistorySysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "lamports",
          type: "u64"
        },
        {
          name: "transientStakeSeed",
          type: "u64"
        },
        {
          name: "ephemeralStakeSeed",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "redelegate",
      accounts: [
        {
          name: "stakePool",
          isMut: false,
          isSigner: false
        },
        {
          name: "staker",
          isMut: false,
          isSigner: true
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "validatorList",
          isMut: true,
          isSigner: false
        },
        {
          name: "sourceCanonicalStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "sourceTransientStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "uninitializedEphemeralStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "destinationTransientStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "destinationStakeAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "destinationValidatorVoteAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "clockSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeHistorySysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeConfigSysvar",
          isMut: false,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "lamports",
          type: "u64"
        },
        {
          name: "sourceTransientStakeSeed",
          type: "u64"
        },
        {
          name: "ephemeralStakeSeed",
          type: "u64"
        },
        {
          name: "destinationTransientStakeSeed",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "depositStakeWithSlippage",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "validatorList",
          isMut: true,
          isSigner: false
        },
        {
          name: "depositAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "validatorStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "reserveStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "feeTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "referralFeeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokenMintAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "sysvarClockAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarStakeHistory",
          isMut: false,
          isSigner: false
        },
        {
          name: "poolTokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "minimumPoolTokensOut",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "withdrawStakeWithSlippage",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "validatorList",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawalAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "newWithdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "userTransferAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "burnPoolTokens",
          isMut: true,
          isSigner: false
        },
        {
          name: "feeTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "sysvarClockAccount",
          isMut: false,
          isSigner: false
        },
        {
          name: "poolTokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "poolTokensIn",
          type: "u64"
        },
        {
          name: "minimumLamportsOut",
          type: "string"
        }
      ],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "depositSolWithSlippage",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "reserveStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "depositAccount",
          isMut: false,
          isSigner: true
        },
        {
          name: "poolTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "feeTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "referralFeeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "solDepositAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "lamportsIn",
          type: "u64"
        },
        {
          name: "minimumPoolsTokensOut",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "withdrawSolWithSlippage",
      accounts: [
        {
          name: "stakePool",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawAuthority",
          isMut: false,
          isSigner: false
        },
        {
          name: "transferAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "poolTokenBurn",
          isMut: true,
          isSigner: false
        },
        {
          name: "reserveStakeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "withdrawAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "feeTokenAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "poolTokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "sysvarClock",
          isMut: false,
          isSigner: false
        },
        {
          name: "sysvarStakeHistory",
          isMut: false,
          isSigner: false
        },
        {
          name: "stakeProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "tokenProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "solWithdrawAuthority",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "poolTokensIn",
          type: "u64"
        },
        {
          name: "minimumLamportsOut",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 25
      }
    }
  ],
  accounts: [
    {
      name: "Uninitialized",
      type: {
        kind: "struct",
        fields: []
      }
    },
    {
      name: "StakePool",
      type: {
        kind: "struct",
        fields: [
          {
            name: "accountType",
            type: {
              defined: "AccountType"
            }
          },
          {
            name: "manager",
            type: "publicKey"
          },
          {
            name: "staker",
            type: "publicKey"
          },
          {
            name: "stakeDepositAuthority",
            type: "publicKey"
          },
          {
            name: "stakeWithdrawBumpSeed",
            type: "u8"
          },
          {
            name: "validatorList",
            type: "publicKey"
          },
          {
            name: "reserveStake",
            type: "publicKey"
          },
          {
            name: "poolMint",
            type: "publicKey"
          },
          {
            name: "managerFeeAccount",
            type: "publicKey"
          },
          {
            name: "tokenProgramId",
            type: "publicKey"
          },
          {
            name: "totalLamports",
            type: "u64"
          },
          {
            name: "poolTokenSupply",
            type: "u64"
          },
          {
            name: "lastUpdateEpoch",
            type: "u64"
          },
          {
            name: "lockup",
            type: {
              defined: "Lockup"
            }
          },
          {
            name: "epochFee",
            type: {
              defined: "Fee"
            }
          },
          {
            name: "nextEpochFee",
            type: {
              option: {
                defined: "Fee"
              }
            }
          },
          {
            name: "preferredDepositValidatorVoteAddress",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "preferredWithdrawValidatorVoteAddress",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "stakeDepositFee",
            type: {
              defined: "Fee"
            }
          },
          {
            name: "stakeWithdrawalFee",
            type: {
              defined: "Fee"
            }
          },
          {
            name: "nextStakeWithdrawalFee",
            type: {
              option: {
                defined: "Fee"
              }
            }
          },
          {
            name: "stakeReferralFee",
            type: "u8"
          },
          {
            name: "solDepositAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "solDepositFee",
            type: {
              defined: "Fee"
            }
          },
          {
            name: "solReferralFee",
            type: "u8"
          },
          {
            name: "solWithdrawAuthority",
            type: {
              option: "publicKey"
            }
          },
          {
            name: "solWithdrawalFee",
            type: {
              defined: "Fee"
            }
          },
          {
            name: "nextSolWithdrawalFee",
            type: {
              option: {
                defined: "Fee"
              }
            }
          },
          {
            name: "lastEpochPoolTokenSupply",
            type: "u64"
          },
          {
            name: "lastEpochTotalLamports",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ValidatorList",
      type: {
        kind: "struct",
        fields: [
          {
            name: "validatorListHeader",
            type: {
              defined: "ValidatorListHeader"
            }
          },
          {
            name: "validators",
            type: {
              vec: {
                defined: "ValidatorStakeInfo"
              }
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "ValidatorStakeInfo",
      type: {
        kind: "struct",
        fields: [
          {
            name: "activeStakeLamports",
            type: "u64"
          },
          {
            name: "transientStakeLamports",
            type: "u64"
          },
          {
            name: "lastUpdateEpoch",
            type: "u64"
          },
          {
            name: "transientSeedSuffixStart",
            type: "u64"
          },
          {
            name: "unused",
            type: "u32"
          },
          {
            name: "transientSeedSuffixEnd",
            type: "u32"
          },
          {
            name: "status",
            type: {
              defined: "StakeStatus"
            }
          },
          {
            name: "voteAccountAddress",
            type: "publicKey"
          }
        ]
      }
    },
    {
      name: "Fee",
      type: {
        kind: "struct",
        fields: [
          {
            name: "denominator",
            type: "u64"
          },
          {
            name: "numerator",
            type: "u64"
          }
        ]
      }
    },
    {
      name: "ValidatorListHeader",
      type: {
        kind: "struct",
        fields: [
          {
            name: "accountType",
            type: {
              defined: "AccountType"
            }
          },
          {
            name: "maxValidators",
            type: "u32"
          }
        ]
      }
    },
    {
      name: "AccountType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "StakePool"
          },
          {
            name: "ValidatorList"
          }
        ],
        size: "u8"
      }
    },
    {
      name: "StakeStatus",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Active"
          },
          {
            name: "DeactivatingTransient"
          },
          {
            name: "ReadyForRemoval"
          }
        ]
      }
    },
    {
      name: "PreferredValidatorType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "Deposit"
          },
          {
            name: "Withdraw"
          }
        ]
      }
    },
    {
      name: "FeeType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "SolReferral",
            fields: ["u8"]
          },
          {
            name: "StakeReferral",
            fields: ["u8"]
          },
          {
            name: "Epoch",
            fields: [
              {
                defined: "Fee"
              }
            ]
          },
          {
            name: "StakeWithdrawal",
            fields: [
              {
                defined: "Fee"
              }
            ]
          },
          {
            name: "SolDeposit",
            fields: [
              {
                defined: "Fee"
              }
            ]
          },
          {
            name: "StakeDeposit",
            fields: [
              {
                defined: "Fee"
              }
            ]
          },
          {
            name: "SolWithdrawal",
            fields: [
              {
                defined: "Fee"
              }
            ]
          }
        ]
      }
    },
    {
      name: "FundingType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "StakeDeposit"
          },
          {
            name: "SolDeposit"
          },
          {
            name: "SolWithdraw"
          }
        ]
      }
    },
    {
      name: "Lockup",
      type: {
        kind: "struct",
        fields: [
          {
            name: "unix_timestamp",
            type: "i64"
          },
          {
            name: "epoch",
            type: "u64"
          },
          {
            name: "custodian",
            type: "publicKey"
          }
        ]
      }
    }
  ],
  errors: [
    {
      code: 0,
      name: "AlreadyInUse",
      msg: "AlreadyInUse"
    },
    {
      code: 1,
      name: "InvalidProgramAddress",
      msg: "InvalidProgramAddress"
    },
    {
      code: 2,
      name: "InvalidState",
      msg: "InvalidState"
    },
    {
      code: 3,
      name: "CalculationFailure",
      msg: "CalculationFailure"
    },
    {
      code: 4,
      name: "FeeTooHigh",
      msg: "FeeTooHigh"
    },
    {
      code: 5,
      name: "WrongAccountMint",
      msg: "WrongAccountMint"
    },
    {
      code: 6,
      name: "WrongManager",
      msg: "WrongManager"
    },
    {
      code: 7,
      name: "SignatureMissing",
      msg: "SignatureMissing"
    },
    {
      code: 8,
      name: "InvalidValidatorStakeList",
      msg: "InvalidValidatorStakeList"
    },
    {
      code: 9,
      name: "InvalidFeeAccount",
      msg: "InvalidFeeAccount"
    },
    {
      code: 10,
      name: "WrongPoolMint",
      msg: "WrongPoolMint"
    },
    {
      code: 11,
      name: "WrongStakeState",
      msg: "WrongStakeState"
    },
    {
      code: 12,
      name: "UserStakeNotActive",
      msg: "UserStakeNotActive"
    },
    {
      code: 13,
      name: "ValidatorAlreadyAdded",
      msg: "ValidatorAlreadyAdded"
    },
    {
      code: 14,
      name: "ValidatorNotFound",
      msg: "ValidatorNotFound"
    },
    {
      code: 15,
      name: "InvalidStakeAccountAddress",
      msg: "InvalidStakeAccountAddress"
    },
    {
      code: 16,
      name: "StakeListOutOfDate",
      msg: "StakeListOutOfDate"
    },
    {
      code: 17,
      name: "StakeListAndPoolOutOfDate",
      msg: "StakeListAndPoolOutOfDate"
    },
    {
      code: 18,
      name: "UnknownValidatorStakeAccount",
      msg: "UnknownValidatorStakeAccount"
    },
    {
      code: 19,
      name: "WrongMintingAuthority",
      msg: "WrongMintingAuthority"
    },
    {
      code: 20,
      name: "UnexpectedValidatorListAccountSize",
      msg: "UnexpectedValidatorListAccountSize"
    },
    {
      code: 21,
      name: "WrongStaker",
      msg: "WrongStaker"
    },
    {
      code: 22,
      name: "NonZeroPoolTokenSupply",
      msg: "NonZeroPoolTokenSupply"
    },
    {
      code: 23,
      name: "StakeLamportsNotEqualToMinimum",
      msg: "StakeLamportsNotEqualToMinimum"
    },
    {
      code: 24,
      name: "IncorrectDepositVoteAddress",
      msg: "IncorrectDepositVoteAddress"
    },
    {
      code: 25,
      name: "IncorrectWithdrawVoteAddress",
      msg: "IncorrectWithdrawVoteAddress"
    },
    {
      code: 26,
      name: "InvalidMintFreezeAuthority",
      msg: "InvalidMintFreezeAuthority"
    },
    {
      code: 27,
      name: "FeeIncreaseTooHigh",
      msg: "FeeIncreaseTooHigh"
    },
    {
      code: 28,
      name: "WithdrawalTooSmall",
      msg: "WithdrawalTooSmall"
    },
    {
      code: 29,
      name: "DepositTooSmall",
      msg: "DepositTooSmall"
    },
    {
      code: 30,
      name: "InvalidStakeDepositAuthority",
      msg: "InvalidStakeDepositAuthority"
    },
    {
      code: 31,
      name: "InvalidSolDepositAuthority",
      msg: "InvalidSolDepositAuthority"
    },
    {
      code: 32,
      name: "InvalidPreferredValidator",
      msg: "InvalidPreferredValidator"
    },
    {
      code: 33,
      name: "TransientAccountInUse",
      msg: "TransientAccountInUse"
    },
    {
      code: 34,
      name: "InvalidSolWithdrawAuthority",
      msg: "InvalidSolWithdrawAuthority"
    },
    {
      code: 35,
      name: "SolWithdrawalTooLarge",
      msg: "SolWithdrawalTooLarge"
    },
    {
      code: 36,
      name: "InvalidMetadataAccount",
      msg: "InvalidMetadataAccount"
    }
  ],
  metadata: {
    origin: "shank",
    address: "SPoo1Ku8WFXoNDMHPsrGSTSG1Y47rzgn41SLUNakuHy",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/spl/token.ts
var TokenIDL = {
  version: "3.5.0",
  name: "spl-token",
  instructions: [
    {
      name: "initializeMint",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "decimals",
          type: "u8"
        },
        {
          name: "mintAuthority",
          type: "publicKey"
        },
        {
          name: "freezeAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "initializeAccount",
      accounts: [
        {
          name: "accountToInitialize",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false
        },
        {
          name: "rentSysvar",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "initializeMultisig",
      accounts: [
        {
          name: "multisig",
          isMut: true,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        },
        {
          name: "signers",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "noOfSignersRequired",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "transfer",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "approve",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "revoke",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "setAuthority",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "currentAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "authorityType",
          type: {
            defined: "AuthorityType"
          }
        },
        {
          name: "newAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "mintTo",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintTo",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "burn",
      accounts: [
        {
          name: "burnAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "closeAccount",
      accounts: [
        {
          name: "closeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "freezeAccount",
      accounts: [
        {
          name: "freezeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "thawAccount",
      accounts: [
        {
          name: "thawAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "transferChecked",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "approveChecked",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "mintToChecked",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintTo",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "burnChecked",
      accounts: [
        {
          name: "burnAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "initializeAccount2",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "associatedMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "rentSysvar",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "syncNative",
      accounts: [
        {
          name: "nativeTokenAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "initializeAccount3",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "associatedMint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "initializeMultisig2",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "m",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "initializeMint2",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "decimals",
          type: "u8"
        },
        {
          name: "mintAuthority",
          type: "publicKey"
        },
        {
          name: "freezeAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "getAccountDataSize",
      accounts: [
        {
          name: "mint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "initializeImmutableOwner",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "amountToUiAmount",
      accounts: [
        {
          name: "mint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "uiAmountToAmount",
      accounts: [
        {
          name: "mint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "uiAmount",
          type: "string"
        }
      ],
      discriminant: {
        type: "u8",
        value: 24
      }
    }
  ],
  accounts: [
    {
      name: "MintAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "mint_authority",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "decimals",
            type: "u8"
          },
          {
            name: "is_initialized",
            type: "bool"
          },
          {
            name: "freeze_authority",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          }
        ]
      }
    },
    {
      name: "TokenAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "owner",
            type: "publicKey"
          },
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "delegate",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          },
          {
            name: "state",
            type: {
              defined: "AccountState"
            }
          },
          {
            name: "is_native",
            type: {
              coption: "u64",
              prefix: "u32"
            }
          },
          {
            name: "delegated_amount",
            type: "u64"
          },
          {
            name: "close_authority",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          }
        ]
      }
    },
    {
      name: "MultisigAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "num_of_signers_required",
            type: "u8"
          },
          {
            name: "num_of_valid_signers_required",
            type: "u8"
          },
          {
            name: "is_initialized",
            type: "bool"
          },
          {
            name: "signers",
            type: {
              array: ["publicKey", 11]
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "AccountState",
      type: {
        kind: "enum",
        size: "u8",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "Initialized"
          },
          {
            name: "Frozen"
          }
        ]
      }
    },
    {
      name: "AuthorityType",
      type: {
        kind: "enum",
        variants: [
          {
            name: "MintTokens"
          },
          {
            name: "FreezeAccount"
          },
          {
            name: "AccountOwner"
          },
          {
            name: "CloseAccount"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
    binaryVersion: "3.5.0",
    libVersion: "3.5.0"
  }
};

// src/idls/shank/spl/token-extensions/token-v2.ts
var Token2022IDL = {
  version: "0.7.0",
  name: "spl-token-2022",
  instructions: [
    {
      name: "initializeMint",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "decimals",
          type: "u8"
        },
        {
          name: "mintAuthority",
          type: "publicKey"
        },
        {
          name: "freezeAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "initializeAccount",
      accounts: [
        {
          name: "accountToInitialize",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "initializeMultisig",
      accounts: [
        {
          name: "multisig",
          isMut: true,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer1",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer2",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer3",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer4",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer5",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer6",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer7",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer8",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer9",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer10",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer11",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "noOfSignersRequired",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "transfer",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "approve",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "revoke",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "setAuthority",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "currentAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "authorityType",
          type: {
            defined: "AuthorityType"
          }
        },
        {
          name: "newAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "mintTo",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintTo",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "burn",
      accounts: [
        {
          name: "burnAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "closeAccount",
      accounts: [
        {
          name: "closeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "freezeAccount",
      accounts: [
        {
          name: "freezeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "thawAccount",
      accounts: [
        {
          name: "thawAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "transferChecked",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "approveChecked",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "mintToChecked",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintTo",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "burnChecked",
      accounts: [
        {
          name: "burnAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "initializeAccount2",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "associatedMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "syncNative",
      accounts: [
        {
          name: "nativeTokenAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "initializeAccount3",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "associatedMint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "initializeMultisig2",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "signer1",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer2",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer3",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer4",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer5",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer6",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer7",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer8",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer9",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer10",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer11",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "noOfSignersRequired",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "initializeMint2",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "decimals",
          type: "u8"
        },
        {
          name: "mintAuthority",
          type: "publicKey"
        },
        {
          name: "freezeAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "getAccountDataSize",
      accounts: [
        {
          name: "mint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "extensionType",
          type: {
            defined: "ExtensionTypeArray"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "initializeImmutableOwner",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "amountToUiAmount",
      accounts: [
        {
          name: "mint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "uiAmountToAmount",
      accounts: [
        {
          name: "mint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "uiAmount",
          type: "string"
        }
      ],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "initializeMintCloseAuthority",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "closeAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    // This part onwards is new from token-2022
    {
      name: "transferFeeExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "confidentialTransferExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "defaultAccountStateExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "reallocate",
      accounts: [
        {
          name: "reallocatedAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "extensionType",
          type: {
            defined: "ExtensionTypeArray"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "memoTransferExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "createNativeMint",
      accounts: [
        {
          name: "fundingAccount",
          isMut: true,
          isSigner: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "fundingAccount",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "initializeNonTransferableMint",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "interestBearingMintExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "cpiGuardExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "initializePermanentDelegate",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "delegate",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "transferHookExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 36
      }
    },
    {
      name: "confidentialTransferFeeExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 37
      }
    },
    {
      name: "withdrawExcessLamports",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 38
      }
    },
    {
      name: "metadataPointerExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 39
      }
    }
  ],
  accounts: [
    {
      name: "MintAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "mint_authority",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "decimals",
            type: "u8"
          },
          {
            name: "is_initialized",
            type: "bool"
          },
          {
            name: "freeze_authority",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          }
        ]
      }
    },
    {
      name: "TokenAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "owner",
            type: "publicKey"
          },
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "delegate",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          },
          {
            name: "state",
            type: {
              defined: "AccountState"
            }
          },
          {
            name: "is_native",
            type: {
              coption: "u64",
              prefix: "u32"
            }
          },
          {
            name: "delegated_amount",
            type: "u64"
          },
          {
            name: "close_authority",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          }
        ]
      }
    },
    {
      name: "MultisigAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "num_of_signers_required",
            type: "u8"
          },
          {
            name: "num_of_valid_signers_required",
            type: "u8"
          },
          {
            name: "is_initialized",
            type: "bool"
          },
          {
            name: "signers",
            type: {
              array: ["publicKey", 11]
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "AccountState",
      type: {
        kind: "enum",
        size: "u8",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "Initialized"
          },
          {
            name: "Frozen"
          }
        ]
      }
    },
    {
      name: "AccountType",
      type: {
        kind: "enum",
        size: "u8",
        variants: [{ name: "Uninitialized" }, { name: "Mint" }, { name: "Account" }]
      }
    },
    {
      name: "AuthorityType",
      type: {
        kind: "enum",
        size: "u8",
        variants: [
          { name: "MintTokens" },
          { name: "FreezeAccount" },
          { name: "AccountOwner" },
          { name: "CloseAccount" },
          { name: "TransferFeeConfig" },
          { name: "WithheldWithdraw" },
          { name: "CloseMint" },
          { name: "InterestRate" },
          { name: "PermanentDelegate" },
          { name: "ConfidentialTransferMint" },
          { name: "TransferHookProgramId" },
          { name: "ConfidentialTransferFeeConfig" },
          { name: "MetadataPointer" }
        ]
      }
    },
    {
      name: "ExtensionTypeArray",
      type: {
        kind: "struct",
        fields: [
          {
            name: "ExtensionType",
            type: {
              vec: {
                defined: "ExtensionType"
              },
              size: "remainder"
            }
          }
        ]
      }
    },
    {
      name: "ExtensionTypeWithFields",
      type: {
        kind: "enum",
        size: "u16",
        variants: [
          { name: "Uninitialized" },
          {
            name: "TransferFeeConfig",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "transferFeeConfigAuthority",
                type: "publicKey"
              },
              {
                name: "withdrawWithheldAuthority",
                type: "publicKey"
              },
              {
                name: "withheldAmount",
                type: "u64"
              },
              {
                name: "olderTransferFee",
                type: {
                  defined: "TransferFee"
                }
              },
              {
                name: "newerTransferFee",
                type: {
                  defined: "TransferFee"
                }
              }
            ]
          },
          {
            name: "TransferFeeAmount",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "withheldAmount",
                type: "u64"
              }
            ]
          },
          {
            name: "MintCloseAuthority",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "closeAuthority",
                type: "publicKey"
              }
            ]
          },
          {
            name: "ConfidentialTransferMint",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "authority",
                type: "publicKey"
              },
              {
                name: "autoApproveNewAccounts",
                type: "bool"
              },
              {
                name: "auditorElgamalPubkey",
                type: "publicKey"
              }
            ]
          },
          {
            name: "ConfidentialTransferAccount",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "approved",
                type: "bool"
              },
              {
                name: "elgamal_pubkey",
                type: "publicKey"
              },
              {
                name: "pending_balance_lo",
                type: {
                  array: ["u8", 64]
                }
              },
              {
                name: "pending_balance_hi",
                type: {
                  array: ["u8", 64]
                }
              },
              {
                name: "available_balance",
                type: {
                  array: ["u8", 64]
                }
              },
              {
                name: "decryptable_available_balance",
                type: {
                  array: ["u8", 36]
                }
              },
              {
                name: "allow_confidential_credits",
                type: "bool"
              },
              {
                name: "allow_non_confidential_credits",
                type: "bool"
              },
              {
                name: "pending_balance_credit_counter",
                type: "u64"
              },
              {
                name: "maximum_pending_balance_credit_counter",
                type: "u64"
              },
              {
                name: "expected_pending_balance_credit_counter",
                type: "u64"
              },
              {
                name: "actual_pending_balance_credit_counter",
                type: "u64"
              }
            ]
          },
          {
            name: "DefaultAccountState",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "defaultAccountState",
                type: {
                  defined: "AccountState"
                }
              }
            ]
          },
          {
            name: "ImmutableOwner",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              }
            ]
          },
          {
            name: "MemoTransfer",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "requireIncomingTransferMemos",
                type: "bool"
              }
            ]
          },
          {
            name: "NonTransferable",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              }
            ]
          },
          {
            name: "InterestBearingConfig",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "rate",
                type: "publicKey"
              },
              {
                name: "initializationTimestamp",
                type: "i64"
              },
              {
                name: "preUpdateAverageRate",
                type: "i16"
              },
              {
                name: "lastUpdateTimestamp",
                type: "i64"
              },
              {
                name: "currentRate",
                type: "i16"
              }
            ]
          },
          {
            name: "CpiGuard",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "lockCpi",
                type: "bool"
              }
            ]
          },
          {
            name: "PermanentDelegate",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "delegate",
                type: "publicKey"
              }
            ]
          },
          {
            name: "NonTransferableAccount",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              }
            ]
          },
          {
            name: "TransferHook",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "authority",
                type: "publicKey"
              },
              {
                name: "programId",
                type: "publicKey"
              }
            ]
          },
          {
            name: "TransferHookAccount",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "transferring",
                type: "bool"
              }
            ]
          },
          {
            name: "ConfidentialTransferFeeConfig",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "authority",
                type: "publicKey"
              },
              {
                name: "withdrawWithheldAuthorityElgamalPubkey",
                type: "publicKey"
              },
              {
                name: "harvestToMintEnabled",
                type: "bool"
              },
              {
                name: "withheldAmount",
                type: {
                  array: ["u8", 64]
                }
              }
            ]
          },
          {
            name: "ConfidentialTransferFeeAmount",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "withheldAmount",
                type: {
                  array: ["u8", 64]
                }
              }
            ]
          },
          {
            name: "MetadataPointer",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "authority",
                type: "publicKey"
              },
              {
                name: "metadataAddress",
                type: "publicKey"
              }
            ]
          },
          {
            name: "TokenMetadata",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "updateAuthority",
                type: "publicKey"
              },
              {
                name: "mint",
                type: "publicKey"
              },
              {
                name: "name",
                type: "string"
              },
              {
                name: "symbol",
                type: "string"
              },
              {
                name: "uri",
                type: "string"
              },
              {
                name: "additionalMetadata",
                type: {
                  hashMap: ["string", "string"]
                }
              }
            ]
          }
        ]
      }
    },
    {
      name: "ExtensionType",
      type: {
        kind: "enum",
        size: "u16",
        variants: [
          { name: "Uninitialized" },
          { name: "TransferFeeConfig" },
          { name: "TransferFeeAmount" },
          { name: "MintCloseAuthority" },
          { name: "ConfidentialTransferMint" },
          { name: "ConfidentialTransferAccount" },
          { name: "DefaultAccountState" },
          { name: "ImmutableOwner" },
          { name: "MemoTransfer" },
          { name: "NonTransferable" },
          { name: "InterestBearingConfig" },
          { name: "CpiGuard" },
          { name: "PermanentDelegate" },
          { name: "NonTransferableAccount" },
          { name: "TransferHook" },
          { name: "TransferHookAccount" },
          { name: "ConfidentialTransferFeeConfig" },
          { name: "ConfidentialTransferFeeAmount" },
          { name: "MetadataPointer" },
          { name: "TokenMetadata" }
        ]
      }
    },
    {
      name: "TransferFee",
      type: {
        kind: "struct",
        fields: [
          {
            name: "epoch",
            type: "u64"
          },
          {
            name: "maximumFee",
            type: "u64"
          },
          {
            name: "transferFeeBasisPoints",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "BasisPoints",
      type: {
        kind: "struct",
        fields: [
          {
            name: "BasisPoints",
            type: {
              array: ["u8", 2]
            }
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "0.7.0",
    libVersion: "0.7.0"
  }
};

// src/idls/shank/spl/token-extensions/token-v2-235377525.ts
var Token2022_235377525_IDL = {
  version: "1.0.0",
  name: "spl-token-2022",
  instructions: [
    {
      name: "initializeMint",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "decimals",
          type: "u8"
        },
        {
          name: "mintAuthority",
          type: "publicKey"
        },
        {
          name: "freezeAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 0
      }
    },
    {
      name: "initializeAccount",
      accounts: [
        {
          name: "accountToInitialize",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 1
      }
    },
    {
      name: "initializeMultisig",
      accounts: [
        {
          name: "multisig",
          isMut: true,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer1",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer2",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer3",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer4",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer5",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer6",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer7",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer8",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer9",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer10",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer11",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "noOfSignersRequired",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 2
      }
    },
    {
      name: "transfer",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 3
      }
    },
    {
      name: "approve",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 4
      }
    },
    {
      name: "revoke",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 5
      }
    },
    {
      name: "setAuthority",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "currentAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "authorityType",
          type: {
            defined: "AuthorityType"
          }
        },
        {
          name: "newAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 6
      }
    },
    {
      name: "mintTo",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintTo",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 7
      }
    },
    {
      name: "burn",
      accounts: [
        {
          name: "burnAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 8
      }
    },
    {
      name: "closeAccount",
      accounts: [
        {
          name: "closeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 9
      }
    },
    {
      name: "freezeAccount",
      accounts: [
        {
          name: "freezeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "mint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 10
      }
    },
    {
      name: "thawAccount",
      accounts: [
        {
          name: "thawAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 11
      }
    },
    {
      name: "transferChecked",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 12
      }
    },
    {
      name: "approveChecked",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "delegate",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 13
      }
    },
    {
      name: "mintToChecked",
      accounts: [
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintTo",
          isMut: true,
          isSigner: false
        },
        {
          name: "mintAuthority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 14
      }
    },
    {
      name: "burnChecked",
      accounts: [
        {
          name: "burnAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "tokenMint",
          isMut: true,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        },
        {
          name: "decimals",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 15
      }
    },
    {
      name: "initializeAccount2",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "associatedMint",
          isMut: false,
          isSigner: false
        },
        {
          name: "rent",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u8",
        value: 16
      }
    },
    {
      name: "syncNative",
      accounts: [
        {
          name: "nativeTokenAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 17
      }
    },
    {
      name: "initializeAccount3",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "associatedMint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "owner",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u8",
        value: 18
      }
    },
    {
      name: "initializeMultisig2",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "signer1",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer2",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer3",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer4",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer5",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer6",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer7",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer8",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer9",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer10",
          isMut: false,
          isSigner: false
        },
        {
          name: "signer11",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "noOfSignersRequired",
          type: "u8"
        }
      ],
      discriminant: {
        type: "u8",
        value: 19
      }
    },
    {
      name: "initializeMint2",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "decimals",
          type: "u8"
        },
        {
          name: "mintAuthority",
          type: "publicKey"
        },
        {
          name: "freezeAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 20
      }
    },
    {
      name: "getAccountDataSize",
      accounts: [
        {
          name: "mint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "extensionType",
          type: {
            defined: "ExtensionTypeArray"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 21
      }
    },
    {
      name: "initializeImmutableOwner",
      accounts: [
        {
          name: "initializeAccount",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 22
      }
    },
    {
      name: "amountToUiAmount",
      accounts: [
        {
          name: "mint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "amount",
          type: "u64"
        }
      ],
      discriminant: {
        type: "u8",
        value: 23
      }
    },
    {
      name: "uiAmountToAmount",
      accounts: [
        {
          name: "mint",
          isMut: false,
          isSigner: false
        }
      ],
      args: [
        {
          name: "uiAmount",
          type: "string"
        }
      ],
      discriminant: {
        type: "u8",
        value: 24
      }
    },
    {
      name: "initializeMintCloseAuthority",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "closeAuthority",
          type: {
            coption: "publicKey",
            prefix: "u8"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 25
      }
    },
    // This part onwards is new from token-2022
    {
      name: "transferFeeExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 26
      }
    },
    {
      name: "confidentialTransferExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 27
      }
    },
    {
      name: "defaultAccountStateExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 28
      }
    },
    {
      name: "reallocate",
      accounts: [
        {
          name: "reallocatedAccount",
          isMut: true,
          isSigner: false
        },
        {
          name: "payer",
          isMut: true,
          isSigner: true
        },
        {
          name: "systemProgram",
          isMut: false,
          isSigner: false
        },
        {
          name: "owner",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [
        {
          name: "extensionType",
          type: {
            defined: "ExtensionTypeArray"
          }
        }
      ],
      discriminant: {
        type: "u8",
        value: 29
      }
    },
    {
      name: "memoTransferExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 30
      }
    },
    {
      name: "createNativeMint",
      accounts: [
        {
          name: "fundingAccount",
          isMut: true,
          isSigner: true
        },
        {
          name: "mint",
          isMut: true,
          isSigner: false
        },
        {
          name: "fundingAccount",
          isMut: false,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 31
      }
    },
    {
      name: "initializeNonTransferableMint",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 32
      }
    },
    {
      name: "interestBearingMintExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 33
      }
    },
    {
      name: "cpiGuardExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 34
      }
    },
    {
      name: "initializePermanentDelegate",
      accounts: [
        {
          name: "mint",
          isMut: true,
          isSigner: false
        }
      ],
      args: [
        {
          name: "delegate",
          type: "publicKey"
        }
      ],
      discriminant: {
        type: "u8",
        value: 35
      }
    },
    {
      name: "transferHookExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 36
      }
    },
    {
      name: "confidentialTransferFeeExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 37
      }
    },
    {
      name: "withdrawExcessLamports",
      accounts: [
        {
          name: "source",
          isMut: true,
          isSigner: false
        },
        {
          name: "destination",
          isMut: true,
          isSigner: false
        },
        {
          name: "authority",
          isMut: false,
          isSigner: true
        },
        {
          name: "signers",
          isMut: false,
          isSigner: true
        }
      ],
      args: [],
      discriminant: {
        type: "u8",
        value: 38
      }
    },
    {
      name: "metadataPointerExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 39
      }
    },
    {
      name: "groupPointerExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 40
      }
    },
    {
      name: "groupMemberPointerExtension",
      accounts: [],
      args: [],
      discriminant: {
        type: "u8",
        value: 41
      }
    }
  ],
  accounts: [
    {
      name: "MintAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "mint_authority",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          },
          {
            name: "supply",
            type: "u64"
          },
          {
            name: "decimals",
            type: "u8"
          },
          {
            name: "is_initialized",
            type: "bool"
          },
          {
            name: "freeze_authority",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          }
        ]
      }
    },
    {
      name: "TokenAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "mint",
            type: "publicKey"
          },
          {
            name: "owner",
            type: "publicKey"
          },
          {
            name: "amount",
            type: "u64"
          },
          {
            name: "delegate",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          },
          {
            name: "state",
            type: {
              defined: "AccountState"
            }
          },
          {
            name: "is_native",
            type: {
              coption: "u64",
              prefix: "u32"
            }
          },
          {
            name: "delegated_amount",
            type: "u64"
          },
          {
            name: "close_authority",
            type: {
              coption: "publicKey",
              prefix: "u32"
            }
          }
        ]
      }
    },
    {
      name: "MultisigAccount",
      type: {
        kind: "struct",
        fields: [
          {
            name: "num_of_signers_required",
            type: "u8"
          },
          {
            name: "num_of_valid_signers_required",
            type: "u8"
          },
          {
            name: "is_initialized",
            type: "bool"
          },
          {
            name: "signers",
            type: {
              array: ["publicKey", 11]
            }
          }
        ]
      }
    }
  ],
  types: [
    {
      name: "AccountState",
      type: {
        kind: "enum",
        size: "u8",
        variants: [
          {
            name: "Uninitialized"
          },
          {
            name: "Initialized"
          },
          {
            name: "Frozen"
          }
        ]
      }
    },
    {
      name: "AccountType",
      type: {
        kind: "enum",
        size: "u8",
        variants: [{ name: "Uninitialized" }, { name: "Mint" }, { name: "Account" }]
      }
    },
    {
      name: "AuthorityType",
      type: {
        kind: "enum",
        size: "u8",
        variants: [
          { name: "MintTokens" },
          { name: "FreezeAccount" },
          { name: "AccountOwner" },
          { name: "CloseAccount" },
          { name: "TransferFeeConfig" },
          { name: "WithheldWithdraw" },
          { name: "CloseMint" },
          { name: "InterestRate" },
          { name: "PermanentDelegate" },
          { name: "ConfidentialTransferMint" },
          { name: "TransferHookProgramId" },
          { name: "ConfidentialTransferFeeConfig" },
          { name: "MetadataPointer" },
          { name: "GroupPointer" },
          { name: "GroupMemberPointer" }
        ]
      }
    },
    {
      name: "ExtensionTypeArray",
      type: {
        kind: "struct",
        fields: [
          {
            name: "ExtensionType",
            type: {
              vec: {
                defined: "ExtensionType"
              },
              size: "remainder"
            }
          }
        ]
      }
    },
    {
      name: "ExtensionTypeWithFields",
      type: {
        kind: "enum",
        size: "u16",
        variants: [
          { name: "Uninitialized" },
          {
            name: "TransferFeeConfig",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "transferFeeConfigAuthority",
                type: "publicKey"
              },
              {
                name: "withdrawWithheldAuthority",
                type: "publicKey"
              },
              {
                name: "withheldAmount",
                type: "u64"
              },
              {
                name: "olderTransferFee",
                type: {
                  defined: "TransferFee"
                }
              },
              {
                name: "newerTransferFee",
                type: {
                  defined: "TransferFee"
                }
              }
            ]
          },
          {
            name: "TransferFeeAmount",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "withheldAmount",
                type: "u64"
              }
            ]
          },
          {
            name: "MintCloseAuthority",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "closeAuthority",
                type: "publicKey"
              }
            ]
          },
          {
            name: "ConfidentialTransferMint",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "authority",
                type: "publicKey"
              },
              {
                name: "autoApproveNewAccounts",
                type: "bool"
              },
              {
                name: "auditorElgamalPubkey",
                type: "publicKey"
              }
            ]
          },
          {
            name: "ConfidentialTransferAccount",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "approved",
                type: "bool"
              },
              {
                name: "elgamal_pubkey",
                type: "publicKey"
              },
              {
                name: "pending_balance_lo",
                type: {
                  array: ["u8", 64]
                }
              },
              {
                name: "pending_balance_hi",
                type: {
                  array: ["u8", 64]
                }
              },
              {
                name: "available_balance",
                type: {
                  array: ["u8", 64]
                }
              },
              {
                name: "decryptable_available_balance",
                type: {
                  array: ["u8", 36]
                }
              },
              {
                name: "allow_confidential_credits",
                type: "bool"
              },
              {
                name: "allow_non_confidential_credits",
                type: "bool"
              },
              {
                name: "pending_balance_credit_counter",
                type: "u64"
              },
              {
                name: "maximum_pending_balance_credit_counter",
                type: "u64"
              },
              {
                name: "expected_pending_balance_credit_counter",
                type: "u64"
              },
              {
                name: "actual_pending_balance_credit_counter",
                type: "u64"
              }
            ]
          },
          {
            name: "DefaultAccountState",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "defaultAccountState",
                type: {
                  defined: "AccountState"
                }
              }
            ]
          },
          {
            name: "ImmutableOwner",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              }
            ]
          },
          {
            name: "MemoTransfer",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "requireIncomingTransferMemos",
                type: "bool"
              }
            ]
          },
          {
            name: "NonTransferable",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              }
            ]
          },
          {
            name: "InterestBearingConfig",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "rateAuthority",
                type: "publicKey"
              },
              {
                name: "initializationTimestamp",
                type: "i64"
              },
              {
                name: "preUpdateAverageRate",
                type: "i16"
              },
              {
                name: "lastUpdateTimestamp",
                type: "i64"
              },
              {
                name: "currentRate",
                type: "i16"
              }
            ]
          },
          {
            name: "CpiGuard",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "lockCpi",
                type: "bool"
              }
            ]
          },
          {
            name: "PermanentDelegate",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "delegate",
                type: "publicKey"
              }
            ]
          },
          {
            name: "NonTransferableAccount",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              }
            ]
          },
          {
            name: "TransferHook",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "authority",
                type: "publicKey"
              },
              {
                name: "programId",
                type: "publicKey"
              }
            ]
          },
          {
            name: "TransferHookAccount",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "transferring",
                type: "bool"
              }
            ]
          },
          {
            name: "ConfidentialTransferFeeConfig",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "authority",
                type: "publicKey"
              },
              {
                name: "withdrawWithheldAuthorityElgamalPubkey",
                type: "publicKey"
              },
              {
                name: "harvestToMintEnabled",
                type: "bool"
              },
              {
                name: "withheldAmount",
                type: {
                  array: ["u8", 64]
                }
              }
            ]
          },
          {
            name: "ConfidentialTransferFeeAmount",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "withheldAmount",
                type: {
                  array: ["u8", 64]
                }
              }
            ]
          },
          {
            name: "MetadataPointer",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "authority",
                type: "publicKey"
              },
              {
                name: "metadataAddress",
                type: "publicKey"
              }
            ]
          },
          {
            name: "TokenMetadata",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "updateAuthority",
                type: "publicKey"
              },
              {
                name: "mint",
                type: "publicKey"
              },
              {
                name: "name",
                type: "string"
              },
              {
                name: "symbol",
                type: "string"
              },
              {
                name: "uri",
                type: "string"
              },
              {
                name: "additionalMetadata",
                type: {
                  hashMap: ["string", "string"]
                }
              }
            ]
          },
          {
            name: "GroupPointer",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "authority",
                type: "publicKey"
              },
              {
                name: "groupAddress",
                type: "publicKey"
              }
            ]
          },
          {
            name: "TokenGroup",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "updateAuthority",
                type: "publicKey"
              },
              {
                name: "mint",
                type: "publicKey"
              },
              {
                name: "size",
                type: "u32"
              },
              {
                name: "maxSize",
                type: "u32"
              }
            ]
          },
          {
            name: "GroupMemberPointer",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "authority",
                type: "publicKey"
              },
              {
                name: "memberAddress",
                type: "publicKey"
              }
            ]
          },
          {
            name: "TokenGroupMember",
            fields: [
              {
                name: "extensionLength",
                type: "u16"
              },
              {
                name: "mint",
                type: "publicKey"
              },
              {
                name: "group",
                type: "publicKey"
              },
              {
                name: "memberNumber",
                type: "u32"
              }
            ]
          }
        ]
      }
    },
    {
      name: "ExtensionType",
      type: {
        kind: "enum",
        size: "u16",
        variants: [
          { name: "Uninitialized" },
          { name: "TransferFeeConfig" },
          { name: "TransferFeeAmount" },
          { name: "MintCloseAuthority" },
          { name: "ConfidentialTransferMint" },
          { name: "ConfidentialTransferAccount" },
          { name: "DefaultAccountState" },
          { name: "ImmutableOwner" },
          { name: "MemoTransfer" },
          { name: "NonTransferable" },
          { name: "InterestBearingConfig" },
          { name: "CpiGuard" },
          { name: "PermanentDelegate" },
          { name: "NonTransferableAccount" },
          { name: "TransferHook" },
          { name: "TransferHookAccount" },
          { name: "ConfidentialTransferFeeConfig" },
          { name: "ConfidentialTransferFeeAmount" },
          { name: "MetadataPointer" },
          { name: "TokenMetadata" },
          { name: "GroupPointer" },
          { name: "TokenGroup" },
          { name: "GroupMemberPointer" },
          { name: "TokenGroupMember" }
        ]
      }
    },
    {
      name: "TransferFee",
      type: {
        kind: "struct",
        fields: [
          {
            name: "epoch",
            type: "u64"
          },
          {
            name: "maximumFee",
            type: "u64"
          },
          {
            name: "transferFeeBasisPoints",
            type: "u16"
          }
        ]
      }
    },
    {
      name: "BasisPoints",
      type: {
        kind: "struct",
        fields: [
          {
            name: "BasisPoints",
            type: {
              array: ["u8", 2]
            }
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    binaryVersion: "1.0.0",
    libVersion: "1.0.0"
  }
};

// src/idls/shank/sysvar/clock.ts
var ClockIDL = {
  version: "0.0.0",
  name: "sysvar_clock",
  accounts: [
    {
      name: "SysvarClock",
      type: {
        kind: "struct",
        fields: [
          {
            name: "clock",
            type: {
              defined: "Clock"
            }
          }
        ]
      }
    }
  ],
  instructions: [],
  types: [
    {
      name: "Clock",
      type: {
        kind: "struct",
        fields: [
          {
            name: "slot",
            type: "u64"
          },
          {
            name: "epoch_start_timestamp",
            type: "i64"
          },
          {
            name: "epoch",
            type: "u64"
          },
          {
            name: "leader_schedule_epoch",
            type: "u64"
          },
          {
            name: "unix_timestamp",
            type: "i64"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "SysvarC1ock11111111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/sysvar/epoch-schedule.ts
var EpochScheduleIDL = {
  version: "0.0.0",
  name: "sysvar_epoch_schedule",
  accounts: [
    {
      name: "SysvarEpochSchedule",
      type: {
        kind: "struct",
        fields: [
          {
            name: "epochSchedule",
            type: {
              defined: "EpochSchedule"
            }
          }
        ]
      }
    }
  ],
  instructions: [],
  types: [
    {
      name: "EpochSchedule",
      type: {
        kind: "struct",
        fields: [
          {
            name: "slots_per_epoch",
            type: "u64"
          },
          {
            name: "leader_schedule_slot_offset",
            type: "u64"
          },
          {
            name: "warmup",
            type: "bool"
          },
          {
            name: "first_normal_epoch",
            type: "u64"
          },
          {
            name: "first_normal_slot",
            type: "u64"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "SysvarEpochSchedu1e111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/sysvar/fees.ts
var FeesIDL = {
  version: "0.0.0",
  name: "sysvar_fees",
  accounts: [
    {
      name: "sysvarFees",
      type: {
        kind: "struct",
        fields: [
          {
            name: "fees",
            type: {
              defined: "Fees"
            }
          }
        ]
      }
    }
  ],
  instructions: [],
  types: [
    {
      name: "Fees",
      type: {
        kind: "struct",
        fields: [
          {
            name: "lamports_per_signature",
            type: "u64"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "SysvarFees111111111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/sysvar/recent-block-hashes.ts
var RecentBlockHashesIDL = {
  version: "0.0.0",
  name: "sysvar_recent_blockhashes",
  accounts: [
    {
      name: "RecentBlockhashes",
      type: {
        kind: "struct",
        fields: [
          {
            name: "entry",
            type: {
              vec: {
                defined: "Entry"
              },
              size: "u64"
            }
          }
        ]
      }
    }
  ],
  instructions: [],
  types: [
    {
      name: "Entry",
      type: {
        kind: "struct",
        fields: [
          {
            name: "blockHash",
            type: "publicKey"
          },
          {
            name: "fee_calculator",
            type: {
              defined: "FeeCalculator"
            }
          }
        ]
      }
    },
    {
      name: "FeeCalculator",
      type: {
        kind: "struct",
        fields: [
          {
            name: "lamports_per_signature",
            type: "u64"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "SysvarRecentB1ockHashes11111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/sysvar/rent.ts
var RentIDL = {
  version: "0.0.0",
  name: "sysvar_rent",
  accounts: [
    {
      name: "rentData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "rent",
            type: {
              defined: "Rent"
            }
          }
        ]
      }
    }
  ],
  instructions: [],
  types: [
    {
      name: "Rent",
      type: {
        kind: "struct",
        fields: [
          {
            name: "lamports_per_byte_year",
            type: "u64"
          },
          {
            name: "exemption_threshold",
            type: "f64"
          },
          {
            name: "burn_percent",
            type: "u8"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "SysvarRent111111111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/sysvar/rewards.ts
var RewardsIDL = {
  version: "0.0.0",
  name: "sysvar_rewards",
  accounts: [
    {
      name: "rewards_data",
      type: {
        kind: "struct",
        fields: [
          {
            name: "rewards",
            type: {
              defined: "Rewards"
            }
          }
        ]
      }
    }
  ],
  instructions: [],
  types: [
    {
      name: "Rewards",
      type: {
        kind: "struct",
        fields: [
          {
            name: "validator_point_value",
            type: "f64"
          },
          {
            name: "unused",
            type: "f64"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "SysvarRewards111111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/sysvar/slot-hashes.ts
var SlotHashesIDL = {
  version: "0.0.0",
  name: "sysvar_slot_hashes",
  accounts: [
    {
      name: "SysvarSlotHashes",
      type: {
        kind: "struct",
        fields: [
          {
            name: "slotHashes",
            type: {
              defined: "SlotHashes"
            }
          }
        ]
      }
    }
  ],
  instructions: [],
  types: [
    {
      name: "SlotHashes",
      type: {
        kind: "struct",
        fields: [
          {
            name: "slotHash",
            type: {
              vec: {
                tuple: ["u64", "publicKey"]
              },
              size: "u64"
            }
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "SysvarS1otHashes111111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/shank/sysvar/stake-history.ts
var StakeHistoryIDL = {
  version: "0.0.0",
  name: "sysvar_stake_history_entry",
  accounts: [
    {
      name: "stakeHistoryData",
      type: {
        kind: "struct",
        fields: [
          {
            name: "stakeHistory",
            type: {
              defined: "StakeHistory"
            }
          }
        ]
      }
    }
  ],
  instructions: [],
  types: [
    {
      name: "StakeHistory",
      type: {
        kind: "struct",
        fields: [
          {
            name: "stakeHistoryTuple",
            type: {
              vec: {
                defined: "StakeHistoryTuple"
              },
              size: "u64"
            }
          }
        ]
      }
    },
    {
      name: "StakeHistoryTuple",
      type: {
        kind: "struct",
        fields: [
          {
            name: "stakeHistoryEntry",
            type: {
              tuple: [
                "u64",
                {
                  defined: "StakeHistoryEntry"
                }
              ]
            }
          }
        ]
      }
    },
    {
      name: "StakeHistoryEntry",
      type: {
        kind: "struct",
        fields: [
          {
            name: "effective",
            type: "u64"
          },
          {
            name: "activating",
            type: "u64"
          },
          {
            name: "deactivating",
            type: "u64"
          }
        ]
      }
    }
  ],
  metadata: {
    origin: "shank",
    address: "SysvarStakeHistory1111111111111111111111111",
    binaryVersion: "0.0.1",
    libVersion: "0.0.1"
  }
};

// src/idls/LocalIdlRepository.ts
var IdlRepository = /* @__PURE__ */ new Map([
  ["11111111111111111111111111111111", /* @__PURE__ */ new Map([[0, SystemIDL]])],
  ["Config1111111111111111111111111111111111111", /* @__PURE__ */ new Map([[0, ConfigIDL]])],
  ["Stake11111111111111111111111111111111111111", /* @__PURE__ */ new Map([[0, StakeIDL]])],
  ["Vote111111111111111111111111111111111111111", /* @__PURE__ */ new Map([[0, VoteIDL]])],
  [
    "ComputeBudget111111111111111111111111111111",
    /* @__PURE__ */ new Map([
      [134784001, ComputeBudgetIDL],
      [134784e3, ComputeBudget_134784000_IDL]
    ])
  ],
  ["BPFLoaderUpgradeab1e11111111111111111111111", /* @__PURE__ */ new Map([[0, BPFLoaderUpgradeableIDL]])],
  ["TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA", /* @__PURE__ */ new Map([[0, TokenIDL]])],
  [
    "TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb",
    /* @__PURE__ */ new Map([
      [220601744, Token2022IDL],
      [235377525, Token2022_235377525_IDL]
    ])
  ],
  ["namesLPneVptA9Z5rqUDD9tMTWEJwofgaYwp8cawRkX", /* @__PURE__ */ new Map([[0, NameServiceIDL]])],
  ["SPoo1Ku8WFXoNDMHPsrGSTSG1Y47rzgn41SLUNakuHy", /* @__PURE__ */ new Map([[0, StakePoolIDL]])],
  ["ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL", /* @__PURE__ */ new Map([[0, AssociatedTokenIDL]])],
  ["PhoeNiXZ8ByJGLkxNfZRnkUfjvmuYqLR89jjFHGqdXY", /* @__PURE__ */ new Map([[0, PhoenixKinobiTree]])],
  [
    "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s",
    /* @__PURE__ */ new Map([
      [121277711, TokenMetadataV125IDL],
      [132757495, TokenMetadataV130IDL],
      [148273286, TokenMetadataV135IDL],
      [153595949, TokenMetadataV160IDL],
      [161821544, TokenMetadataV162IDL],
      [174397839, TokenMetadataV170Beta2IDL],
      [175688231, TokenMetadataV170IDL],
      [188446980, TokenMetadataV1100IDL],
      [191949417, TokenMetadataV1110IDL],
      [196112106, TokenMetadataV1120IDL],
      [205969222, TokenMetadataV1130IDL]
    ])
  ],
  ["auth9SigNpDKz4sJJ1DfCTuZrZNSAgh9sFD3rboVmgg", /* @__PURE__ */ new Map([[0, AuthRulesIDL]])],
  ["AddressLookupTab1e1111111111111111111111111", /* @__PURE__ */ new Map([[0, AddressLookupTableIDL]])],
  ["SysvarC1ock11111111111111111111111111111111", /* @__PURE__ */ new Map([[0, ClockIDL]])],
  ["SysvarEpochSchedu1e111111111111111111111111", /* @__PURE__ */ new Map([[0, EpochScheduleIDL]])],
  ["SysvarFees111111111111111111111111111111111", /* @__PURE__ */ new Map([[0, FeesIDL]])],
  ["SysvarRecentB1ockHashes11111111111111111111", /* @__PURE__ */ new Map([[0, RecentBlockHashesIDL]])],
  ["SysvarRent111111111111111111111111111111111", /* @__PURE__ */ new Map([[0, RentIDL]])],
  ["SysvarRewards111111111111111111111111111111", /* @__PURE__ */ new Map([[0, RewardsIDL]])],
  ["SysvarS1otHashes111111111111111111111111111", /* @__PURE__ */ new Map([[0, SlotHashesIDL]])],
  ["SysvarStakeHistory1111111111111111111111111", /* @__PURE__ */ new Map([[0, StakeHistoryIDL]])],
  ["MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr", /* @__PURE__ */ new Map([[0, MemoKinobiTree]])],
  ["Memo1UhkJRfHyvLMcVucJwxXeuD728EqVDDwQDxFMNo", /* @__PURE__ */ new Map([[0, MemoKinobiTree]])]
]);
var getLocalIdl = (programId, slot, idlRepoMap) => {
  const programIdlMap = idlRepoMap ? idlRepoMap.get(programId) : IdlRepository.get(programId);
  if (programIdlMap === null) {
    return {
      idl: null
    };
  }
  if (programIdlMap !== void 0) {
    if (programIdlMap.size === 1) {
      const [firstKey] = programIdlMap.keys();
      if (firstKey) {
        return {
          idl: programIdlMap.get(firstKey),
          slotDeployed: firstKey
        };
      } else {
        return {
          idl: programIdlMap.get(0),
          slotDeployed: 0
        };
      }
    } else {
      if (slot) {
        const slots = Array.from(programIdlMap.keys());
        const closestSlot = slots.reduce((slotToCompareWith, currentSlot) => {
          if (slotToCompareWith <= slot && slot < currentSlot) {
            return slotToCompareWith;
          } else if (currentSlot >= slot) {
            return currentSlot;
          } else if (slotToCompareWith > currentSlot) {
            return slotToCompareWith;
          }
          return currentSlot;
        });
        return {
          idl: programIdlMap.get(closestSlot),
          slotDeployed: closestSlot
        };
      } else {
        const latestSlot = Math.max(...Array.from(programIdlMap.keys()));
        return {
          idl: programIdlMap.get(latestSlot),
          slotDeployed: latestSlot
        };
      }
    }
  }
  return {
    idl: void 0
  };
};
var addIdlToMap = (idlRepoMap, programId, idl, slot) => {
  const copiedIdlRepoMap = idlRepoMap.size == IdlRepository.size ? new Map(idlRepoMap) : idlRepoMap;
  const programIdlMap = copiedIdlRepoMap.get(programId);
  if (programIdlMap !== void 0 && programIdlMap !== null) {
    programIdlMap.set(slot ?? 0, idl);
    copiedIdlRepoMap.set(programId, programIdlMap);
  } else {
    copiedIdlRepoMap.set(programId, /* @__PURE__ */ new Map([[slot ?? 0, idl]]));
  }
  return copiedIdlRepoMap;
};

// src/idls/IdlRepository.ts
var checkIdlIsAnchor = (idl) => {
  const anchorIdl = idl;
  if (anchorIdl.metadata !== void 0 && anchorIdl.metadata.origin === "shank")
    return false;
  if (anchorIdl.metadata !== void 0 && anchorIdl.metadata.spec)
    return false;
  if (anchorIdl.instructions !== void 0) {
    return anchorIdl.instructions.every((instruction) => {
      if ("discriminant" in instruction) {
        return false;
      }
      return true;
    });
  }
  return false;
};
var checkIdlIsAnchorV1 = (idl) => {
  const anchorIdl = idl;
  if (anchorIdl.metadata && anchorIdl.metadata.spec)
    return true;
  else
    return false;
};
var checkIdlIsShank = (idl) => {
  return idl.instructions !== void 0 && idl.metadata !== void 0;
};
var checkIdlIsString = (idl) => {
  return typeof idl === "string";
};
var getProgramIdl = async (programHash, options, idlRepoMap) => {
  const localIdl = getLocalIdl(programHash, options?.slotContext, idlRepoMap);
  if (localIdl.idl) {
    let idlType = null;
    if (checkIdlIsAnchor(localIdl.idl))
      idlType = "anchor";
    else if (checkIdlIsAnchorV1(localIdl.idl))
      idlType = "anchorV1";
    else if (checkIdlIsShank(localIdl.idl))
      idlType = "shank";
    else if (checkIdlIsString(localIdl.idl))
      idlType = "kinobi";
    if (idlType) {
      return {
        programId: programHash,
        idl: localIdl.idl,
        idlType,
        idlSlotVersion: localIdl.slotDeployed,
        chainId: options?.chainId
      };
    }
  } else if (localIdl.idl === void 0) {
    try {
      const idlInstance = createProgramIdlInstance(options);
      let idlMetaResponse = (await idlInstance.get(`/programs/meta/${programHash}`, {
        params: { slotContext: options?.slotContext }
      })).data.result;
      idlMetaResponse = checkForIdlPatches(idlMetaResponse);
      if (idlMetaResponse.idlInformation) {
        if (idlMetaResponse.idlInformation.idl) {
          if (idlMetaResponse.idlInformation.idlType === "anchor") {
            let idlType = "anchor";
            if (checkIdlIsAnchorV1(idlMetaResponse.idlInformation.idl))
              idlType = "anchorV1";
            return {
              programId: idlMetaResponse.programHash,
              idl: idlMetaResponse.idlInformation.idl,
              idlType,
              idlSlotVersion: idlMetaResponse.idlInformation.slotDeployed,
              chainId: options?.chainId
            };
          } else if (idlMetaResponse.idlInformation.idlType === "shank") {
            return {
              programId: idlMetaResponse.programHash,
              idl: idlMetaResponse.idlInformation.idl,
              idlType: "shank",
              idlSlotVersion: idlMetaResponse.idlInformation.slotDeployed,
              chainId: options?.chainId
            };
          }
          return {
            programId: idlMetaResponse.programHash,
            idl: idlMetaResponse.idlInformation.idl,
            idlType: "anchor",
            idlSlotVersion: idlMetaResponse.idlInformation.slotDeployed,
            chainId: options?.chainId
          };
        }
      }
      return null;
    } catch (error) {
      return null;
    }
  }
  return null;
};
var getMultipleProgramIdls = async (programHashes, options, idlRepoMap) => {
  const promises = programHashes.map((programHash) => getProgramIdl(programHash, options, idlRepoMap));
  const idlsToReturn = [];
  const settledPromises = await Promise.allSettled(promises);
  settledPromises.forEach((settledPromise) => {
    if (settledPromise.status === "fulfilled") {
      const idlItem = settledPromise.value;
      if (idlItem) {
        idlsToReturn.push(idlItem);
      }
    }
  });
  return idlsToReturn;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  IdlRepository,
  addIdlToMap,
  checkForIdlPatches,
  checkIdlIsAnchor,
  checkIdlIsAnchorV1,
  checkIdlIsShank,
  checkIdlIsString,
  getLocalIdl,
  getMultipleProgramIdls,
  getProgramIdl
});
